/* eslint-disable */
var e = function(t, n) {
  return (
    (e =
      Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array &&
        function(e, t) {
          e.__proto__ = t
        }) ||
      function(e, t) {
        for (var n in t)
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n])
      }),
    e(t, n)
  )
}
function t(t, n) {
  if ("function" != typeof n && null !== n)
    throw new TypeError(
      "Class extends value " + String(n) + " is not a constructor or null"
    )
  function i() {
    this.constructor = t
  }
  e(t, n),
    (t.prototype =
      null === n ? Object.create(n) : ((i.prototype = n.prototype), new i()))
}
var n = function() {
  return (
    (n =
      Object.assign ||
      function(e) {
        for (var t, n = 1, i = arguments.length; n < i; n++)
          for (var s in (t = arguments[n]))
            Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s])
        return e
      }),
    n.apply(this, arguments)
  )
}
function i(e, t) {
  var n = {}
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) &&
      t.indexOf(i) < 0 &&
      (n[i] = e[i])
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var s = 0
    for (i = Object.getOwnPropertySymbols(e); s < i.length; s++)
      t.indexOf(i[s]) < 0 &&
        Object.prototype.propertyIsEnumerable.call(e, i[s]) &&
        (n[i[s]] = e[i[s]])
  }
  return n
}
var s,
  a,
  o,
  r,
  l = /*#__PURE__*/ (function() {
    function e() {
      ;(this.nr = 0), (this.keys = 1), (this.subscribers = {})
    }
    return (
      (e.prototype.subscribe = function(e) {
        var t = this.keys++
        return (this.subscribers[t] = e), this.nr++, t
      }),
      (e.prototype.unsubscribe = function(e) {
        this.nr--, delete this.subscribers[e]
      }),
      (e.prototype.next = function(e) {
        var t = this.subscribers
        for (var n in t) t.hasOwnProperty(n) && t[n](e)
      }),
      e
    )
  })(),
  c = [],
  d = !1,
  h = "undefined" != typeof window,
  u =
    h && window.matchMedia && window.matchMedia("(prefers-color-scheme:dark)"),
  _ = h ? navigator.userAgent : "",
  m = h ? navigator.platform : "",
  p = h ? navigator.maxTouchPoints : 0,
  v = _ && _.match(/Android|iPhone|iPad|iPod|Windows Phone|Windows|MSIE/i),
  f = _ && /Safari/.test(_)
;/Android/i.test(v)
  ? ((s = "android"),
    (a = _.match(/Android\s+([\d\.]+)/i)),
    (d = !0),
    a && (c = a[0].replace("Android ", "").split(".")))
  : /iPhone|iPad|iPod/i.test(v) ||
    /iPhone|iPad|iPod/i.test(m) ||
    ("MacIntel" === m && p > 1)
  ? ((s = "ios"),
    (a = _.match(/OS\s+([\d\_]+)/i)),
    (d = !0),
    a &&
      (c = a[0]
        .replace(/_/g, ".")
        .replace("OS ", "")
        .split(".")))
  : /Windows Phone/i.test(v)
  ? ((s = "wp"), (d = !0))
  : /Windows|MSIE/i.test(v) && (s = "windows"),
  (o = +c[0]),
  (r = +c[1])
var g = {},
  y = {},
  b = {},
  D = {},
  C = new l()
function w() {
  var e = "",
    t = "",
    n = ""
  for (var i in ((t =
    "android" === s
      ? "material"
      : "wp" === s || "windows" === s
      ? "windows"
      : "ios"),
  b)) {
    if (b[i].baseTheme === t && !1 !== b[i].auto && i !== t + "-dark") {
      e = i
      break
    }
    i === t ? (e = i) : n || (n = i)
  }
  return e || n
}
function k(e) {
  for (var t in e) e.hasOwnProperty(t) && (g[t] = e[t])
  C.next(g)
}
function x(e, t, i) {
  var s = b[t]
  ;(b[e] = n({}, s, { auto: i, baseTheme: t })), (D.theme = w())
}
var T = { majorVersion: o, minorVersion: r, name: s },
  S =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
  E =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7 14l5-5 5 5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
  M =
    '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M23.12 11.12L21 9l-9 9 9 9 2.12-2.12L16.24 18z"/></svg>',
  L =
    '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M15 9l-2.12 2.12L19.76 18l-6.88 6.88L15 27l9-9z"/></svg>',
  N =
    '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/></svg>',
  H =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/><path fill="none" d="M0 0h24v24H0V0z"/></svg>',
  O =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
  I = {
    clearIcon: N,
    dropdownIcon: S,
    inputStyle: "box",
    labelStyle: "floating",
    notch: !0,
    ripple: !0
  }
;(b.material = {
  Button: { ripple: !0 },
  Calendar: {
    downIcon: S,
    nextIconH: L,
    nextIconV: H,
    prevIconH: M,
    prevIconV: O,
    upIcon: E
  },
  Datepicker: { clearIcon: N, display: "center" },
  Dropdown: I,
  Eventcalendar: {
    chevronIconDown: H,
    colorEventList: !0,
    downIcon: S,
    nextIconH: L,
    nextIconV: H,
    prevIconH: M,
    prevIconV: O,
    upIcon: E
  },
  Input: I,
  ListItem: { ripple: !0 },
  Scroller: { display: "center", rows: 3 },
  Select: { clearIcon: N, rows: 3 },
  Textarea: I
}),
  x("material-dark", "material"),
  (D.theme = w())
var z = q(3),
  P = q(4),
  R = q(7)
function Y(e, t, n) {
  return Math.max(t, Math.min(e, n))
}
function U(e) {
  return Array.isArray(e)
}
function A(e) {
  return e - parseFloat(e) >= 0
}
function W(e) {
  return "number" == typeof e
}
function F(e) {
  return "string" == typeof e
}
function V(e) {
  return null == e || "" === e
}
function B(e) {
  return void 0 === e
}
function X(e) {
  return "object" == typeof e
}
function q(e) {
  return Array.apply(0, Array(Math.max(0, e)))
}
function j(e) {
  return undefined !== e ? e + (A(e) ? "px" : "") : ""
}
function G() {}
function K(e, t) {
  void 0 === t && (t = 2)
  for (var n = e + ""; n.length < t; ) n = "0" + e
  return n
}
function J(e) {
  return Math.round(e)
}
function $(e) {
  return Math.floor(e)
}
function Z(e, t) {
  var n, i
  return (
    void 0 === t && (t = 100),
    function() {
      for (var s = [], a = 0; a < arguments.length; a++) s[a] = arguments[a]
      var o = +new Date()
      n && o < n + t
        ? (clearTimeout(i),
          (i = setTimeout(function() {
            ;(n = o), e.apply(void 0, s)
          }, t)))
        : ((n = o), e.apply(void 0, s))
    }
  )
}
function Q(e, t) {
  var n
  return (
    void 0 === t && (t = 100),
    function() {
      for (var i = [], s = 0; s < arguments.length; s++) i[s] = arguments[s]
      clearTimeout(n),
        (n = setTimeout(function() {
          e.apply(void 0, i)
        }, t))
    }
  )
}
function ee(e, t) {
  return (function(e, t, n) {
    for (var i = e.length, s = 0; s < i; s++) {
      var a = e[s]
      if (t(a, s)) return n ? s : a
    }
    return n ? -1 : undefined
  })(e, t)
}
q(24)
var te = h ? document : undefined,
  ne = h ? window : undefined,
  ie = ["Webkit", "Moz"],
  se = te && te.createElement("div").style,
  ae = te && te.createElement("canvas"),
  oe = ae && ae.getContext("2d"),
  re = ne && ne.CSS,
  le = re && re.supports,
  ce = {},
  de =
    (ne && ne.requestAnimationFrame) ||
    function(e) {
      return setTimeout(e, 20)
    },
  he =
    (ne && ne.cancelAnimationFrame) ||
    function(e) {
      clearTimeout(e)
    },
  ue = se && undefined !== se.animationName,
  _e = "ios" === s && !f,
  me = _e && ne && ne.webkit && ne.webkit.messageHandlers,
  pe = (se && undefined === se.touchAction) || (_e && !me),
  ve = (function() {
    if (!se || undefined !== se.transform) return ""
    for (var e = 0, t = ie; e < t.length; e++) {
      var n = t[e]
      if (undefined !== se[n + "Transform"]) return n
    }
    return ""
  })(),
  fe = ve ? "-" + ve.toLowerCase() + "-" : ""
le && le("(transform-style: preserve-3d)")
var ge = le && (le("position", "sticky") || le("position", "-webkit-sticky"))
function ye(e, t, n, i) {
  e && e.addEventListener(t, n, i)
}
function be(e, t, n, i) {
  e && e.removeEventListener(t, n, i)
}
function De(e) {
  if (h) return e && e.ownerDocument ? e.ownerDocument : te
}
function Ce(e, t) {
  return parseFloat(getComputedStyle(e)[t] || "0")
}
function we(e) {
  return undefined !== e.scrollLeft ? e.scrollLeft : e.pageXOffset
}
function ke(e) {
  return undefined !== e.scrollTop ? e.scrollTop : e.pageYOffset
}
function xe(e) {
  if (h)
    return e && e.ownerDocument && e.ownerDocument.defaultView
      ? e.ownerDocument.defaultView
      : ne
}
function Te(e, t) {
  var n = getComputedStyle(e),
    i = (ve ? n[ve + "Transform"] : n.transform).split(")")[0].split(", ")
  return +(t ? i[13] || i[5] : i[12] || i[4]) || 0
}
function Se(e) {
  if (ce[e]) return ce[e]
  if (!oe) return "#fff"
  ;(oe.fillStyle = e), oe.fillRect(0, 0, 1, 1)
  var t = oe.getImageData(0, 0, 1, 1).data,
    n = 0.299 * +t[0] + 0.587 * +t[1] + 0.114 * +t[2] < 130 ? "#fff" : "#000"
  return (ce[e] = n), n
}
function Ee(e, t, n, i, s, a) {
  var o = Math.min(1, (+new Date() - t) / 468),
    r = 0.5 * (1 - Math.cos(Math.PI * o)),
    l = J(n + (i - n) * r)
  s ? (e.scrollLeft = l) : (e.scrollTop = l),
    l !== i
      ? de(function() {
          Ee(e, t, n, i, s, a)
        })
      : a && a()
}
function Me(e, t, n, i, s, a) {
  ;(t = Math.max(0, J(t))),
    s && i && (t = -t),
    n
      ? Ee(e, +new Date(), i ? e.scrollLeft : e.scrollTop, t, i, a)
      : (i ? (e.scrollLeft = t) : (e.scrollTop = t), a && a())
}
function Le(e) {
  if (te && e) {
    var t = te.createElement("div")
    return (t.innerHTML = e), t.textContent.trim()
  }
  return e || ""
}
function Ne(e) {
  var t = e.getBoundingClientRect(),
    n = { left: t.left, top: t.top },
    i = xe(e)
  return undefined !== i && ((n.top += ke(i)), (n.left += we(i))), n
}
function He(e, t) {
  var n = e && (e.matches || e.msMatchesSelector)
  return n && n.call(e, t)
}
function Oe(e, t) {
  for (var n = 0; n < e.length; n++) t(e[n], n)
}
var Ie = {},
  ze = [],
  Pe = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i
function Re(e, t) {
  for (var n in t) e[n] = t[n]
  return e
}
function Ye(e) {
  var t = e.parentNode
  t && t.removeChild(e)
}
var Ue = {
  _catchError: function(e, t) {
    for (var n, i, s; (t = t._parent); )
      if ((n = t._component) && !n._processingException)
        try {
          if (
            ((i = n.constructor) &&
              null != i.getDerivedStateFromError &&
              (n.setState(i.getDerivedStateFromError(e)), (s = n._dirty)),
            null != n.componentDidCatch &&
              (n.componentDidCatch(e), (s = n._dirty)),
            s)
          )
            return (n._pendingError = n)
        } catch (t) {
          e = t
        }
    throw e
  },
  _vnodeId: 0
}
function Ae(e, t, n) {
  var i,
    s,
    a,
    o = {}
  for (a in t) "key" == a ? (i = t[a]) : "ref" == a ? (s = t[a]) : (o[a] = t[a])
  if (arguments.length > 3)
    for (n = [n], a = 3; a < arguments.length; a++) n.push(arguments[a])
  if (
    (null != n && (o.children = n),
    "function" == typeof e && null != e.defaultProps)
  )
    for (a in e.defaultProps) void 0 === o[a] && (o[a] = e.defaultProps[a])
  return We(e, o, i, s, null)
}
function We(e, t, n, i, s) {
  var a = {
    type: e,
    props: t,
    key: n,
    ref: i,
    _children: null,
    _parent: null,
    _depth: 0,
    _dom: null,
    _nextDom: void 0,
    _component: null,
    _hydrating: null,
    constructor: void 0,
    _original: null == s ? ++Ue._vnodeId : s
  }
  return null != Ue.vnode && Ue.vnode(a), a
}
function Fe(e) {
  return e.children
}
function Ve(e, t) {
  ;(this.props = e), (this.context = t)
}
function Be(e, t) {
  if (null == t)
    return e._parent ? Be(e._parent, e._parent._children.indexOf(e) + 1) : null
  for (var n; t < e._children.length; t++)
    if (null != (n = e._children[t]) && null != n._dom) return n._dom
  return "function" == typeof e.type ? Be(e) : null
}
function Xe(e) {
  var t = e._vnode,
    n = t._dom,
    i = e._parentDom
  if (i) {
    var s = [],
      a = Re({}, t)
    ;(a._original = t._original + 1),
      at(
        i,
        t,
        a,
        e._globalContext,
        void 0 !== i.ownerSVGElement,
        null != t._hydrating ? [n] : null,
        s,
        null == n ? Be(t) : n,
        t._hydrating
      ),
      ot(s, t),
      t._dom != n && qe(t)
  }
}
function qe(e) {
  if (null != (e = e._parent) && null != e._component) {
    e._dom = e._component.base = null
    for (var t = 0; t < e._children.length; t++) {
      var n = e._children[t]
      if (null != n && null != n._dom) {
        e._dom = e._component.base = n._dom
        break
      }
    }
    return qe(e)
  }
}
;(Ve.prototype.setState = function(e, t) {
  var n
  ;(n =
    null != this._nextState && this._nextState !== this.state
      ? this._nextState
      : (this._nextState = Re({}, this.state))),
    "function" == typeof e && (e = e(Re({}, n), this.props)),
    e && Re(n, e),
    null != e && this._vnode && (t && this._renderCallbacks.push(t), Je(this))
}),
  (Ve.prototype.forceUpdate = function(e) {
    this._vnode &&
      ((this._force = !0), e && this._renderCallbacks.push(e), Je(this))
  }),
  (Ve.prototype.render = Fe)
var je,
  Ge = [],
  Ke =
    "function" == typeof Promise
      ? Promise.prototype.then.bind(Promise.resolve())
      : setTimeout
function Je(e) {
  ;((!e._dirty && (e._dirty = !0) && Ge.push(e) && !$e._rerenderCount++) ||
    je !== Ue.debounceRendering) &&
    ((je = Ue.debounceRendering) || Ke)($e)
}
function $e() {
  for (var e; ($e._rerenderCount = Ge.length); )
    (e = Ge.sort(function(e, t) {
      return e._vnode._depth - t._vnode._depth
    })),
      (Ge = []),
      e.some(function(e) {
        e._dirty && Xe(e)
      })
}
function Ze(e, t, n, i, s, a, o, r, l, c) {
  var d,
    h,
    u,
    _,
    m,
    p,
    v,
    f = (i && i._children) || ze,
    g = f.length
  for (n._children = [], d = 0; d < t.length; d++)
    if (
      null !=
      (_ =
        null == (_ = t[d]) || "boolean" == typeof _
          ? (n._children[d] = null)
          : "string" == typeof _ || "number" == typeof _ || "bigint" == typeof _
          ? (n._children[d] = We(null, _, null, null, _))
          : Array.isArray(_)
          ? (n._children[d] = We(Fe, { children: _ }, null, null, null))
          : _._depth > 0
          ? (n._children[d] = We(_.type, _.props, _.key, null, _._original))
          : (n._children[d] = _))
    ) {
      if (
        ((_._parent = n),
        (_._depth = n._depth + 1),
        null === (u = f[d]) || (u && _.key == u.key && _.type === u.type))
      )
        f[d] = void 0
      else
        for (h = 0; h < g; h++) {
          if ((u = f[h]) && _.key == u.key && _.type === u.type) {
            f[h] = void 0
            break
          }
          u = null
        }
      at(e, _, (u = u || Ie), s, a, o, r, l, c),
        (m = _._dom),
        (h = _.ref) &&
          u.ref != h &&
          (v || (v = []),
          u.ref && v.push(u.ref, null, _),
          v.push(h, _._component || m, _)),
        null != m
          ? (null == p && (p = m),
            "function" == typeof _.type &&
            null != _._children &&
            _._children === u._children
              ? (_._nextDom = l = Qe(_, l, e))
              : (l = et(e, _, u, f, m, l)),
            c || "option" !== n.type
              ? "function" == typeof n.type && (n._nextDom = l)
              : (e.value = ""))
          : l && u._dom == l && l.parentNode != e && (l = Be(u))
    }
  for (n._dom = p, d = g; d--; )
    null != f[d] &&
      ("function" == typeof n.type &&
        null != f[d]._dom &&
        f[d]._dom == n._nextDom &&
        (n._nextDom = Be(i, d + 1)),
      lt(f[d], f[d]))
  if (v) for (d = 0; d < v.length; d++) rt(v[d], v[++d], v[++d])
}
function Qe(e, t, n) {
  for (var i = 0; i < e._children.length; i++) {
    var s = e._children[i]
    s &&
      ((s._parent = e),
      (t =
        "function" == typeof s.type
          ? Qe(s, t, n)
          : et(n, s, s, e._children, s._dom, t)))
  }
  return t
}
function et(e, t, n, i, s, a) {
  var o
  if (void 0 !== t._nextDom) (o = t._nextDom), (t._nextDom = void 0)
  else if (null == n || s != a || null == s.parentNode)
    e: if (null == a || a.parentNode !== e) e.appendChild(s), (o = null)
    else {
      for (var r = a, l = 0; (r = r.nextSibling) && l < i.length; l += 2)
        if (r == s) break e
      e.insertBefore(s, a), (o = a)
    }
  return (a = void 0 !== o ? o : s.nextSibling)
}
function tt(e, t, n) {
  "-" === t[0]
    ? e.setProperty(t, n)
    : null == n
    ? (e[t] = "")
    : "number" != typeof n || Pe.test(t)
    ? (e[t] = n)
    : (e[t] = n + "px")
}
function nt(e, t, n, i, s) {
  var a
  e: if ("style" === t)
    if ("string" == typeof n) e.style.cssText = n
    else {
      if (("string" == typeof i && (e.style.cssText = i = ""), i))
        for (t in i) (n && t in n) || tt(e.style, t, "")
      if (n) for (t in n) (i && n[t] === i[t]) || tt(e.style, t, n[t])
    }
  else if ("o" === t[0] && "n" === t[1])
    if (
      ((a = t !== (t = t.replace(/Capture$/, ""))),
      (t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2)),
      e._listeners || (e._listeners = {}),
      (e._listeners[t + a] = n),
      n)
    ) {
      if (!i) {
        var o = a ? st : it
        e.addEventListener(t, o, a)
      }
    } else {
      var r = a ? st : it
      e.removeEventListener(t, r, a)
    }
  else if ("dangerouslySetInnerHTML" !== t) {
    if (s) t = t.replace(/xlink[H:h]/, "h").replace(/sName$/, "s")
    else if (
      "href" !== t &&
      "list" !== t &&
      "form" !== t &&
      "tabIndex" !== t &&
      "download" !== t &&
      t in e
    )
      try {
        e[t] = null == n ? "" : n
        break e
      } catch (e) {}
    "function" == typeof n ||
      (null != n && (!1 !== n || ("a" === t[0] && "r" === t[1]))
        ? e.setAttribute(t, n)
        : e.removeAttribute(t))
  }
}
function it(e) {
  this._listeners[e.type + !1](Ue.event ? Ue.event(e) : e)
}
function st(e) {
  this._listeners[e.type + !0](Ue.event ? Ue.event(e) : e)
}
function at(e, t, n, i, s, a, o, r, l) {
  var c,
    d = t.type
  if (void 0 !== t.constructor) return null
  null != n._hydrating &&
    ((l = n._hydrating),
    (r = t._dom = n._dom),
    (t._hydrating = null),
    (a = [r])),
    (c = Ue._diff) && c(t)
  try {
    e: if ("function" == typeof d) {
      var h,
        u,
        _,
        m,
        p,
        v,
        f = t.props,
        g = (c = d.contextType) && i[c._id],
        y = c ? (g ? g.props.value : c._defaultValue) : i
      if (
        (n._component
          ? (v = (h = t._component = n._component)._processingException =
              h._pendingError)
          : ("prototype" in d && d.prototype.render
              ? (t._component = h = new d(f, y))
              : ((t._component = h = new Ve(f, y)),
                (h.constructor = d),
                (h.render = ct)),
            g && g.sub(h),
            (h.props = f),
            h.state || (h.state = {}),
            (h.context = y),
            (h._globalContext = i),
            (u = h._dirty = !0),
            (h._renderCallbacks = [])),
        null == h._nextState && (h._nextState = h.state),
        null != d.getDerivedStateFromProps &&
          (h._nextState == h.state && (h._nextState = Re({}, h._nextState)),
          Re(h._nextState, d.getDerivedStateFromProps(f, h._nextState))),
        (_ = h.props),
        (m = h.state),
        u)
      )
        null == d.getDerivedStateFromProps &&
          null != h.componentWillMount &&
          h.componentWillMount(),
          null != h.componentDidMount &&
            h._renderCallbacks.push(h.componentDidMount)
      else {
        if (
          (null == d.getDerivedStateFromProps &&
            f !== _ &&
            null != h.componentWillReceiveProps &&
            h.componentWillReceiveProps(f, y),
          (!h._force &&
            null != h.shouldComponentUpdate &&
            !1 === h.shouldComponentUpdate(f, h._nextState, y)) ||
            t._original === n._original)
        ) {
          ;(h.props = f),
            (h.state = h._nextState),
            t._original !== n._original && (h._dirty = !1),
            (h._vnode = t),
            (t._dom = n._dom),
            (t._children = n._children),
            t._children.forEach(function(e) {
              e && (e._parent = t)
            }),
            h._renderCallbacks.length && o.push(h)
          break e
        }
        null != h.componentWillUpdate &&
          h.componentWillUpdate(f, h._nextState, y),
          null != h.componentDidUpdate &&
            h._renderCallbacks.push(function() {
              h.componentDidUpdate(_, m, p)
            })
      }
      ;(h.context = y),
        (h.props = f),
        (h.state = h._nextState),
        (c = Ue._render) && c(t),
        (h._dirty = !1),
        (h._vnode = t),
        (h._parentDom = e),
        (c = h.render(h.props, h.state, h.context)),
        (h.state = h._nextState),
        null != h.getChildContext && (i = Re(Re({}, i), h.getChildContext())),
        u ||
          null == h.getSnapshotBeforeUpdate ||
          (p = h.getSnapshotBeforeUpdate(_, m))
      var b = null != c && c.type === Fe && null == c.key ? c.props.children : c
      Ze(e, Array.isArray(b) ? b : [b], t, n, i, s, a, o, r, l),
        (h.base = t._dom),
        (t._hydrating = null),
        h._renderCallbacks.length && o.push(h),
        v && (h._pendingError = h._processingException = null),
        (h._force = !1)
    } else
      null == a && t._original === n._original
        ? ((t._children = n._children), (t._dom = n._dom))
        : (t._dom = (function(e, t, n, i, s, a, o, r) {
            var l = n.props,
              c = t.props,
              d = t.type,
              h = 0
            "svg" === d && (s = !0)
            if (null != a)
              for (; h < a.length; h++) {
                var u = a[h]
                if (
                  u &&
                  (u === e || (d ? u.localName == d : 3 == u.nodeType))
                ) {
                  ;(e = u), (a[h] = null)
                  break
                }
              }
            if (null == e) {
              if (null === d) return document.createTextNode(c)
              ;(e = s
                ? document.createElementNS("http://www.w3.org/2000/svg", d)
                : document.createElement(d, c.is && c)),
                (a = null),
                (r = !1)
            }
            if (null === d) l === c || (r && e.data === c) || (e.data = c)
            else {
              a = a && ze.slice.call(e.childNodes)
              var _ = (l = n.props || Ie).dangerouslySetInnerHTML,
                m = c.dangerouslySetInnerHTML
              if (
                (r ||
                  (null != a && (l = {}),
                  (m || _) &&
                    ((m &&
                      ((_ && m.__html == _.__html) ||
                        m.__html === e.innerHTML)) ||
                      (e.innerHTML = (m && m.__html) || ""))),
                (function(e, t, n, i, s) {
                  var a
                  for (a in n)
                    "children" === a ||
                      "key" === a ||
                      a in t ||
                      nt(e, a, null, n[a], i)
                  for (a in t)
                    (s && "function" != typeof t[a]) ||
                      "children" === a ||
                      "key" === a ||
                      "value" === a ||
                      "checked" === a ||
                      n[a] === t[a] ||
                      nt(e, a, t[a], n[a], i)
                })(e, c, l, s, r),
                m)
              )
                t._children = []
              else if (
                ((h = t.props.children),
                Ze(
                  e,
                  Array.isArray(h) ? h : [h],
                  t,
                  n,
                  i,
                  s && "foreignObject" !== d,
                  a,
                  o,
                  e.firstChild,
                  r
                ),
                null != a)
              )
                for (h = a.length; h--; ) null != a[h] && Ye(a[h])
              r ||
                ("value" in c &&
                  void 0 !== (h = c.value) &&
                  (h !== e.value || ("progress" === d && !h)) &&
                  nt(e, "value", h, l.value, !1),
                "checked" in c &&
                  void 0 !== (h = c.checked) &&
                  h !== e.checked &&
                  nt(e, "checked", h, l.checked, !1))
            }
            return e
          })(n._dom, t, n, i, s, a, o, l))
    ;(c = Ue.diffed) && c(t)
  } catch (e) {
    ;(t._original = null),
      (l || null != a) &&
        ((t._dom = r), (t._hydrating = !!l), (a[a.indexOf(r)] = null)),
      Ue._catchError(e, t, n)
  }
}
function ot(e, t) {
  Ue._commit && Ue._commit(t, e),
    e.some(function(t) {
      try {
        ;(e = t._renderCallbacks),
          (t._renderCallbacks = []),
          e.some(function(e) {
            e.call(t)
          })
      } catch (e) {
        Ue._catchError(e, t._vnode)
      }
    })
}
function rt(e, t, n) {
  try {
    "function" == typeof e ? e(t) : (e.current = t)
  } catch (e) {
    Ue._catchError(e, n)
  }
}
function lt(e, t, n) {
  var i, s
  if (
    (Ue.unmount && Ue.unmount(e),
    (i = e.ref) && ((i.current && i.current !== e._dom) || rt(i, null, t)),
    n || "function" == typeof e.type || (n = null != (s = e._dom)),
    (e._dom = e._nextDom = void 0),
    null != (i = e._component))
  ) {
    if (i.componentWillUnmount)
      try {
        i.componentWillUnmount()
      } catch (e) {
        Ue._catchError(e, t)
      }
    i.base = i._parentDom = null
  }
  if ((i = e._children))
    for (var a = 0; a < i.length; a++) i[a] && lt(i[a], t, n)
  null != s && Ye(s)
}
function ct(e, t, n) {
  return this.constructor(e, n)
}
function dt(e, t, n) {
  Ue._root && Ue._root(e, t)
  var i = "function" == typeof n,
    s = i ? null : (n && n._children) || t._children,
    a = []
  at(
    t,
    (e = ((!i && n) || t)._children = Ae(Fe, null, [e])),
    s || Ie,
    Ie,
    void 0 !== t.ownerSVGElement,
    !i && n
      ? [n]
      : s
      ? null
      : t.firstChild
      ? ze.slice.call(t.childNodes)
      : null,
    a,
    !i && n ? n : s ? s._dom : t.firstChild,
    i
  ),
    ot(a, e)
}
$e._rerenderCount = 0
var ht = 0
var ut = /*#__PURE__*/ (function(e) {
  function n() {
    return (null !== e && e.apply(this, arguments)) || this
  }
  return (
    t(n, e),
    (n.prototype.render = function() {}),
    (n.prototype.shouldComponentUpdate = function(e, t) {
      return _t(e, this.props) || _t(t, this.state)
    }),
    n
  )
})(Ve)
function _t(e, t) {
  for (var n in e) if (e[n] !== t[n]) return !0
  for (var n in t) if (!(n in e)) return !0
  return !1
}
var mt = Ae
Ue.vnode = function(e) {
  var t = e.props,
    n = {}
  if (F(e.type)) {
    for (var i in t) {
      var s = t[i]
      ;/^onAni/.test(i)
        ? (i = i.toLowerCase())
        : /ondoubleclick/i.test(i) && (i = "ondblclick"),
        (n[i] = s)
    }
    e.props = n
  }
}
var pt = {},
  vt = 0
function ft(e, t, n, i, s) {
  He(e, t)
    ? e.__mbscFormInst || gt(n, e, s, i, !0)
    : Oe(e.querySelectorAll(t), function(e) {
        e.__mbscFormInst || gt(n, e, s, i, !0)
      })
}
function gt(e, t, i, s, a) {
  var o,
    r,
    l = [],
    c = [],
    d = {},
    h = s || {},
    u = h.renderToParent ? t.parentNode : t,
    _ = u.parentNode,
    m = h.useOwnChildren ? t : u,
    p = t.getAttribute("class"),
    v = t.value,
    f = n({ className: u.getAttribute("class") }, t.dataset, i, {
      ref: function(e) {
        r = e
      }
    })
  h.readProps &&
    h.readProps.forEach(function(e) {
      var n = t[e]
      undefined !== n && (f[e] = n)
    }),
    h.readAttrs &&
      h.readAttrs.forEach(function(e) {
        var n = t.getAttribute(e)
        null !== n && (f[e] = n)
      })
  var g = h.slots
  if (g)
    for (var y in g)
      if (g.hasOwnProperty(y)) {
        var b = g[y],
          D = u.querySelector("[mbsc-" + b + "]")
        D &&
          ((d[y] = D),
          D.parentNode.removeChild(D),
          (f[y] = mt("span", { className: "mbsc-slot-" + b })))
      }
  if (
    (h.hasChildren &&
      (Oe(m.childNodes, function(e) {
        e !== t &&
          8 !== e.nodeType &&
          (3 !== e.nodeType || (3 === e.nodeType && /\S/.test(e.nodeValue))) &&
          l.push(e),
          c.push(e)
      }),
      Oe(l, function(e) {
        m.removeChild(e)
      }),
      l.length && (f.hasChildren = !0)),
    t.id || (t.id = "mbsc-control-" + vt++),
    h.before && h.before(t, f, l),
    dt(mt(e, f), _, u),
    p &&
      h.renderToParent &&
      (o = t.classList).add.apply(
        o,
        p
          .replace(/^\s+|\s+$/g, "")
          .replace(/\s+|^\s|\s$/g, " ")
          .split(" ")
      ),
    h.hasChildren)
  ) {
    var C = "." + h.parentClass,
      w = He(u, C) ? u : u.querySelector(C)
    w &&
      Oe(l, function(e) {
        w.appendChild(e)
      })
  }
  if ((h.hasValue && (t.value = v), g)) {
    var k = function(e) {
      if (d.hasOwnProperty(e)) {
        var t = g[e],
          n = d[e]
        Oe(u.querySelectorAll(".mbsc-slot-" + t), function(e, t) {
          var i = t > 0 ? n.cloneNode(!0) : n
          e.appendChild(i)
        })
      }
    }
    for (var y in d) k(y)
  }
  return (
    (r.destroy = function() {
      var e = u.parentNode,
        n = te.createComment("")
      e.insertBefore(n, u),
        dt(null, u),
        delete t.__mbscInst,
        delete t.__mbscFormInst,
        (u.innerHTML = ""),
        u.setAttribute("class", f.className),
        e.replaceChild(u, n),
        h.hasChildren &&
          Oe(c, function(e) {
            m.appendChild(e)
          }),
        h.renderToParent && t.setAttribute("class", p)
    }),
    a
      ? (t.__mbscInst || (t.__mbscInst = r), (t.__mbscFormInst = r))
      : (t.__mbscInst = r),
    r
  )
}
function yt(e, t) {
  return t ? e.__mbscFormInst : e.__mbscInst
}
function bt(e) {
  pt[e._name] = e
}
function Dt(e, t) {
  if (e)
    for (var n in pt)
      if (pt.hasOwnProperty(n)) {
        var i = pt[n]
        ft(e, i._selector, i, i._renderOpt, t)
      }
}
function Ct(e, t) {
  return function(n, i) {
    var s = {}
    if (F(n)) {
      var a,
        o = te.querySelectorAll(n)
      return (
        Oe(o, function(n) {
          var o = gt(e, n, i, t)
          ;(s[n.id] = o), a || (a = o)
        }),
        1 === o.length ? a : s
      )
    }
    return gt(e, n, i, t)
  }
}
function wt(e) {
  return e < -1e-7 ? Math.ceil(e - 1e-7) : Math.floor(e + 1e-7)
}
function kt(e, t, n) {
  var i,
    s,
    a,
    o,
    r = new Array(0, 0, 0)
  return (
    (i =
      e > 1582 || (1582 === e && t > 10) || (1582 === e && 10 === t && n > 14)
        ? wt((1461 * (e + 4800 + wt((t - 14) / 12))) / 4) +
          wt((367 * (t - 2 - 12 * wt((t - 14) / 12))) / 12) -
          wt((3 * wt((e + 4900 + wt((t - 14) / 12)) / 100)) / 4) +
          n -
          32075
        : 367 * e -
          wt((7 * (e + 5001 + wt((t - 9) / 7))) / 4) +
          wt((275 * t) / 9) +
          n +
          1729777),
    (o = wt(((s = i - 1948440 + 10632) - 1) / 10631)),
    (a =
      wt((10985 - (s = s - 10631 * o + 354)) / 5316) * wt((50 * s) / 17719) +
      wt(s / 5670) * wt((43 * s) / 15238)),
    (s =
      s -
      wt((30 - a) / 15) * wt((17719 * a) / 50) -
      wt(a / 16) * wt((15238 * a) / 43) +
      29),
    (t = wt((24 * s) / 709)),
    (n = s - wt((709 * t) / 24)),
    (e = 30 * o + a - 30),
    (r[2] = n),
    (r[1] = t),
    (r[0] = e),
    r
  )
}
h &&
  (te.addEventListener("DOMContentLoaded", function() {
    Dt(te)
  }),
  te.addEventListener("mbsc-enhance", function(e) {
    Dt(e.target)
  }))
var xt = {
    getYear: function(e) {
      return kt(e.getFullYear(), e.getMonth() + 1, e.getDate())[0]
    },
    getMonth: function(e) {
      return --kt(e.getFullYear(), e.getMonth() + 1, e.getDate())[1]
    },
    getDay: function(e) {
      return kt(e.getFullYear(), e.getMonth() + 1, e.getDate())[2]
    },
    getDate: function(e, t, n, i, s, a, o) {
      t < 0 && ((e += Math.floor(t / 12)), (t = t % 12 ? 12 + (t % 12) : 0)),
        t > 11 && ((e += Math.floor(t / 12)), (t %= 12))
      var r = (function(e, t, n) {
        var i,
          s,
          a,
          o,
          r,
          l = new Array(3),
          c =
            wt((11 * e + 3) / 30) +
            354 * e +
            30 * t -
            wt((t - 1) / 2) +
            n +
            1948440 -
            385
        return (
          c > 2299160
            ? ((a = wt((4 * (i = c + 68569)) / 146097)),
              (i -= wt((146097 * a + 3) / 4)),
              (o = wt((4e3 * (i + 1)) / 1461001)),
              (i = i - wt((1461 * o) / 4) + 31),
              (s = wt((80 * i) / 2447)),
              (n = i - wt((2447 * s) / 80)),
              (t = s + 2 - 12 * (i = wt(s / 11))),
              (e = 100 * (a - 49) + o + i))
            : ((r = wt(((s = c + 1402) - 1) / 1461)),
              (a = wt(((i = s - 1461 * r) - 1) / 365) - wt(i / 1461)),
              (s = wt((80 * (o = i - 365 * a + 30)) / 2447)),
              (n = o - wt((2447 * s) / 80)),
              (t = s + 2 - 12 * (o = wt(s / 11))),
              (e = 4 * r + a + o - 4716)),
          (l[2] = n),
          (l[1] = t),
          (l[0] = e),
          l
        )
      })(e, +t + 1, n)
      return new Date(r[0], r[1] - 1, r[2], i || 0, s || 0, a || 0, o || 0)
    },
    getMaxDayOfMonth: function(e, t) {
      t < 0 && ((e += Math.floor(t / 12)), (t = t % 12 ? 12 + (t % 12) : 0)),
        t > 11 && ((e += Math.floor(t / 12)), (t %= 12))
      return (
        [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29][t] +
        (11 === t && (11 * e + 14) % 30 < 11 ? 1 : 0)
      )
    }
  },
  Tt = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  St = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29]
function Et(e, t, n) {
  var i,
    s = e - 1600,
    a = t - 1,
    o = n - 1,
    r = 365 * s + $((s + 3) / 4) - $((s + 99) / 100) + $((s + 399) / 400)
  for (i = 0; i < a; ++i) r += Tt[i]
  a > 1 && ((s % 4 == 0 && s % 100 != 0) || s % 400 == 0) && ++r
  var l = (r += o) - 79,
    c = 979 + 33 * $(l / 12053) + 4 * $((l %= 12053) / 1461)
  for (
    (l %= 1461) >= 366 && ((c += $((l - 1) / 365)), (l = (l - 1) % 365)), i = 0;
    i < 11 && l >= St[i];
    ++i
  )
    l -= St[i]
  return [c, i + 1, l + 1]
}
var Mt,
  Lt = {
    getYear: function(e) {
      return Et(e.getFullYear(), e.getMonth() + 1, e.getDate())[0]
    },
    getMonth: function(e) {
      return --Et(e.getFullYear(), e.getMonth() + 1, e.getDate())[1]
    },
    getDay: function(e) {
      return Et(e.getFullYear(), e.getMonth() + 1, e.getDate())[2]
    },
    getDate: function(e, t, n, i, s, a, o) {
      t < 0 && ((e += $(t / 12)), (t = t % 12 ? 12 + (t % 12) : 0)),
        t > 11 && ((e += $(t / 12)), (t %= 12))
      var r = (function(e, t, n) {
        var i,
          s = e - 979,
          a = t - 1,
          o = n - 1,
          r = 365 * s + 8 * $(s / 33) + $(((s % 33) + 3) / 4)
        for (i = 0; i < a; ++i) r += St[i]
        var l = (r += o) + 79,
          c = 1600 + 400 * $(l / 146097),
          d = !0
        for (
          (l %= 146097) >= 36525 &&
            ((c += 100 * $(--l / 36524)), (l %= 36524) >= 365 ? l++ : (d = !1)),
            c += 4 * $(l / 1461),
            (l %= 1461) >= 366 && ((d = !1), (c += $(--l / 365)), (l %= 365)),
            i = 0;
          l >= Tt[i] + (1 === i && d ? 1 : 0);
          i++
        )
          l -= Tt[i] + (1 === i && d ? 1 : 0)
        return [c, i + 1, l + 1]
      })(e, +t + 1, n)
      return new Date(r[0], r[1] - 1, r[2], i || 0, s || 0, a || 0, o || 0)
    },
    getMaxDayOfMonth: function(e, t) {
      var n,
        i,
        s,
        a = 31
      for (
        t < 0 && ((e += $(t / 12)), (t = t % 12 ? 12 + (t % 12) : 0)),
          t > 11 && ((e += $(t / 12)), (t %= 12));
        !1 ==
        ((i = t + 1),
        (s = a),
        !(
          (n = e) < 0 ||
          n > 32767 ||
          i < 1 ||
          i > 12 ||
          s < 1 ||
          s > St[i - 1] + (12 === i && ((n - 979) % 33) % 4 == 0 ? 1 : 0)
        ));

      )
        a--
      return a
    }
  },
  Nt = {},
  Ht = { en: Nt },
  Ot = /*#__PURE__*/ (function(e) {
    function n() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t._newProps = {}),
        (t._setEl = function(e) {
          t._el = e ? e._el || e : null
        }),
        t
      )
    }
    return (
      t(n, e),
      Object.defineProperty(n.prototype, "value", {
        get: function() {
          return this.__value
        },
        set: function(e) {
          this.__value = e
        },
        enumerable: !0,
        configurable: !0
      }),
      (n.prototype.componentDidMount = function() {
        this.__init(),
          this._init(),
          this._mounted(),
          this._updated(),
          this._enhance()
      }),
      (n.prototype.componentDidUpdate = function() {
        this._updated(), this._enhance()
      }),
      (n.prototype.componentWillUnmount = function() {
        this._destroy(), this.__destroy()
      }),
      (n.prototype.render = function() {
        return this._willUpdate(), this._template(this.s, this.state)
      }),
      (n.prototype.getInst = function() {
        return this
      }),
      (n.prototype.setOptions = function(e) {
        for (var t in e) this.props[t] = e[t]
        this.forceUpdate()
      }),
      (n.prototype._safeHtml = function(e) {
        return { __html: e }
      }),
      (n.prototype._init = function() {}),
      (n.prototype.__init = function() {}),
      (n.prototype._emit = function(e, t) {}),
      (n.prototype._template = function(e, t) {}),
      (n.prototype._mounted = function() {}),
      (n.prototype._updated = function() {}),
      (n.prototype._destroy = function() {}),
      (n.prototype.__destroy = function() {}),
      (n.prototype._willUpdate = function() {}),
      (n.prototype._enhance = function() {
        var e = this._shouldEnhance
        e && (Dt(!0 === e ? this._el : e), (this._shouldEnhance = !1))
      }),
      n
    )
  })(ut),
  It = 0,
  zt = { large: 992, medium: 768, small: 576, xlarge: 1200, xsmall: 0 }
u &&
  ((Mt = u.matches),
  u.addListener(function(e) {
    ;(Mt = e.matches), C.next()
  }))
var Pt,
  Rt,
  Yt = /*#__PURE__*/ (function(e) {
    function i() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t.s = {}),
        (t.state = {}),
        (t._mbsc = !0),
        (t._v = { version: "5.14.1" }),
        (t._uid = ++It),
        t
      )
    }
    return (
      t(i, e),
      Object.defineProperty(i.prototype, "nativeElement", {
        get: function() {
          return this._el
        },
        enumerable: !0,
        configurable: !0
      }),
      (i.prototype.destroy = function() {}),
      (i.prototype._hook = function(e, t) {
        var n = this.s
        if (((t.inst = this), (t.type = e), this._emit(e, t), n[e]))
          return n[e](t, this)
      }),
      (i.prototype.__init = function() {
        var e = this
        if (this.constructor.defaults) {
          this._optChange = C.subscribe(function() {
            e.forceUpdate()
          })
          var t = this.props.modules
          if (t)
            for (var n = 0, i = t; n < i.length; n++) {
              var s = i[n]
              s.init && s.init(this)
            }
        }
        this._hook("onInit", {})
      }),
      (i.prototype.__destroy = function() {
        undefined !== this._optChange && C.unsubscribe(this._optChange),
          this._hook("onDestroy", {})
      }),
      (i.prototype._render = function(e, t) {}),
      (i.prototype._willUpdate = function() {
        this._merge(), this._render(this.s, this.state)
      }),
      (i.prototype._resp = function(e) {
        var t,
          n = e.responsive,
          i = -1,
          s = this.state.width
        if ((undefined === s && (s = ne ? ne.innerWidth : 375), n && s))
          for (var a in n)
            if (n.hasOwnProperty(a)) {
              var o = n[a],
                r = o.breakpoint || zt[a]
              s >= r && r > i && ((t = o), (i = r))
            }
        return t
      }),
      (i.prototype._merge = function() {
        var e,
          t,
          i,
          a = this.constructor,
          o = a.defaults,
          r = this._opt || {},
          l = {}
        if (((this._prevS = this.s || {}), o)) {
          for (var c in this.props)
            undefined !== this.props[c] && (l[c] = this.props[c])
          var h = l.locale || r.locale || g.locale || {},
            u =
              l.calendarSystem ||
              h.calendarSystem ||
              r.calendarSystem ||
              g.calendarSystem,
            _ = l.theme || r.theme || g.theme,
            m = l.themeVariant || r.themeVariant || g.themeVariant
          ;("auto" !== _ && _) || (_ = D.theme),
            ("dark" !== m && (!Mt || ("auto" !== m && m))) ||
              !b[_ + "-dark"] ||
              (_ += "-dark"),
            (l.theme = _)
          var p = (i = b[_]) && b[_][a._name]
          t = n({}, o, p, h, g, r, u, l)
          var v = this._resp(t)
          ;(this._respProps = v), v && (t = n({}, t, v))
        } else (t = n({}, this.props)), (i = b[t.theme])
        ;(e = i && i.baseTheme),
          (t.baseTheme = e),
          (this.s = t),
          (this._className = t.cssClass || t.class || t.className || ""),
          (this._rtl = " mbsc-" + (t.rtl ? "rtl" : "ltr")),
          (this._theme = " mbsc-" + t.theme + (e ? " mbsc-" + e : "")),
          (this._touchUi =
            "auto" === t.touchUi || undefined === t.touchUi ? d : t.touchUi),
          (this._hb =
            "ios" !== s || ("ios" !== t.theme && "ios" !== e) ? "" : " mbsc-hb")
      }),
      (i.defaults = undefined),
      (i._name = ""),
      i
    )
  })(Ot),
  Ut = /*#__PURE__*/ (function(e) {
    function n() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(n, e),
      (n.prototype._template = function(e) {
        return mt(
          "span",
          {
            onClick: e.onClick,
            className: this._cssClass,
            dangerouslySetInnerHTML: this._svg
          },
          this._hasChildren && e.name
        )
      }),
      n
    )
  })(
    /*#__PURE__*/ (function(e) {
      function n() {
        return (null !== e && e.apply(this, arguments)) || this
      }
      return (
        t(n, e),
        (n.prototype._render = function(e) {
          ;(this._hasChildren = !F(e.name)),
            (this._cssClass =
              this._className +
              " mbsc-icon" +
              this._theme +
              (e.name && !this._hasChildren
                ? -1 !== e.name.indexOf(" ")
                  ? " " + e.name
                  : " mbsc-font-icon mbsc-icon-" + e.name
                : "")),
            (this._svg = e.svg ? this._safeHtml(e.svg) : undefined)
        }),
        n
      )
    })(Yt)
  ),
  At = "click",
  Wt = "mousedown",
  Ft = "mouseup",
  Vt = "mouseenter",
  Bt = 0
function Xt(e, t, n) {
  var i = (n ? "page" : "client") + t
  return e.targetTouches && e.targetTouches[0]
    ? e.targetTouches[0][i]
    : e.changedTouches && e.changedTouches[0]
    ? e.changedTouches[0][i]
    : e[i]
}
function qt(e, t) {
  if (!t.mbscClick) {
    var n = (e.originalEvent || e).changedTouches[0],
      i = document.createEvent("MouseEvents")
    i.initMouseEvent(
      "click",
      !0,
      !0,
      window,
      1,
      n.screenX,
      n.screenY,
      n.clientX,
      n.clientY,
      !1,
      !1,
      !1,
      !1,
      0,
      null
    ),
      (i.isMbscTap = !0),
      (i.isIonicTap = !0),
      (Pt = !0),
      (t.mbscChange = !0),
      (t.mbscClick = !0),
      t.dispatchEvent(i),
      (Pt = !1),
      Bt++,
      setTimeout(function() {
        Bt--
      }, 500),
      setTimeout(function() {
        delete t.mbscClick
      })
  }
}
function jt(e) {
  !Bt ||
    Pt ||
    e.isMbscTap ||
    ("TEXTAREA" === e.target.nodeName && e.type === Wt) ||
    (e.stopPropagation(), e.preventDefault())
}
function Gt(e) {
  xe(e.target).__mbscFocusVisible = !1
}
function Kt(e) {
  xe(e.target).__mbscFocusVisible = !0
}
function Jt(e) {
  De(e.target).__mbscMoveObs.next(e)
}
function $t(e) {
  e &&
    setTimeout(function() {
      ;(e.style.opacity = "0"),
        (e.style.transition = "opacity linear .4s"),
        setTimeout(function() {
          e && e.parentNode && e.parentNode.removeChild(e)
        }, 400)
    }, 200)
}
function Zt(e, t) {
  var n,
    i,
    s,
    a,
    o,
    r,
    c,
    d,
    h,
    u,
    _,
    m,
    p,
    v,
    f,
    g,
    y = {},
    b = xe(e),
    D = De(e)
  function C(e) {
    if ("touchstart" === e.type) Rt = !0
    else if (Rt) return e.type === Wt && (Rt = !1), !0
    return !1
  }
  function w() {
    c &&
      ($t(a),
      (a = (function(e, t, n) {
        var i = e.getBoundingClientRect(),
          s = t - i.left,
          a = n - i.top,
          o = Math.max(s, e.offsetWidth - s),
          r = Math.max(a, e.offsetHeight - a),
          l = 2 * Math.sqrt(Math.pow(o, 2) + Math.pow(r, 2)),
          c = te.createElement("span")
        c.classList.add("mbsc-ripple")
        var d = c.style
        return (
          (d.backgroundColor = getComputedStyle(e).color),
          (d.width = l + "px"),
          (d.height = l + "px"),
          (d.top = n - i.top - l / 2 + "px"),
          (d.left = t - i.left - l / 2 + "px"),
          e.appendChild(c),
          setTimeout(function() {
            ;(d.opacity = ".2"),
              (d.transform = "scale(1)"),
              (d.transition =
                "opacity linear .1s, transform cubic-bezier(0, 0, 0.2, 1) .4s")
          }, 30),
          c
        )
      })(e, m, p))),
      t.onPress(),
      (n = !0)
  }
  function k(e, a) {
    ;(i = !1),
      $t(e),
      clearTimeout(s),
      (s = setTimeout(function() {
        n && (t.onRelease(), (n = !1))
      }, a))
  }
  function x(e) {
    if (!C(e) && (e.type !== Wt || (0 === e.button && !e.ctrlKey))) {
      if (
        ((u = Xt(e, "X")),
        (_ = Xt(e, "Y")),
        (m = u),
        (p = _),
        (n = !1),
        (i = !1),
        (d = !1),
        (g = !0),
        (y.moved = d),
        (y.startX = u),
        (y.startY = _),
        (y.endX = m),
        (y.endY = p),
        (y.deltaX = 0),
        (y.deltaY = 0),
        (y.domEvent = e),
        (y.isTouch = Rt),
        $t(a),
        t.onStart)
      ) {
        var o = t.onStart(y)
        c = o && o.ripple
      }
      t.onPress && ((i = !0), clearTimeout(s), (s = setTimeout(w, 50))),
        e.type === Wt && (ye(D, "mousemove", T), ye(D, Ft, S)),
        ye(D, "contextmenu", z)
    }
  }
  function T(e) {
    g &&
      ((m = Xt(e, "X")),
      (p = Xt(e, "Y")),
      (v = m - u),
      (f = p - _),
      !d && (Math.abs(v) > 9 || Math.abs(f) > 9) && ((d = !0), k(a)),
      (y.moved = d),
      (y.endX = m),
      (y.endY = p),
      (y.deltaX = v),
      (y.deltaY = f),
      (y.domEvent = e),
      (y.isTouch = "touchmove" === e.type),
      t.onMove && t.onMove(y))
  }
  function S(e) {
    g &&
      (i && !n && (clearTimeout(s), w()),
      (y.domEvent = e),
      (y.isTouch = "touchend" === e.type),
      t.onEnd && t.onEnd(y),
      k(a, 75),
      (g = !1),
      "touchend" === e.type && t.click && pe && !d && qt(e, e.target),
      e.type === Ft && (be(D, "mousemove", T), be(D, Ft, S)),
      be(D, "contextmenu", z))
  }
  function E(e) {
    C(e) || ((r = !0), t.onHoverIn(e))
  }
  function M(e) {
    r && t.onHoverOut(e), (r = !1)
  }
  function L(e) {
    t.onKeyDown(e)
  }
  function N(e) {
    ;(t.keepFocus || b.__mbscFocusVisible) && ((o = !0), t.onFocus(e))
  }
  function H(e) {
    o && t.onBlur(e), (o = !1)
  }
  function O(e) {
    t.onChange(e)
  }
  function I(e) {
    ;(y.domEvent = e), Rt || t.onDoubleClick(y)
  }
  function z(e) {
    Rt && e.preventDefault()
  }
  if (
    (ye(e, "touchstart", x, { passive: !0 }),
    ye(e, Wt, x),
    ye(e, "touchend", S),
    ye(e, "touchcancel", S),
    D)
  ) {
    var P = D.__mbscMoveCount || 0,
      R = D.__mbscMoveObs || new l()
    0 === P && ye(D, "touchmove", Jt, { passive: !1 }),
      (D.__mbscMoveObs = R),
      (D.__mbscMoveCount = ++P),
      (h = R.subscribe(T))
  }
  if (
    (t.onChange && ye(e, "change", O),
    t.onHoverIn && ye(e, Vt, E),
    t.onHoverOut && ye(e, "mouseleave", M),
    t.onKeyDown && ye(e, "keydown", L),
    t.onFocus && b && (ye(e, "focus", N), !t.keepFocus))
  ) {
    var Y = b.__mbscFocusCount || 0
    0 === Y && (ye(b, Wt, Gt, !0), ye(b, "keydown", Kt, !0)),
      (b.__mbscFocusCount = ++Y)
  }
  return (
    t.onBlur && ye(e, "blur", H),
    t.onDoubleClick && ye(e, "dblclick", I),
    function() {
      if ((clearTimeout(s), t.onFocus && b && !t.keepFocus)) {
        var n = b.__mbscFocusCount || 0
        ;(b.__mbscFocusCount = --n),
          n <= 0 && (be(b, Wt, Gt), be(b, "keydown", Kt))
      }
      if (D) {
        var i = D.__mbscMoveCount || 0
        ;(D.__mbscMoveCount = --i),
          D.__mbscMoveObs && D.__mbscMoveObs.unsubscribe(h),
          i <= 0 &&
            (delete D.__mbscMoveCount,
            delete D.__mbscMoveObs,
            be(D, "touchmove", Jt, { passive: !1 }))
      }
      be(e, Wt, x, { passive: !0 }),
        be(e, "touchend", S),
        be(e, "touchcancel", S),
        be(D, "mousemove", T),
        be(D, Ft, S),
        be(D, "contextmenu", z),
        be(e, "change", O),
        be(e, Vt, E),
        be(e, "mouseleave", M),
        be(e, "keydown", L),
        be(e, "touchstart", x),
        be(e, "focus", N),
        be(e, "blur", H),
        be(e, "dblclick", I)
    }
  )
}
h &&
  (["mousedown", Vt, Wt, Ft, At].forEach(function(e) {
    te.addEventListener(e, jt, !0)
  }),
  "android" === s &&
    o < 5 &&
    te.addEventListener(
      "change",
      function(e) {
        var t = e.target
        Bt &&
          "checkbox" === t.type &&
          !t.mbscChange &&
          (e.stopPropagation(), e.preventDefault()),
          delete t.mbscChange
      },
      !0
    ))
var Qt = /*#__PURE__*/ (function(e) {
  function s() {
    return (null !== e && e.apply(this, arguments)) || this
  }
  return (
    t(s, e),
    (s.prototype._template = function(e) {
      var t = this.props,
        s = t.ariaLabel,
        a = t.children
      t.className, t.color
      var o = t.endIcon
      t.endIconSrc
      var r = t.endIconSvg
      t.hasChildren
      var l = t.icon
      t.iconSrc
      var c = t.iconSvg
      t.ripple, t.rtl
      var d = t.startIcon
      t.startIconSrc
      var h = t.startIconSvg
      t.tag, t.theme, t.themeVariant, t.variant
      var u = i(t, [
          "ariaLabel",
          "children",
          "className",
          "color",
          "endIcon",
          "endIconSrc",
          "endIconSvg",
          "hasChildren",
          "icon",
          "iconSrc",
          "iconSvg",
          "ripple",
          "rtl",
          "startIcon",
          "startIconSrc",
          "startIconSvg",
          "tag",
          "theme",
          "themeVariant",
          "variant"
        ]),
        _ = n(
          { "aria-label": s, className: this._cssClass, ref: this._setEl },
          u
        ),
        m = mt(
          Fe,
          null,
          this._isIconOnly &&
            mt(Ut, {
              className: this._iconClass,
              name: l,
              svg: c,
              theme: e.theme
            }),
          this._hasStartIcon &&
            mt(Ut, {
              className: this._startIconClass,
              name: d,
              svg: h,
              theme: e.theme
            }),
          a,
          this._hasEndIcon &&
            mt(Ut, {
              className: this._endIconClass,
              name: o,
              svg: r,
              theme: e.theme
            })
        )
      return "span" === e.tag
        ? mt(
            "span",
            n(
              {
                role: "button",
                "aria-disabled": e.disabled,
                tabIndex: this._tabIndex
              },
              _
            ),
            m
          )
        : "a" === e.tag
        ? mt("a", n({ "aria-disabled": e.disabled }, _), m)
        : mt("button", n({}, _), m)
    }),
    s
  )
})(
  /*#__PURE__*/ (function(e) {
    function n() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(n, e),
      (n.prototype._mounted = function() {
        var e = this
        this._unlisten = Zt(this._el, {
          click: !0,
          onBlur: function() {
            e.setState({ hasFocus: !1 })
          },
          onFocus: function() {
            e.setState({ hasFocus: !0 })
          },
          onHoverIn: function() {
            e.s.disabled || e.setState({ hasHover: !0 })
          },
          onHoverOut: function() {
            e.setState({ hasHover: !1 })
          },
          onKeyDown: function(t) {
            switch (t.keyCode) {
              case 13:
              case 32:
                e._el.click(), t.preventDefault()
            }
          },
          onPress: function() {
            e.setState({ isActive: !0 })
          },
          onRelease: function() {
            e.setState({ isActive: !1 })
          },
          onStart: function() {
            return { ripple: e.s.ripple && !e.s.disabled }
          }
        })
      }),
      (n.prototype._render = function(e, t) {
        var n = this,
          i = e.disabled
        ;(this._isIconOnly = !(!e.icon && !e.iconSvg)),
          (this._hasStartIcon = !(!e.startIcon && !e.startIconSvg)),
          (this._hasEndIcon = !(!e.endIcon && !e.endIconSvg)),
          (this._tabIndex = i ? undefined : e.tabIndex || 0),
          (this._cssClass =
            this._className +
            " mbsc-reset mbsc-font mbsc-button" +
            this._theme +
            this._rtl +
            " mbsc-button-" +
            e.variant +
            (this._isIconOnly ? " mbsc-icon-button" : "") +
            (i ? " mbsc-disabled" : "") +
            (e.color ? " mbsc-button-" + e.color : "") +
            (t.hasFocus && !i ? " mbsc-focus" : "") +
            (t.isActive && !i ? " mbsc-active" : "") +
            (t.hasHover && !i ? " mbsc-hover" : "")),
          (this._iconClass = "mbsc-button-icon" + this._rtl),
          (this._startIconClass = this._iconClass + " mbsc-button-icon-start"),
          (this._endIconClass = this._iconClass + " mbsc-button-icon-end"),
          e.disabled &&
            t.hasHover &&
            setTimeout(function() {
              n.setState({ hasHover: !1 })
            })
      }),
      (n.prototype._destroy = function() {
        this._unlisten()
      }),
      (n.defaults = { ripple: !1, tag: "button", variant: "standard" }),
      (n._name = "Button"),
      n
    )
  })(Yt)
)
function en(e) {
  return !!e._mbsc
}
function tn(e, t) {
  var n = t.dataTimezone || t.displayTimezone,
    i = t.timezonePlugin
  if (n && i && en(e)) {
    var s = e.clone()
    return s.setTimezone(n), s.toISOString()
  }
  return e
}
var nn = {
    amText: "am",
    dateFormat: "MM/DD/YYYY",
    dateFormatLong: "D DDD MMM YYYY",
    dayNames: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    daySuffix: "",
    firstDay: 0,
    getDate: fn,
    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    monthSuffix: "",
    pmText: "pm",
    separator: " ",
    shortYearCutoff: "+10",
    timeFormat: "h:mm A",
    todayText: "Today",
    weekText: "Week {count}",
    yearSuffix: "",
    getMonth: function(e) {
      return e.getMonth()
    },
    getDay: function(e) {
      return e.getDate()
    },
    getYear: function(e) {
      return e.getFullYear()
    },
    getMaxDayOfMonth: function(e, t) {
      return 32 - new Date(e, t, 32, 12).getDate()
    },
    getWeekNumber: function(e) {
      var t = new Date(+e)
      t.setHours(0, 0, 0), t.setDate(t.getDate() + 4 - (t.getDay() || 7))
      var n = new Date(t.getFullYear(), 0, 1)
      return Math.ceil(((t - n) / 864e5 + 1) / 7)
    }
  },
  sn = /^(\d{4}|[+\-]\d{6})(?:-(\d{2})(?:-(\d{2}))?)?(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?((Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/,
  an = /^((\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/
function on(e, t, n) {
  var i,
    s,
    a = { y: 1, m: 2, d: 3, h: 4, i: 5, s: 6, u: 7, tz: 8 }
  if (n)
    for (i in a)
      a.hasOwnProperty(i) && (s = e[a[i] - t]) && (n[i] = "tz" === i ? s : 1)
}
function rn(e) {
  return (
    +new Date(
      1970,
      0,
      1,
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    ) - +new Date(1970, 0, 1)
  )
}
function ln(e, t, n, i, s) {
  var a = +e,
    o = +n
  return a < (s && o === +i ? +i + 1 : +i) && (s && a === +t ? +t + 1 : +t) > o
}
function cn(e, t, n, i, s) {
  return ((!t && !s) || e.exclusiveEndDates) && n && i && n < i
    ? yn(t ? undefined : e, +i - 1)
    : i
}
function dn(e) {
  return e.getFullYear() + "-" + K(e.getMonth() + 1) + "-" + K(e.getDate())
}
function hn(e) {
  return en(e)
    ? e.createDate(e.getFullYear(), e.getMonth(), e.getDate())
    : fn(e.getFullYear(), e.getMonth(), e.getDate())
}
function un(e) {
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate())
}
function _n(e, t) {
  return J((un(t) - un(e)) / 864e5)
}
function mn(e, t, n) {
  var i = e.getFullYear(),
    s = e.getMonth(),
    a = e.getDay(),
    o = undefined === n ? t.firstDay : n
  return new Date(i, s, o - (o - a > 0 ? 7 : 0) - a + e.getDate())
}
function pn(e, t) {
  return (
    e.getFullYear() === t.getFullYear() &&
    e.getMonth() === t.getMonth() &&
    e.getDate() === t.getDate()
  )
}
function vn(e, t, n) {
  return n.getYear(e) === n.getYear(t) && n.getMonth(e) === n.getMonth(t)
}
function fn(e, t, n, i, s, a, o) {
  var r = new Date(e, t, n, i || 0, s || 0, a || 0, o || 0)
  return (
    23 === r.getHours() && 0 === (i || 0) && r.setHours(r.getHours() + 2), r
  )
}
function gn(e) {
  return e.getTime
}
function yn(e, t, n, i, s, a, o, r) {
  return null === t
    ? null
    : t && (W(t) || F(t)) && B(n)
    ? bn(t, e)
    : e && e.timezonePlugin
    ? e.timezonePlugin.createDate(e, t, n, i, s, a, o, r)
    : X(t)
    ? new Date(t)
    : B(t)
    ? new Date()
    : new Date(t, n || 0, i || 1, s || 0, a || 0, o || 0, r || 0)
}
function bn(e, t, n, i) {
  var s
  if (!e) return null
  var a = t && t.timezonePlugin
  if (a) {
    var o = en(e) ? e : a.parse(e, t)
    return o.setTimezone(t.displayTimezone), o
  }
  return gn(e)
    ? e
    : e._isAMomentObject
    ? e.toDate()
    : W(e)
    ? new Date(e)
    : (F(e) && (e = e.trim()),
      (s = an.exec(e))
        ? (on(s, 2, i),
          new Date(
            1970,
            0,
            1,
            s[2] ? +s[2] : 0,
            s[3] ? +s[3] : 0,
            s[4] ? +s[4] : 0,
            s[5] ? +s[5] : 0
          ))
        : (s = sn.exec(e))
        ? (on(s, 0, i),
          new Date(
            s[1] ? +s[1] : 1970,
            s[2] ? s[2] - 1 : 0,
            s[3] ? +s[3] : 1,
            s[4] ? +s[4] : 0,
            s[5] ? +s[5] : 0,
            s[6] ? +s[6] : 0,
            s[7] ? +s[7] : 0
          ))
        : Cn(n, e, t))
}
function Dn(e, t, i) {
  var s,
    a,
    o = "",
    r = !1,
    l = n({}, nn, g.locale, i),
    c = function(t) {
      for (var n = 0, i = s; i + 1 < e.length && e.charAt(i + 1) === t; )
        n++, i++
      return n
    },
    d = function(e) {
      var t = c(e)
      return (s += t), t
    },
    h = function(e, t, n) {
      var i = "" + t
      if (d(e)) for (; i.length < n; ) i = "0" + i
      return i
    },
    u = function(e, t, n, i) {
      return 3 === d(e) ? i[t] : n[t]
    }
  for (s = 0; s < e.length; s++)
    if (r) "'" !== e.charAt(s) || d("'") ? (o += e.charAt(s)) : (r = !1)
    else
      switch (e.charAt(s)) {
        case "D":
          o +=
            c("D") > 1
              ? u("D", t.getDay(), l.dayNamesShort, l.dayNames)
              : h("D", l.getDay(t), 2)
          break
        case "M":
          o +=
            c("M") > 1
              ? u("M", l.getMonth(t), l.monthNamesShort, l.monthNames)
              : h("M", l.getMonth(t) + 1, 2)
          break
        case "Y":
          ;(a = l.getYear(t)),
            (o += 3 === d("Y") ? a : (a % 100 < 10 ? "0" : "") + (a % 100))
          break
        case "h":
          var _ = t.getHours()
          o += h("h", _ > 12 ? _ - 12 : 0 === _ ? 12 : _, 2)
          break
        case "H":
          o += h("H", t.getHours(), 2)
          break
        case "m":
          o += h("m", t.getMinutes(), 2)
          break
        case "s":
          o += h("s", t.getSeconds(), 2)
          break
        case "a":
          o += t.getHours() > 11 ? l.pmText : l.amText
          break
        case "A":
          o +=
            t.getHours() > 11 ? l.pmText.toUpperCase() : l.amText.toUpperCase()
          break
        case "'":
          d("'") ? (o += "'") : (r = !0)
          break
        default:
          o += e.charAt(s)
      }
  return o
}
function Cn(e, t, i) {
  var s = n({}, nn, i),
    a = bn(s.defaultValue || new Date())
  if (!t) return a
  e || (e = s.dateFormat + s.separator + s.timeFormat)
  var o,
    r = s.shortYearCutoff,
    l = s.getYear(a),
    c = s.getMonth(a) + 1,
    d = s.getDay(a),
    h = a.getHours(),
    u = a.getMinutes(),
    _ = 0,
    m = -1,
    p = !1,
    v = 0,
    f = function(t) {
      for (var n = 0, i = o; i + 1 < e.length && e.charAt(i + 1) === t; )
        n++, i++
      return n
    },
    g = function(e) {
      var t = f(e)
      return (o += t), t
    },
    y = function(e) {
      var n = g(e),
        i = new RegExp("^\\d{1," + (n >= 2 ? 4 : 2) + "}"),
        s = t.substr(v).match(i)
      return s ? ((v += s[0].length), parseInt(s[0], 10)) : 0
    },
    b = function(e, n, i) {
      for (var s = 3 === g(e) ? i : n, a = 0; a < s.length; a++)
        if (t.substr(v, s[a].length).toLowerCase() === s[a].toLowerCase())
          return (v += s[a].length), a + 1
      return 0
    },
    D = function() {
      v++
    }
  for (o = 0; o < e.length; o++)
    if (p) "'" !== e.charAt(o) || g("'") ? D() : (p = !1)
    else
      switch (e.charAt(o)) {
        case "Y":
          l = y("Y")
          break
        case "M":
          c = f("M") < 2 ? y("M") : b("M", s.monthNamesShort, s.monthNames)
          break
        case "D":
          f("D") < 2 ? (d = y("D")) : b("D", s.dayNamesShort, s.dayNames)
          break
        case "H":
          h = y("H")
          break
        case "h":
          h = y("h")
          break
        case "m":
          u = y("m")
          break
        case "s":
          _ = y("s")
          break
        case "a":
          m = b("a", [s.amText, s.pmText], [s.amText, s.pmText]) - 1
          break
        case "A":
          m = b("A", [s.amText, s.pmText], [s.amText, s.pmText]) - 1
          break
        case "'":
          g("'") ? D() : (p = !0)
          break
        default:
          D()
      }
  if (l < 100) {
    var C = void 0
    ;(C =
      l <= (F(r) ? (new Date().getFullYear() % 100) + parseInt(r, 10) : +r)
        ? 0
        : -100),
      (l += new Date().getFullYear() - (new Date().getFullYear() % 100) + C)
  }
  h = -1 === m ? h : m && h < 12 ? h + 12 : m || 12 !== h ? h : 0
  var w = s.getDate(l, c - 1, d, h, u, _)
  return s.getYear(w) !== l || s.getMonth(w) + 1 !== c || s.getDay(w) !== d
    ? a
    : w
}
function wn(e) {
  return en(e) ? e.clone() : new Date(e)
}
function kn(e, t) {
  var n = wn(e)
  return n.setDate(n.getDate() + t), n
}
function xn(e, t, n) {
  return t > n ? e <= n || e >= t : e >= t && e <= n
}
function Tn(e, t) {
  var n = 6e4 * t,
    i = wn(e).setHours(0, 0, 0, 0),
    s = i + Math.round((+e - +i) / n) * n
  return en(e) ? e.createDate(s) : new Date(s)
}
h &&
  "undefined" == typeof Symbol &&
  (window.Symbol = { toPrimitive: "toPrimitive" }),
  (y.datetime = { formatDate: Dn, parseDate: Cn })
var Sn = { SU: 0, MO: 1, TU: 2, WE: 3, TH: 4, FR: 5, SA: 6 },
  En = {
    byday: "weekDays",
    bymonth: "month",
    bymonthday: "day",
    dtstart: "from",
    freq: "repeat",
    wkst: "weekStart"
  }
function Mn(e, t, n, i) {
  var s = bn(t.start, t.allDay ? undefined : n),
    a = bn(t.end, t.allDay ? undefined : n),
    o = a - s
  for (
    i && ((t.start = s), (t.end = a)),
      s = hn(s),
      a = n.exclusiveEndDates ? a : hn(kn(a, 1));
    s < a || !o;

  )
    Ln(e, s, t), (s = kn(s, 1)), (o = 1)
}
function Ln(e, t, n) {
  var i = dn(t)
  ;(e[i] = e[i] || []), e[i].push(n)
}
function Nn(e) {
  return e ? (U(e) ? e : F(e) ? e.split(",") : [e]) : []
}
function Hn(e, t, n, i, s, a, o) {
  F(e) &&
    (e = (function(e) {
      for (var t = {}, n = 0, i = e.split(";"); n < i.length; n++) {
        var s = i[n].split("="),
          a = s[0].trim().toLowerCase(),
          o = s[1].trim()
        t[En[a] || a] = o
      }
      return t
    })(e))
  var r,
    l,
    c = s.getYear,
    d = s.getMonth,
    h = s.getDay,
    u = s.getDate,
    _ = s.getMaxDayOfMonth,
    m = (e.repeat || "").toLowerCase(),
    p = e.interval || 1,
    v = e.count,
    f = [],
    g = e.from
      ? bn(e.from)
      : t || (1 !== p || undefined !== v ? new Date() : n),
    y = e.until ? bn(e.until) : 1 / 0,
    b = g < n,
    D = b ? n : hn(g),
    C = y < i ? y : i,
    w = undefined === v ? 1 / 0 : v,
    k = (e.weekDays || "").split(","),
    x = Sn[(e.weekStart || "MO").trim().toUpperCase()],
    T = +(e.day || h(g)),
    S = +(e.month || d(g)),
    E = (function(e, t, n, i, s, a) {
      var o = {}
      if (s) for (var r = 0, l = Nn(s); r < l.length; r++) o[dn(bn(l[r]))] = !0
      if (a)
        for (var c = 0, d = Hn(a, e, t, n, i); c < d.length; c++)
          o[dn(d[c].d)] = !0
      return o
    })(t, n, i, s, a, o),
    M = !0,
    L = 0,
    N = 0
  switch (m) {
    case "daily":
      for (N = v && b ? $(_n(g, n) / p) : 0; M; )
        (l = u(c(g), d(g), h(g) + N * p)) < C && N < w
          ? (E[dn(l)] || f.push({ d: l, i: N }), N++)
          : (M = !1)
      break
    case "weekly":
      for (
        var H = {},
          O = [],
          I = hn(g),
          z = mn(g, { firstDay: x }),
          P = z.getDay(),
          R = mn(n, { firstDay: x }),
          Y = 0,
          U = k;
        Y < U.length;
        Y++
      ) {
        var A = U[Y]
        O.push(Sn[A.trim().toUpperCase()])
      }
      if (
        (O.sort(function(e, t) {
          return (e = (e -= P) < 0 ? e + 7 : e) - (t = (t -= P) < 0 ? t + 7 : t)
        }),
        b && undefined === v)
      )
        for (var W = $(_n(z, R)), V = 0, B = O; V < B.length; V++) {
          A = B[V]
          var X = $(W / (7 * p))
          A < g.getDay() && X--, A < n.getDay() && X++, (H[A] = X), (N += X)
        }
      for (; M; ) {
        for (var q = 0, j = O; q < j.length; q++) {
          ;(l = u(
            c((r = kn(z, (A = j[q]) < x ? A - x + 7 : A - x))),
            d(r),
            h(r) + 7 * ((H[A] || 0) + L) * p
          )) < C && N < w
            ? l >= I && (E[dn(l)] || f.push({ d: l, i: N }), N++)
            : (M = !1)
        }
        L++
      }
      break
    case "monthly":
      for (; M; ) {
        var G = _(c(g), d(g) + L * p)
        ;(l = u(c(g), d(g) + L * p, T < 0 ? G + T + 1 : T)) < C && N < w
          ? G >= T && (l >= D && !E[dn(l)] && f.push({ d: l, i: N }), N++)
          : (M = !1),
          L++
      }
      break
    case "yearly":
      for (; M; ) {
        G = _(c(g) + L * p, S - 1)
        ;(l = u(c(g) + L * p, S - 1, T < 0 ? G + T + 1 : T)) < C && N < w
          ? G >= T && (l >= D && !E[dn(l)] && f.push({ d: l, i: N }), N++)
          : (M = !1),
          L++
      }
  }
  return f
}
function On(e, t, i, s, a) {
  var o = {},
    r = s.timezonePlugin,
    l = s.dataTimezone || s.displayTimezone,
    c = r ? { displayTimezone: l, timezonePlugin: r } : s
  if (e) {
    for (var d = 0, h = e; d < h.length; d++) {
      var u = h[d],
        _ = F(u) || u.getTime || u.toDate ? u : u.start || u.date,
        m = bn(_, u.allDay ? undefined : s)
      if (u.recurring)
        for (
          var p = an.test(_) ? null : bn(_),
            v = kn(t, -1),
            f = kn(i, 1),
            g = Hn(
              u.recurring,
              p,
              v,
              f,
              s,
              u.recurringException,
              u.recurringExceptionRule
            ),
            y = yn(u.allDay ? undefined : c, m),
            b = u.end ? +bn(u.end, u.allDay ? undefined : s) - +y : 0,
            D = 0,
            C = g;
          D < C.length;
          D++
        ) {
          var w = C[D],
            k = w.d,
            x = n({}, u)
          u.start
            ? (x.start = yn(
                u.allDay ? undefined : c,
                k.getFullYear(),
                k.getMonth(),
                k.getDate(),
                y.getHours(),
                y.getMinutes(),
                y.getSeconds()
              ))
            : ((x.allDay = !0),
              (x.start = yn(
                undefined,
                k.getFullYear(),
                k.getMonth(),
                k.getDate()
              ))),
            u.end && (x.end = yn(u.allDay ? undefined : c, +x.start + b)),
            (x.nr = w.i),
            (x.original = u),
            x.start && x.end ? Mn(o, x, s, a) : Ln(o, k, x)
        }
      else u.start && u.end ? Mn(o, u, s, a) : m && Ln(o, m, u)
    }
    return o
  }
}
var In,
  zn = 0
function Pn(e, t, n) {
  var i,
    s,
    a,
    o,
    r,
    l,
    c,
    d = 0
  function h() {
    ;(s.style.width = "100000px"),
      (s.style.height = "100000px"),
      (i.scrollLeft = 1e5),
      (i.scrollTop = 1e5),
      (l.scrollLeft = 1e5),
      (l.scrollTop = 1e5)
  }
  function u() {
    var e = +new Date()
    ;(o = 0),
      c ||
        (e - d > 200 && !i.scrollTop && !i.scrollLeft && ((d = e), h()),
        o || (o = de(u)))
  }
  function _() {
    r || (r = de(m))
  }
  function m() {
    ;(r = 0), h(), t()
  }
  return (
    ne && ne.ResizeObserver
      ? (In ||
          (In = new ne.ResizeObserver(function(e) {
            r ||
              (r = de(function() {
                for (var t = 0, n = e; t < n.length; t++) {
                  var i = n[t]
                  i.target.__mbscResize && i.target.__mbscResize()
                }
                r = 0
              }))
          })),
        zn++,
        (e.__mbscResize = function() {
          n ? n.run(t) : t()
        }),
        In.observe(e))
      : (a = te && te.createElement("div")),
    a &&
      ((a.innerHTML =
        '<div class="mbsc-resize"><div class="mbsc-resize-i mbsc-resize-x"></div></div><div class="mbsc-resize"><div class="mbsc-resize-i mbsc-resize-y"></div></div>'),
      (a.dir = "ltr"),
      (l = a.childNodes[1]),
      (i = a.childNodes[0]),
      (s = i.childNodes[0]),
      e.appendChild(a),
      ye(i, "scroll", _),
      ye(l, "scroll", _),
      n
        ? n.runOutsideAngular(function() {
            de(u)
          })
        : de(u)),
    {
      detach: function() {
        In
          ? (zn--,
            delete e.__mbscResize,
            In.unobserve(e),
            zn || (In = undefined))
          : (a &&
              (be(i, "scroll", _),
              be(l, "scroll", _),
              e.removeChild(a),
              he(r),
              (a = undefined)),
            (c = !0))
      }
    }
  )
}
var Rn = new Date(1970, 0, 1),
  Yn = 1,
  Un = n({}, nn, {
    dateText: "Date",
    eventText: "event",
    eventsText: "events",
    moreEventsText: "{count} more",
    nextText: "Next",
    prevText: "Previous",
    showEventTooltip: !0,
    showToday: !0,
    timeText: "Time"
  })
function An(e, t) {
  var n = t.refDate ? bn(t.refDate) : Rn,
    i = t.eventRangeSize || 1,
    s = "week" === t.calendarType,
    a = t.showCalendar,
    o = t.getDate,
    r = (a && !s) || (!a && "week" !== t.eventRange) ? n : mn(n, t),
    l = t.getYear(r),
    c = t.getMonth(r),
    d = t.getDay(r)
  if (a) return s ? o(l, c, d + 7 * t.weeks * e) : o(l, c + e * t.size, 1)
  switch (t.eventRange) {
    case "year":
      return o(l + e * i, c, 1)
    case "week":
      return o(l, c, d + 7 * i * e)
    case "day":
      return o(l, c, d + i * e)
    default:
      return o(l, c + e * i, 1)
  }
}
function Wn(e, t) {
  var n,
    i = t.refDate ? bn(t.refDate) : Rn,
    s = t.getYear,
    a = t.getMonth,
    o = "week" === t.calendarType,
    r = t.eventRangeSize || 1
  if (t.showCalendar)
    return $(
      o
        ? _n(mn(i, t), mn(e, t)) / (7 * t.weeks)
        : (a(e) - a(i) + 12 * (s(e) - s(i))) / t.size
    )
  switch (t.eventRange) {
    case "year":
      n = s(e) - s(i)
      break
    case "week":
      n = _n(mn(i, t), mn(e, t)) / 7
      break
    case "day":
      n = _n(i, e)
      break
    case "month":
      n = a(e) - a(i) + 12 * (s(e) - s(i))
      break
    default:
      return
  }
  return $(n / r)
}
function Fn(e, t) {
  var n = t.refDate ? bn(t.refDate) : Rn
  return $((t.getYear(e) - t.getYear(n)) / 12)
}
function Vn(e, t) {
  var n = t.refDate ? bn(t.refDate) : Rn
  return t.getYear(e) - t.getYear(n)
}
function Bn(e, t) {
  var n = bn(e.start || e.date),
    i = bn(t.start || e.date),
    s = e.title || e.text,
    a = t.title || t.text,
    o = n ? +n * (e.allDay ? 1 : 10) : 0,
    r = i ? +i * (t.allDay ? 1 : 10) : 0
  return o === r ? (s > a ? 1 : -1) : o - r
}
function Xn(e, t, n, i, s, a, o, r, l, c, d, h, u, _) {
  t = t || {}
  for (
    var m = {},
      p = {},
      v = n,
      f = 0,
      g = s,
      y = i,
      b = function() {
        var b,
          D,
          C = dn(v),
          w = v.getDay(),
          k = e.getDay(v),
          x = d && e.getDate(e.getYear(v), e.getMonth(v) + 1, 0),
          T = (l && (w === r || (1 === k && d))) || +v == +n,
          S = qn(t[C] || [], c),
          E = 0,
          M = 0,
          L = 0
        T && ((p = {}), (y = l ? kn(v, a) : i)),
          o &&
            (S = S.filter(function(e) {
              return e.allDay
            })),
          -1 === s && (g = S.length + 1)
        var N = S.length,
          H = []
        h &&
          (H.push({ id: "count_" + +v, count: N, placeholder: 0 === N }),
          (E = g))
        for (
          var O = function() {
            if (
              ((b = null),
              S.forEach(function(e, t) {
                p[E] === e && ((b = e), (D = t))
              }),
              E === g - 1 && (M < N - 1 || (L === N && !b)) && -1 !== s)
            ) {
              var t = N - M,
                n = u || "",
                i = ((t > 1 && _) || n).replace(/{count}/, t)
              t && H.push({ id: "more_" + ++f, more: i }),
                b &&
                  ((p[E] = null),
                  b._days.forEach(function(e) {
                    m[dn(e)].data[E] = {
                      id: "more_" + ++f,
                      more: n.replace(/{count}/, "1")
                    }
                  })),
                M++,
                E++
            } else if (b)
              D === L && L++,
                pn(v, bn(b.end, b.allDay ? undefined : e)) && (p[E] = null),
                H.push({
                  id: b.id + (b.recurring ? "_" + b.nr : ""),
                  event: b
                }),
                E++,
                M++,
                b._days.push(v)
            else if (L < N) {
              var a = S[L],
                o = a.allDay,
                r = a.start && bn(a.start, o ? undefined : e)
              if (!r || pn(v, r) || T) {
                var l = a.end && bn(a.end, o ? undefined : e),
                  c = cn(e, o, r, l, !0),
                  d = c && !pn(r, c),
                  h = x && x < c ? x : c
                undefined === a.id && (a.id = "mbsc_" + Yn++),
                  d && (p[E] = a),
                  (a._days = [v]),
                  H.push({
                    event: a,
                    id: a.id + (a.recurring ? "_" + a.nr : ""),
                    lastDay: x ? kn(x, 1) : undefined,
                    multiDay: d,
                    showText: !0,
                    width: d ? 100 * Math.min(_n(v, h) + 1, _n(v, y)) : 100
                  }),
                  E++,
                  M++
              }
              L++
            } else M < N && H.push({ id: "ph_" + ++f, placeholder: !0 }), E++
          };
          N && E < g;

        )
          O()
        ;(m[C] = { data: H, events: S }), (v = hn(kn(v, 1)))
      };
    v < i;

  )
    b()
  return m
}
function qn(e, t) {
  return e && e.slice(0).sort(t || Bn)
}
var jn,
  Gn,
  Kn = /*#__PURE__*/ (function(e) {
    function n() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t.state = {
          height: "sm",
          maxLabels: 0,
          pageSize: 0,
          pickerSize: 0,
          width: "sm"
        }),
        (t._dim = {}),
        (t._months = [1, 2, 3]),
        (t._title = []),
        (t.MONTH_VIEW = "month"),
        (t.YEAR_VIEW = "year"),
        (t.MULTI_YEAR_VIEW = "multi-year"),
        (t.nextPage = function() {
          switch ((t._prevDocClick(), t._view)) {
            case "multi-year":
              t._activeYearsChange(1)
              break
            case "year":
              t._activeYearChange(1)
              break
            default:
              t._activeChange(1)
          }
        }),
        (t.prevPage = function() {
          switch ((t._prevDocClick(), t._view)) {
            case "multi-year":
              t._activeYearsChange(-1)
              break
            case "year":
              t._activeYearChange(-1)
              break
            default:
              t._activeChange(-1)
          }
        }),
        (t._changeView = function(e) {
          var n = t._view,
            i = t._hasPicker,
            s = t.s.selectView
          if (!e) {
            switch (n) {
              case "month":
                e = "multi-year"
                break
              case "multi-year":
                e = "year"
                break
              default:
                e = i || "year" === s ? "multi-year" : "month"
            }
            "multi-year" === n && 12 == +t.s.size && (e = "month")
          }
          var a = i && e === s
          t.setState({
            view: e,
            viewClosing: a ? undefined : n,
            viewOpening: a ? undefined : e
          })
        }),
        (t._onDayHoverIn = function(e) {
          t._disableHover ||
            (t._hook("onDayHoverIn", e),
            (t._hoverTimer = setTimeout(function() {
              var n = dn(e.date)
              t._labels && (e.labels = t._labels[n]),
                t._marked && (e.marked = t._marked[n]),
                (t._isHover = !0),
                t._hook("onCellHoverIn", e)
            }, 150)))
        }),
        (t._onDayHoverOut = function(e) {
          if (
            !t._disableHover &&
            (t._hook("onDayHoverOut", e),
            clearTimeout(t._hoverTimer),
            t._isHover)
          ) {
            var n = dn(e.date)
            t._labels && (e.labels = t._labels[n]),
              t._marked && (e.marked = t._marked[n]),
              (t._isHover = !1),
              t._hook("onCellHoverOut", e)
          }
        }),
        (t._onLabelClick = function(e) {
          ;(t._isLabelClick = !0), t._hook("onLabelClick", e)
        }),
        (t._onDayClick = function(e) {
          ;(t._shouldFocus = !t._isLabelClick),
            (t._prevAnim = !1),
            (t._prevPageChange = t.s.noOuterChange),
            (t._isLabelClick = !1),
            t._hook("onDayClick", e)
        }),
        (t._onTodayClick = function(e) {
          ;(t._prevAnim = !1),
            t._hook("onActiveChange", { date: +new Date(), today: !0 }),
            t._hook("onTodayClick", {})
        }),
        (t._onMonthClick = function(e) {
          var n = e.date,
            i = t.s
          if ("year" === i.selectView) t._hook("onDayClick", e)
          else {
            var s = Wn(n, i) - t._offset
            t._changeView("month"),
              (t._shouldFocus = !0),
              (t._prevAnim = !t._hasPicker),
              t._hook("onActiveChange", {
                date: +n,
                nav: !0,
                pageChange: s !== t._pageIndex
              })
          }
        }),
        (t._onYearClick = function(e) {
          var n = t.s,
            i = n.selectView
          ;("multi-year" !== i && 12 != +n.size) || t._hook("onDayClick", e),
            "multi-year" !== i &&
              ((t._shouldFocus = !0),
              (t._prevAnim = "year" === i),
              (t._activeMonth = +e.date),
              t._changeView())
        }),
        (t._onPageChange = function(e) {
          ;(t._isSwipeChange = !0), t._activeChange(e.diff)
        }),
        (t._onYearPageChange = function(e) {
          t._activeYearChange(e.diff)
        }),
        (t._onYearsPageChange = function(e) {
          t._activeYearsChange(e.diff)
        }),
        (t._onAnimationEnd = function(e) {
          ;(t._disableHover = !1),
            t._isIndexChange && (t._pageLoaded(), (t._isIndexChange = !1))
        }),
        (t._onStart = function() {
          clearTimeout(t._hoverTimer)
        }),
        (t._onGestureStart = function(e) {
          ;(t._disableHover = !0), t._hook("onGestureStart", e)
        }),
        (t._onGestureEnd = function(e) {
          t._prevDocClick()
        }),
        (t._onPickerClose = function() {
          t.setState({ view: "month" })
        }),
        (t._onPickerOpen = function() {
          var e = t._pickerCont.clientHeight,
            n = t._pickerCont.clientWidth
          t.setState({ pickerSize: t._isVertical ? e : n })
        }),
        (t._onPickerBtnClick = function(e) {
          "month" === t._view && (t._pickerBtn = e.currentTarget),
            t._prevDocClick(),
            t._changeView()
        }),
        (t._onDocClick = function(e) {
          var n = t.s.selectView
          t._prevClick ||
            t._hasPicker ||
            t._view === n ||
            !t._pickerCont ||
            t._pickerCont.contains(e.target) ||
            t._changeView(n)
        }),
        (t._onViewAnimationEnd = function() {
          undefined === t.state.viewOpening
            ? t.setState({ viewClosing: undefined })
            : t.setState({ viewOpening: undefined })
        }),
        (t._onResize = function() {
          if (t._body && h) {
            var e = t.s,
              n = t.state,
              i = e.showCalendar,
              s = i
                ? t._body.querySelector(".mbsc-calendar-body-inner")
                : t._body,
              a = t._el.offsetWidth,
              o = t._el.offsetHeight,
              r = s.clientHeight,
              l = s.clientWidth,
              c = t._isVertical ? r : l,
              d = t._hasPicker ? n.pickerSize : c,
              u = "sm",
              _ = "sm",
              m = 0,
              p = !1,
              v = 0,
              f = 0
            if (
              (e.responsiveStyle &&
                !t._isGrid &&
                (r > 300 && (_ = "md"), l > 767 && (u = "md")),
              u !== n.width || _ !== n.height)
            )
              (t._shouldCheckSize = !0), t.setState({ width: u, height: _ })
            else {
              var g = []
              if (t._labels && i) {
                var y = s.querySelector(".mbsc-calendar-text"),
                  b = s.querySelector(".mbsc-calendar-day-inner"),
                  D = b.querySelector(".mbsc-calendar-labels"),
                  C = y ? Ce(y, "marginBottom") : 2,
                  w = y ? y.offsetHeight : 18
                ;(v = D.offsetTop),
                  (p = s.scrollHeight > s.clientHeight),
                  (f = w + C),
                  (m = Math.max(1, $((b.clientHeight - v) / f)))
                for (
                  var k = s
                      .querySelector(".mbsc-calendar-row")
                      .querySelectorAll(".mbsc-calendar-cell"),
                    x = 0;
                  x < k.length;
                  x++
                )
                  if (x || !e.showWeekNumbers) {
                    var T = k[x].getBoundingClientRect().width
                    g.push(T)
                  }
              }
              t._hook("onResize", { height: o, target: t._el, width: a }),
                t.setState({
                  cellSizes: g,
                  cellTextHeight: v,
                  hasScrollY: p,
                  labelHeight: f,
                  maxLabels: m,
                  pageSize: c,
                  pickerSize: d
                })
            }
          }
        }),
        (t._onKeyDown = function(e) {
          var n,
            i = t.s,
            s = t._view,
            a = "month" === s ? t._active : t._activeMonth,
            o = new Date(a),
            r = i.getYear(o),
            l = i.getMonth(o),
            c = i.getDay(o),
            d = i.getDate,
            h = i.weeks,
            u = "month" === i.calendarType
          if ("multi-year" === s) {
            var _ = void 0
            switch (e.keyCode) {
              case 37:
                _ = r - 1 * t._rtlNr
                break
              case 39:
                _ = r + 1 * t._rtlNr
                break
              case 38:
                _ = r - 3
                break
              case 40:
                _ = r + 3
                break
              case 36:
                _ = t._getPageYears(t._yearsIndex)
                break
              case 35:
                _ = t._getPageYears(t._yearsIndex) + 11
                break
              case 33:
                _ = r - 12
                break
              case 34:
                _ = r + 12
            }
            _ &&
              t._minYears <= _ &&
              t._maxYears >= _ &&
              (e.preventDefault(),
              (t._shouldFocus = !0),
              (t._prevAnim = !1),
              (t._activeMonth = +d(_, 0, 1)),
              t.forceUpdate())
          } else if ("year" === s) {
            switch (e.keyCode) {
              case 37:
                n = d(r, l - 1 * t._rtlNr, 1)
                break
              case 39:
                n = d(r, l + 1 * t._rtlNr, 1)
                break
              case 38:
                n = d(r, l - 3, 1)
                break
              case 40:
                n = d(r, l + 3, 1)
                break
              case 36:
                n = d(r, 0, 1)
                break
              case 35:
                n = d(r, 11, 1)
                break
              case 33:
                n = d(r - 1, l, 1)
                break
              case 34:
                n = d(r + 1, l, 1)
            }
            n &&
              t._minYear <= n &&
              t._maxYear >= n &&
              (e.preventDefault(),
              (t._shouldFocus = !0),
              (t._prevAnim = !1),
              (t._activeMonth = +n),
              t.forceUpdate())
          } else if ("month" === s) {
            switch (e.keyCode) {
              case 37:
                n = d(r, l, c - 1 * t._rtlNr)
                break
              case 39:
                n = d(r, l, c + 1 * t._rtlNr)
                break
              case 38:
                n = d(r, l, c - 7)
                break
              case 40:
                n = d(r, l, c + 7)
                break
              case 36:
                n = d(r, l, 1)
                break
              case 35:
                n = d(r, l + 1, 0)
                break
              case 33:
                n = e.altKey
                  ? d(r - 1, l, c)
                  : u
                  ? d(r, l - 1, c)
                  : d(r, l, c - 7 * h)
                break
              case 34:
                n = e.altKey
                  ? d(r + 1, l, c)
                  : u
                  ? d(r, l + 1, c)
                  : d(r, l, c + 7 * h)
            }
            if (n && t._minDate <= n && t._maxDate >= n) {
              e.preventDefault()
              var m = Wn(n, i) - t._offset
              ;(t._shouldFocus = !0),
                (t._prevAnim = !1),
                (t._pageChange = i.noOuterChange && m !== t._pageIndex),
                t._hook("onActiveChange", {
                  date: +n,
                  pageChange: t._pageChange
                })
            }
          }
        }),
        t
      )
    }
    return (
      t(n, e),
      (n.prototype._getPageDay = function(e) {
        return +An(e + this._offset, this.s)
      }),
      (n.prototype._getPageStyle = function(e, t, n) {
        var i
        return (
          ((i = {})[(ve ? ve + "T" : "t") + "ransform"] =
            "translate" +
            this._axis +
            "(" +
            100 * (e - t) * this._rtlNr +
            "%)"),
          (i.width = 100 / (n || 1) + "%"),
          i
        )
      }),
      (n.prototype._getPageYear = function(e) {
        var t = this.s,
          n = t.refDate ? bn(t.refDate) : Rn
        return t.getYear(n) + e + this._yearOffset
      }),
      (n.prototype._getPageYears = function(e) {
        var t = this.s,
          n = t.refDate ? bn(t.refDate) : Rn
        return t.getYear(n) + 12 * (e + this._yearsOffset)
      }),
      (n.prototype._getPickerClass = function(e) {
        var t,
          n = e === this.s.selectView ? " mbsc-calendar-picker-main" : "",
          i = "mbsc-calendar-picker",
          s = this._hasPicker,
          a = this.state,
          o = a.viewClosing,
          r = a.viewOpening
        switch (e) {
          case "month":
            t = s
              ? ""
              : ("month" === r ? "in-down" : "") +
                ("month" === o ? "out-down" : "")
            break
          case "multi-year":
            t =
              s && "month" === o
                ? ""
                : ("multi-year" === r ? "in-up" : "") +
                  ("multi-year" === o ? "out-up" : "")
            break
          default:
            t =
              s && "month" === r
                ? ""
                : ("year" === r
                    ? "multi-year" === o
                      ? "in-down"
                      : "in-up"
                    : "") +
                  ("year" === o
                    ? "multi-year" === r
                      ? "out-down"
                      : "out-up"
                    : "")
        }
        return i + n + (ue && t ? " " + i + "-" + t : "")
      }),
      (n.prototype._isNextDisabled = function(e) {
        if (!this._hasPicker || e) {
          var t = this._view
          if ("multi-year" === t)
            return this._yearsIndex + 1 > this._maxYearsIndex
          if ("year" === t) return this._yearIndex + 1 > this._maxYearIndex
        }
        return this._pageIndex + 1 > this._maxIndex
      }),
      (n.prototype._isPrevDisabled = function(e) {
        if (!this._hasPicker || e) {
          var t = this._view
          if ("multi-year" === t)
            return this._yearsIndex - 1 < this._minYearsIndex
          if ("year" === t) return this._yearIndex - 1 < this._minYearIndex
        }
        return this._pageIndex - 1 < this._minIndex
      }),
      (n.prototype._render = function(e, t) {
        var n = e.getDate,
          i = e.getYear,
          s = e.getMonth,
          a = e.showCalendar,
          o = "month" === e.calendarType,
          r = "year" === e.calendarType,
          l = r ? 12 : e.size || 1,
          c = l > 1 && (o || r),
          d = a ? (o || r ? 6 : e.weeks) : 0,
          h = e.activeDate || this._active || +new Date(),
          u = h !== this._active,
          _ = new Date(h),
          m = this._prevS,
          p = e.dateFormat,
          v = e.monthNames,
          f = e.yearSuffix,
          g = A(e.labelList)
            ? +e.labelList + 1
            : "all" === e.labelList
            ? -1
            : 0,
          y = e.labelList !== m.labelList
        e.size = l
        var b =
            e.calendarType !== m.calendarType ||
            e.eventRange !== m.eventRange ||
            e.eventRangeSize !== m.eventRangeSize ||
            e.refDate !== m.refDate ||
            e.showCalendar !== m.showCalendar ||
            e.weeks !== m.weeks ||
            e.firstDay !== m.firstDay,
          D =
            this._pageChange ||
            undefined === this._pageIndex ||
            b ||
            (!this._prevPageChange &&
              u &&
              (h < +this._firstDay || h >= +this._lastDay))
              ? Wn(_, e)
              : this._pageIndex + this._offset
        ;(d === this._weeks && undefined !== this._pageIndex) ||
          (this._offset = D),
          u && (this._activeMonth = h)
        var C = Fn(new Date(this._activeMonth), e),
          w = Vn(new Date(this._activeMonth), e)
        if (
          (u && ((this._yearsOffset = C), (this._yearOffset = w)),
          (this._view = t.view || e.selectView),
          (this._yearsIndex = C - this._yearsOffset),
          (this._yearIndex = w - this._yearOffset),
          "year" === this._view)
        )
          this._viewTitle = this._getPageYear(this._yearIndex) + ""
        else if ("multi-year" === this._view) {
          var k = this._getPageYears(this._yearsIndex)
          this._viewTitle = k + " - " + (k + 11)
        }
        var x,
          T,
          S =
            ((x = e.pages),
            (T = t.pageSize),
            "auto" === x
              ? Math.max(1, Math.min(3, Math.floor(T ? T / 296 : 1)))
              : x
              ? +x
              : 1),
          E =
            "vertical" === e.calendarScroll &&
            "auto" !== e.pages &&
            (undefined === e.pages || 1 === e.pages),
          M =
            undefined !== e.showOuterDays
              ? e.showOuterDays
              : !E && S < 2 && (!o || !l || l < 2),
          L = An(D, e),
          N = An(D + S, e)
        a ||
          "week" !== e.eventRange ||
          undefined === e.startDay ||
          undefined === e.endDay ||
          ((L = kn(
            L,
            e.startDay - e.firstDay + (e.startDay < e.firstDay ? 7 : 0)
          )),
          (N = kn(
            L,
            7 * e.eventRangeSize +
              e.endDay -
              e.startDay +
              1 -
              (e.endDay < e.startDay ? 0 : 7)
          )))
        var H = a && M ? mn(L, e) : L,
          O = An(D + S - 1, e),
          I = a && M ? kn(mn(O, e), 7 * d) : N,
          z = a ? mn(An(D - 0 - 1, e), e) : L,
          P = a ? mn(An(D - 0 + S + 1 - 1, e), e) : N,
          R = a ? kn(P, 7 * d) : N,
          U = p.search(/m/i),
          W = p.search(/y/i)
        if (V(e.min))
          (this._minDate = -1 / 0),
            (this._minIndex = -1 / 0),
            (this._minYears = -1 / 0),
            (this._minYearsIndex = -1 / 0),
            (this._minYear = -1 / 0),
            (this._minYearIndex = -1 / 0)
        else {
          if (m.min !== e.min || e.getDate !== m.getDate) {
            var F = bn(e.min)
            ;(this._minDate = hn(F)),
              (this._minYear = n(i(F), s(F), 1)),
              (this._minYears = i(F))
          }
          ;(this._minIndex = Wn(this._minDate, e) - this._offset),
            (this._minYearIndex = Vn(this._minDate, e) - this._yearOffset),
            (this._minYearsIndex = Fn(this._minDate, e) - this._yearsOffset)
        }
        if (V(e.max))
          (this._maxDate = 1 / 0),
            (this._maxIndex = 1 / 0),
            (this._maxYears = 1 / 0),
            (this._maxYearsIndex = 1 / 0),
            (this._maxYear = 1 / 0),
            (this._maxYearIndex = 1 / 0)
        else {
          if (m.max !== e.max || e.getDate !== m.getDate) {
            var B = bn(e.max)
            ;(this._maxDate = B),
              (this._maxYear = n(i(B), s(B) + 1, 1)),
              (this._maxYears = i(this._maxDate))
          }
          ;(this._maxIndex = Wn(this._maxDate, e) - this._offset),
            (this._maxYearIndex = Vn(this._maxDate, e) - this._yearOffset),
            (this._maxYearsIndex = Fn(this._maxDate, e) - this._yearsOffset)
        }
        if (c && ((this._monthsMulti = []), undefined !== D)) {
          for (var X = $(t.pageSize / 296) || 1; l % X; ) X--
          for (var q = 0; q < l / X; ++q) {
            for (var G = [], K = 0; K < X; ++K)
              G.push(+n(i(L), s(L) + q * X + K, 1))
            this._monthsMulti.push(G)
          }
        }
        ;(e.theme !== m.theme ||
          e.calendarScroll !== m.calendarScroll ||
          e.calendarType !== m.calendarType ||
          e.hasContent !== m.hasContent ||
          e.showWeekNumbers !== m.showWeekNumbers ||
          e.weeks !== m.weeks ||
          y) &&
          (this._shouldCheckSize = !0),
          (m.width === e.width && m.height === e.height) ||
            (this._dim = { height: j(e.height), width: j(e.width) }),
          (this._cssClass =
            "mbsc-calendar mbsc-font" +
            this._theme +
            this._rtl +
            (t.height ? "" : " mbsc-calendar-hidden") +
            (c
              ? " mbsc-calendar-grid-view"
              : " mbsc-calendar-height-" +
                t.height +
                " mbsc-calendar-width-" +
                t.width) +
            " " +
            e.cssClass),
          (this._dayNames =
            "sm" === t.width || c ? e.dayNamesMin : e.dayNamesShort),
          (this._isSwipeChange = !1),
          (this._firstDay = L),
          (this._firstPageDay = H),
          (this._lastDay = N),
          (this._lastPageDay = I),
          (this._yearFirst = W < U),
          (this._pageNr = S),
          (this._variableRow = g)
        var J = e.pageLoad !== m.pageLoad,
          Z = +z != +this._viewStart || +R != +this._viewEnd
        if (
          (undefined !== this._pageIndex &&
            Z &&
            ((this._isIndexChange = !this._isSwipeChange && !b),
            this._hook("onPageChange", {
              firstDay: H,
              lastDay: I,
              month: o ? L : undefined,
              viewEnd: R,
              viewStart: z
            })),
          undefined !== D && (this._pageIndex = D - this._offset),
          undefined !== D &&
            (e.marked !== m.marked ||
              e.colors !== m.colors ||
              e.labels !== m.labels ||
              e.invalid !== m.invalid ||
              e.valid !== m.valid ||
              t.maxLabels !== this._maxLabels ||
              Z ||
              y ||
              J))
        ) {
          ;(Z || J) &&
            ((this._marksMap = undefined),
            (this._labelsMap = undefined),
            this._hook("onPageLoading", {
              firstDay: H,
              lastDay: I,
              month: o ? L : undefined,
              viewChanged: Z,
              viewEnd: R,
              viewStart: z
            })),
            (this._maxLabels = t.maxLabels),
            (this._viewStart = z),
            (this._viewEnd = R)
          var Q = this._labelsMap || On(e.labels, z, R, e),
            ee =
              Q &&
              Xn(
                e,
                Q,
                z,
                R,
                this._variableRow || t.maxLabels,
                7,
                !1,
                e.firstDay,
                !0,
                e.eventOrder,
                !M,
                e.showLabelCount,
                e.moreEventsText,
                e.moreEventsPluralText
              )
          ee && !this._labels && (this._shouldCheckSize = !0),
            ((ee && t.maxLabels) || !ee) &&
              (this._shouldPageLoad =
                !this._isIndexChange || this._prevAnim || !a || J),
            (this._labelsLayout = ee),
            (this._labels = Q),
            (this._marked = !Q && (this._marksMap || On(e.marked, z, R, e))),
            (this._colors = On(e.colors, z, R, e)),
            (this._valid = On(e.valid, z, R, e, !0)),
            (this._invalid = On(e.invalid, z, R, e, !0))
        }
        if (
          Z ||
          u ||
          e.monthNames !== m.monthNames ||
          e.eventRange !== m.eventRange ||
          e.eventRangeSize !== m.eventRangeSize
        ) {
          this._title = []
          var te = kn(N, -1),
            ne = undefined === D ? _ : L
          if ("week" === e.calendarType)
            for (
              var ie = 0, se = Object.keys(e.selectedDates);
              ie < se.length;
              ie++
            ) {
              var ae = se[ie]
              if (+ae >= +L && +ae < +N) {
                ne = new Date(+ae)
                break
              }
            }
          if (this._pageNr > 1)
            for (q = 0; q < S; q++) {
              var oe = n(i(L), s(L) + q, 1),
                re = i(oe) + f,
                le = v[s(oe)]
              this._title.push({ yearTitle: re, monthTitle: le })
            }
          else {
            var ce = e.eventRangeSize || 1,
              de = { yearTitle: i(ne) + f, monthTitle: v[s(ne)] },
              he =
                e.showSchedule && 1 === ce
                  ? "month"
                  : a
                  ? e.calendarType
                  : e.eventRange,
              ue = e.eventRange && !a && (!e.showSchedule || ce > 1)
            switch (he) {
              case "year":
                ;(de.title = i(L) + f),
                  ce > 1 && (de.title += " - " + (i(te) + f))
                break
              case "month":
                if (ce > 1 && !a) {
                  var _e = v[s(L)],
                    me = i(L) + f,
                    pe = this._yearFirst ? me + " " + _e : _e + " " + me,
                    ve = v[s(te)],
                    fe = i(te) + f,
                    ge = this._yearFirst ? fe + " " + ve : ve + " " + fe
                  de.title = pe + " - " + ge
                } else c && (de.title = i(L) + f)
                break
              case "day":
              case "week":
                if (ue) {
                  var ye = p.search(/d/i) < U ? "D MMM, YYYY" : "MMM D, YYYY"
                  ;(de.title = Dn(ye, L, e)),
                    ("week" === he || ce > 1) &&
                      (de.title += " - " + Dn(ye, te, e))
                }
            }
            this._title.push(de)
          }
        }
        ;(this._active = h),
          (this._activeMonth = Y(
            this._activeMonth,
            +this._minDate,
            +this._maxDate
          )),
          (this._hasPicker =
            e.hasPicker ||
            c ||
            !o ||
            !a ||
            ("md" === t.width && !1 !== e.hasPicker)),
          (this._axis = E ? "Y" : "X"),
          (this._rtlNr = !E && e.rtl ? -1 : 1),
          (this._weeks = d),
          (this._nextIcon = E
            ? e.nextIconV
            : e.rtl
            ? e.prevIconH
            : e.nextIconH),
          (this._prevIcon = E
            ? e.prevIconV
            : e.rtl
            ? e.nextIconH
            : e.prevIconH),
          (this._mousewheel = undefined === e.mousewheel ? E : e.mousewheel),
          (this._isGrid = c),
          (this._isVertical = E),
          (this._showOuter = M)
      }),
      (n.prototype._mounted = function() {
        ;(this._observer = Pn(this._el, this._onResize, this._zone)),
          (this._doc = De(this._el)),
          ye(this._doc, At, this._onDocClick)
      }),
      (n.prototype._updated = function() {
        var e = this
        if (
          (this._shouldCheckSize
            ? (setTimeout(function() {
                e._onResize()
              }),
              (this._shouldCheckSize = !1))
            : this._shouldPageLoad &&
              (this._pageLoaded(), (this._shouldPageLoad = !1)),
          this._shouldFocus &&
            setTimeout(function() {
              e._focusActive(), (e._shouldFocus = !1)
            }),
          this.s.instanceService &&
            this.s.instanceService.onComponentChange.next({}),
          (this._pageChange = !1),
          (this._prevPageChange = !1),
          this._variableRow && this._body.firstChild)
        ) {
          var t = this._body.firstChild,
            n = t.scrollHeight > t.clientHeight
          n !== this.state.hasScrollY &&
            ((this._shouldCheckSize = !0), this.setState({ hasScrollY: n }))
        }
      }),
      (n.prototype._destroy = function() {
        this._observer && this._observer.detach(),
          be(this._doc, At, this._onDocClick),
          clearTimeout(this._hoverTimer)
      }),
      (n.prototype._getActiveCell = function() {
        var e = this._view,
          t = "month" === e ? this._body : this._pickerCont,
          n = "multi-year" === e ? "year" : "year" === e ? "month" : "cell"
        return t && t.querySelector(".mbsc-calendar-" + n + '[tabindex="0"]')
      }),
      (n.prototype._focusActive = function() {
        var e = this._getActiveCell()
        e && e.focus()
      }),
      (n.prototype._pageLoaded = function() {
        this._hook("onPageLoaded", {
          activeElm: this._getActiveCell(),
          firstDay: this._firstPageDay,
          lastDay: this._lastPageDay,
          month: "month" === this.s.calendarType ? this._firstDay : undefined,
          viewEnd: this._viewEnd,
          viewStart: this._viewStart
        })
      }),
      (n.prototype._activeChange = function(e) {
        var t = this._pageIndex + e
        this._minIndex <= t &&
          this._maxIndex >= t &&
          ((this._prevAnim = !1),
          (this._pageChange = !0),
          this._hook("onActiveChange", {
            date: this._getPageDay(t),
            dir: e,
            pageChange: !0
          }))
      }),
      (n.prototype._activeYearsChange = function(e) {
        var t = this._yearsIndex + e
        if (this._minYearsIndex <= t && this._maxYearsIndex >= t) {
          var n = this._getPageYears(t)
          ;(this._prevAnim = !1),
            (this._activeMonth = +this.s.getDate(n, 0, 1)),
            this.forceUpdate()
        }
      }),
      (n.prototype._activeYearChange = function(e) {
        var t = this._yearIndex + e
        if (this._minYearIndex <= t && this._maxYearIndex >= t) {
          var n = this._getPageYear(t)
          ;(this._prevAnim = !1),
            (this._activeMonth = +this.s.getDate(n, 0, 1)),
            this.forceUpdate()
        }
      }),
      (n.prototype._prevDocClick = function() {
        var e = this
        ;(this._prevClick = !0),
          setTimeout(function() {
            e._prevClick = !1
          })
      }),
      n
    )
  })(Yt),
  Jn =
    ((Gn = {
      _id: (jn = "__cC" + ht++),
      _defaultValue: {},
      Consumer: function(e, t) {
        return e.children(t)
      },
      Provider: function(e) {
        if (!this.getChildContext) {
          var t = [],
            n = {}
          ;(n[jn] = this),
            (this.getChildContext = function() {
              return n
            }),
            (this.shouldComponentUpdate = function(e) {
              this.props.value !== e.value && t.some(Je)
            }),
            (this.sub = function(e) {
              t.push(e)
              var n = e.componentWillUnmount
              e.componentWillUnmount = function() {
                t.splice(t.indexOf(e), 1), n && n.call(e)
              }
            })
        }
        return e.children
      }
    }),
    (Gn.Provider._contextRef = Gn.Consumer.contextType = Gn)),
  $n = /*#__PURE__*/ (function(e) {
    function s() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(s, e),
      (s.prototype.componentWillUnmount = function() {
        this._changes && this._changes.unsubscribe(this._handler)
      }),
      (s.prototype.render = function() {
        var e = this,
          t = this.props,
          s = t.host,
          a = t.component,
          o = t.view,
          r = i(t, ["host", "component", "view"]),
          l = o || (s && s._calendarView)
        return (
          l &&
            !this._changes &&
            ((this._changes = l.s.instanceService.onComponentChange),
            (this._handler = this._changes.subscribe(function() {
              e.forceUpdate()
            }))),
          mt(Jn.Consumer, null, function(e) {
            var t = e.instance || o || (s && s._calendarView)
            return t && mt(a, n({ inst: t }, r))
          })
        )
      }),
      s
    )
  })(ut),
  Zn = function(e) {
    var t = e.inst,
      n = e.className
    return mt(Qt, {
      ariaLabel: t.s.prevText,
      className: "mbsc-calendar-button " + (n || ""),
      disabled: t._isPrevDisabled(),
      iconSvg: t._prevIcon,
      onClick: t.prevPage,
      theme: t.s.theme,
      themeVariant: t.s.themeVariant,
      type: "button",
      variant: "flat"
    })
  },
  Qn = function(e) {
    var t = e.inst,
      n = e.className
    return mt(Qt, {
      ariaLabel: t.s.nextText,
      disabled: t._isNextDisabled(),
      className: "mbsc-calendar-button " + (n || ""),
      iconSvg: t._nextIcon,
      onClick: t.nextPage,
      theme: t.s.theme,
      themeVariant: t.s.themeVariant,
      type: "button",
      variant: "flat"
    })
  },
  ei = function(e) {
    var t = e.inst,
      n = e.className
    return mt(
      Qt,
      {
        className:
          "mbsc-calendar-button mbsc-calendar-button-today " + (n || ""),
        onClick: t._onTodayClick,
        theme: t.s.theme,
        themeVariant: t.s.themeVariant,
        type: "button",
        variant: "flat"
      },
      t.s.todayText
    )
  },
  ti = function(e) {
    var t = e.inst,
      n = e.className
    return mt(
      "div",
      { className: (n || "") + t._theme },
      t._title.length > 0 &&
        t._title.map(function(e, n) {
          if (!(t._pageNr > 1 && n > 0) || t._hasPicker || "month" === t._view)
            return mt(
              Qt,
              {
                className: "mbsc-calendar-button",
                "data-index": n,
                onClick: t._onPickerBtnClick,
                key: n,
                theme: t.s.theme,
                themeVariant: t.s.themeVariant,
                type: "button",
                variant: "flat"
              },
              (t._hasPicker || "month" === t._view) &&
                (e.title
                  ? mt(
                      "span",
                      { className: "mbsc-calendar-title" + t._theme },
                      e.title
                    )
                  : mt(
                      Fe,
                      null,
                      t._yearFirst &&
                        mt(
                          "span",
                          {
                            className:
                              "mbsc-calendar-title mbsc-calendar-year" +
                              t._theme
                          },
                          e.yearTitle
                        ),
                      mt(
                        "span",
                        {
                          className:
                            "mbsc-calendar-title mbsc-calendar-month" + t._theme
                        },
                        e.monthTitle
                      ),
                      !t._yearFirst &&
                        mt(
                          "span",
                          {
                            className:
                              "mbsc-calendar-title mbsc-calendar-year" +
                              t._theme
                          },
                          e.yearTitle
                        )
                    )),
              !t._hasPicker &&
                "month" !== t._view &&
                mt(
                  "span",
                  { className: "mbsc-calendar-title" + t._theme },
                  t._viewTitle
                ),
              t.s.downIcon && 1 === t._pageNr
                ? mt(Ut, {
                    svg: "month" === t._view ? t.s.downIcon : t.s.upIcon,
                    theme: t.s.theme
                  })
                : null
            )
        })
    )
  },
  ni = function(e) {
    var t = e.calendar,
      s = e.view,
      a = i(e, ["calendar", "view"])
    return mt($n, n({ component: Zn, host: t, view: s }, a))
  }
ni._name = "CalendarPrev"
var ii = function(e) {
  var t = e.calendar,
    s = e.view,
    a = i(e, ["calendar", "view"])
  return mt($n, n({ component: Qn, host: t, view: s }, a))
}
ii._name = "CalendarNext"
var si = function(e) {
  var t = e.calendar,
    s = e.view,
    a = i(e, ["calendar", "view"])
  return mt($n, n({ component: ei, host: t, view: s }, a))
}
si._name = "CalendarToday"
var ai = function(e) {
  var t = e.calendar,
    s = e.view,
    a = i(e, ["calendar", "view"])
  return mt($n, n({ component: ti, host: t, view: s }, a))
}
function oi(e) {
  return (
    (this.getChildContext = function() {
      return e.context
    }),
    e.children
  )
}
function ri(e) {
  var t = this,
    n = e._container
  ;(t.componentWillUnmount = function() {
    dt(null, t._temp), (t._temp = null), (t._container = null)
  }),
    t._container && t._container !== n && t.componentWillUnmount(),
    e._vnode
      ? (t._temp ||
          ((t._container = n),
          (t._temp = {
            nodeType: 1,
            parentNode: n,
            childNodes: [],
            appendChild: function(e) {
              this.childNodes.push(e), t._container.appendChild(e)
            },
            insertBefore: function(e, n) {
              this.childNodes.push(e), t._container.appendChild(e)
            },
            removeChild: function(e) {
              this.childNodes.splice(this.childNodes.indexOf(e) >>> 1, 1),
                t._container.removeChild(e)
            }
          })),
        dt(Ae(oi, { context: t.context }, e._vnode), t._temp))
      : t._temp && t.componentWillUnmount()
}
function li(e, t) {
  return Ae(ri, { _vnode: e, _container: t })
}
ai._name = "CalendarNav"
var ci,
  di = /*#__PURE__*/ (function(e) {
    function n() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(n, e),
      (n.prototype.render = function() {
        var e = this.props.context
        return e ? li(this.props.children, e) : null
      }),
      n
    )
  })(Ve),
  hi = "input,select,textarea,button",
  ui = 'textarea,button,input[type="button"],input[type="submit"]',
  _i = hi + ',[tabindex="0"]',
  mi = { enter: 13, esc: 27, space: 32 },
  pi = h && /(iphone|ipod)/i.test(_) && o >= 7
var vi = /*#__PURE__*/ (function(e) {
    function n() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t._lastFocus = +new Date()),
        (t._onOverlayClick = function() {
          t._isOpen &&
            t.s.closeOnOverlayClick &&
            !t._preventClose &&
            t._close("overlay"),
            (t._preventClose = !1)
        }),
        (t._onDocClick = function(e) {
          t.s.showOverlay ||
            e.target === t.s.focusElm ||
            ci !== t ||
            t._onOverlayClick()
        }),
        (t._onMouseDown = function(e) {
          t.s.showOverlay || (t._target = e.target)
        }),
        (t._onMouseUp = function(e) {
          t._target &&
            t._popup &&
            t._popup.contains(t._target) &&
            !t._popup.contains(e.target) &&
            (t._preventClose = !0),
            (t._target = !1)
        }),
        (t._onPopupClick = function() {
          t.s.showOverlay || (t._preventClose = !0)
        }),
        (t._onAnimationEnd = function(e) {
          e.target === t._popup &&
            (t._isClosing &&
              (t._onClosed(),
              (t._isClosing = !1),
              t.state.isReady ? t.setState({ isReady: !1 }) : t.forceUpdate()),
            t._isOpening &&
              (t._onOpened(), (t._isOpening = !1), t.forceUpdate()))
        }),
        (t._onButtonClick = function(e) {
          var n = e.domEvent,
            i = e.button
          t._hook("onButtonClick", { domEvent: n, button: i }),
            /cancel|close|ok|set/.test(i.name) && t._close(i.name)
        }),
        (t._onFocus = function(e) {
          var n = +new Date()
          ci === t &&
            e.target.nodeType &&
            t._ctx.contains(e.target) &&
            !t._popup.contains(e.target) &&
            n - t._lastFocus > 100 &&
            e.target !== t.s.focusElm &&
            ((t._lastFocus = n), t._active.focus())
        }),
        (t._onKeyDown = function(e) {
          var n = t.s,
            i = e.keyCode,
            s = n.focusElm && !n.focusOnOpen ? n.focusElm : undefined
          if (
            (((32 === i && !He(e.target, hi)) ||
              (t._lock && (38 === i || 40 === i))) &&
              e.preventDefault(),
            n.focusTrap && 9 === i)
          ) {
            var a = t._popup.querySelectorAll(_i),
              o = [],
              r = -1,
              l = 0,
              c = -1,
              d = undefined
            Oe(a, function(e) {
              e.disabled ||
                (!e.offsetHeight && !e.offsetWidth) ||
                (o.push(e), r++, e === t._doc.activeElement && (c = r))
            }),
              e.shiftKey && ((l = r), (r = 0)),
              c === r ? (d = s || o[l]) : e.target === s && (d = o[l]),
              d && (d.focus(), e.preventDefault())
          }
        }),
        (t._onContentScroll = function(e) {
          !t._lock ||
            ("touchmove" === e.type && "stylus" === e.touches[0].touchType) ||
            e.preventDefault()
        }),
        (t._onScroll = function(e) {
          var n = t.s
          n.closeOnScroll
            ? t._close("scroll")
            : (t._hasContext || "anchored" === n.display) && t.position()
        }),
        (t._onWndKeyDown = function(e) {
          var n = t.s,
            i = e.keyCode
          if (ci === t) {
            if (
              (t._hook("onKeyDown", { keyCode: i }),
              n.closeOnEsc && 27 === i && t._close("esc"),
              13 === i && He(e.target, ui) && !e.shiftKey)
            )
              return
            if (t._buttons)
              for (var s = 0, a = t._buttons; s < a.length; s++)
                for (
                  var o = a[s],
                    r = 0,
                    l = U(o.keyCode) ? o.keyCode : [o.keyCode];
                  r < l.length;
                  r++
                ) {
                  var c = l[r]
                  if (
                    !o.disabled &&
                    undefined !== c &&
                    (c === i || mi[c] === i)
                  )
                    return void o.handler(e)
                }
          }
        }),
        (t._onResize = function() {
          var e = t._wrapper,
            n = t._hasContext
          ;(t._vpWidth = Math.min(
            e.clientWidth,
            n ? 1 / 0 : t._win.innerWidth
          )),
            (t._vpHeight = Math.min(
              e.clientHeight,
              n ? 1 / 0 : t._win.innerHeight
            )),
            (t._maxWidth = t._limitator.offsetWidth),
            (t._maxHeight =
              undefined !== t.s.maxHeight ||
              t._vpWidth < 768 ||
              t._vpHeight < 650
                ? t._limitator.offsetHeight
                : 600),
            (t._round =
              !1 === t.s.touchUi ||
              (t._popup.offsetWidth < t._vpWidth && t._vpWidth > t._maxWidth))
          var i = {
            isLarge: t._round,
            maxPopupHeight: t._maxHeight,
            maxPopupWidth: t._maxWidth,
            target: t._wrapper,
            windowHeight: t._vpHeight,
            windowWidth: t._vpWidth
          }
          !1 === t._hook("onResize", i) || i.cancel || t.position()
        }),
        t
      )
    }
    return (
      t(n, e),
      (n.prototype.open = function() {
        this._isOpen || this.setState({ isOpen: !0 })
      }),
      (n.prototype.close = function() {
        this._close()
      }),
      (n.prototype.isVisible = function() {
        return !!this._isOpen
      }),
      (n.prototype.position = function() {
        if (this._isOpen) {
          var e = this.s,
            t = this.state,
            n = this._wrapper,
            i = this._popup,
            s = this._hasContext,
            a = e.anchor,
            o = e.anchorAlign,
            r = e.rtl,
            l = ke(this._scrollCont),
            c = we(this._scrollCont),
            d = this._vpWidth,
            h = this._vpHeight,
            u = this._maxWidth,
            _ = this._maxHeight,
            m = Math.min(i.offsetWidth, u),
            p = Math.min(i.offsetHeight, _),
            v = e.showArrow
          ;(this._lock =
            e.scrollLock &&
            this._content.scrollHeight <= this._content.clientHeight),
            s && ((n.style.top = l + "px"), (n.style.left = c + "px"))
          var f =
            !1 ===
            this._hook("onPosition", {
              isLarge: this._round,
              maxPopupHeight: _,
              maxPopupWidth: u,
              target: this._wrapper,
              windowHeight: h,
              windowWidth: d
            })
          if ("anchored" !== e.display || f)
            this.setState({ height: h, isReady: !0, showArrow: v, width: d })
          else {
            var g = 0,
              y = 0,
              b = Y(t.modalLeft || 0, 8, d - m - 8),
              D = t.modalTop || 8,
              C = "bottom",
              w = {},
              k = v ? 16 : 4,
              x = (n.offsetWidth - d) / 2,
              T = (n.offsetHeight - h) / 2
            if (s) {
              var S = this._ctx.getBoundingClientRect()
              ;(y = S.top), (g = S.left)
            }
            if (a && this._ctx.contains(a)) {
              var E = a.getBoundingClientRect(),
                M = E.top - y,
                L = E.left - g,
                N = a.offsetWidth,
                H = a.offsetHeight
              if (
                ((b = Y(
                  (b =
                    ("start" === o && !r) || ("end" === o && r)
                      ? L
                      : ("end" === o && !r) || ("start" === o && r)
                      ? L + N - m
                      : L - (m - N) / 2),
                  8,
                  d - m - 8
                )),
                (D = M + H + k),
                (w = { left: Y(L + N / 2 - b - x, 30, m - 30) + "px" }),
                D + p + k > h)
              )
                if (M - p - k > 0) (C = "top"), (D = M - p - k)
                else if (!e.disableLeftRight) {
                  var O = L - m - 8 > 0
                  ;(O || L + N + m + 8 <= d) &&
                    ((D = Y(M - (p - H) / 2, 8, h - p - 8)) + p + 8 > h &&
                      (D = Math.max(h - p - 8, 0)),
                    (w = { top: Y(M + H / 2 - D - T, 30, p - 30) + "px" }),
                    (C = O ? "left" : "right"),
                    (b = O ? L - m : L + N))
                }
            }
            ;("top" !== C && "bottom" !== C) ||
              (D + p + k > h && ((D = Math.max(h - p - k, 0)), (v = !1))),
              this.setState({
                arrowPos: w,
                bubblePos: C,
                height: h,
                isReady: !0,
                modalLeft: b,
                modalTop: D,
                showArrow: v,
                width: d
              })
          }
        }
      }),
      (n.prototype._render = function(e, t) {
        "bubble" === e.display && (e.display = "anchored")
        var n = e.animation,
          i = e.display,
          s = this._prevS,
          a = "anchored" === i,
          o = "inline" !== i,
          r = e.fullScreen && o,
          l = !!o && (undefined === e.isOpen ? t.isOpen : e.isOpen)
        if (
          (l &&
            (e.windowWidth !== s.windowWidth ||
              e.display !== s.display ||
              e.showArrow !== s.showArrow ||
              (e.anchor !== s.anchor && "anchored" === e.display)) &&
            (this._shouldPosition = !0),
          (this._limits = {
            maxHeight: j(e.maxHeight),
            maxWidth: j(e.maxWidth)
          }),
          (this._style = {
            height: r ? "100%" : j(e.height),
            left: a && t.modalLeft ? t.modalLeft + "px" : "",
            maxHeight: j(this._maxHeight || e.maxHeight),
            maxWidth: j(this._maxWidth || e.maxWidth),
            top: a && t.modalTop ? t.modalTop + "px" : "",
            width: r ? "100%" : j(e.width)
          }),
          (this._hasContext = "body" !== e.context && undefined !== e.context),
          (this._needsLock =
            pi && !this._hasContext && "anchored" !== i && e.scrollLock),
          (this._isModal = o),
          (this._flexButtons =
            "center" === i ||
            (!this._touchUi && !r && ("top" === i || "bottom" === i))),
          undefined !== n && !0 !== n)
        )
          this._animation = F(n) ? n : ""
        else
          switch (i) {
            case "bottom":
              this._animation = "slide-up"
              break
            case "top":
              this._animation = "slide-down"
              break
            default:
              this._animation = "pop"
          }
        e.buttons
          ? e.buttons !== s.buttons &&
            (this._buttons = (function(e, t) {
              var n = e.s,
                i = [],
                s = {
                  cancel: {
                    cssClass: "mbsc-popup-button-close",
                    name: "cancel",
                    text: n.cancelText
                  },
                  close: {
                    cssClass: "mbsc-popup-button-close",
                    name: "close",
                    text: n.closeText
                  },
                  ok: {
                    cssClass: "mbsc-popup-button-primary",
                    keyCode: 13,
                    name: "ok",
                    text: n.okText
                  },
                  set: {
                    cssClass: "mbsc-popup-button-primary",
                    keyCode: 13,
                    name: "set",
                    text: n.setText
                  }
                }
              if (t && t.length)
                return (
                  t.forEach(function(t) {
                    var n = F(t) ? s[t] || { text: t } : t
                    ;(n.handler && !F(n.handler)) ||
                      (F(n.handler) && (n.name = n.handler),
                      (n.handler = function(t) {
                        e._onButtonClick({ domEvent: t, button: n })
                      })),
                      i.push(n)
                  }),
                  i
                )
            })(this, e.buttons))
          : (this._buttons = undefined),
          e.headerText !== s.headerText &&
            (this._headerText = e.headerText
              ? this._safeHtml(e.headerText)
              : undefined),
          l && !this._isOpen && this._onOpen(),
          !l && this._isOpen && this._onClose(),
          (this._isOpen = l),
          (this._isVisible = l || this._isClosing)
      }),
      (n.prototype._updated = function() {
        var e = this,
          t = this.s
        if (
          te &&
          (t.context !== this._prevS.context || !this._ctx) &&
          ((n = F(t.context) ? te.querySelector(t.context) : t.context) ||
            (n = te.body),
          (n.__mbscLock = n.__mbscLock || 0),
          (n.__mbscIOSLock = n.__mbscIOSLock || 0),
          (n.__mbscModals = n.__mbscModals || 0),
          (this._ctx = n),
          this._justOpened)
        )
          return void setTimeout(function() {
            e.forceUpdate()
          })
        if (this._justOpened) {
          var n = this._ctx,
            i = this._wrapper,
            s = this._hasContext,
            a = (this._doc = De(i)),
            o = (this._win = xe(i)),
            r = a.activeElement
          if (!this._hasWidth && t.responsive) {
            var l = Math.min(i.clientWidth, s ? 1 / 0 : o.innerWidth),
              c = Math.min(i.clientHeight, s ? 1 / 0 : o.innerHeight)
            if (
              ((this._hasWidth = !0),
              l !== this.state.width || c !== this.state.height)
            )
              return void setTimeout(function() {
                e.setState({ height: c, width: l })
              })
          }
          if (
            ((this._scrollCont = s ? n : o),
            (this._observer = Pn(i, this._onResize, this._zone)),
            (this._prevFocus = t.focusElm || r),
            n.__mbscModals++,
            t.focusOnOpen &&
              r &&
              setTimeout(function() {
                r.blur()
              }),
            this._needsLock)
          ) {
            if (!n.__mbscIOSLock) {
              var d = ke(this._scrollCont),
                h = we(this._scrollCont)
              ;(n.style.left = -h + "px"),
                (n.style.top = -d + "px"),
                (n.__mbscScrollLeft = h),
                (n.__mbscScrollTop = d),
                n.classList.add("mbsc-popup-open-ios"),
                n.parentNode.classList.add("mbsc-popup-open-ios")
            }
            n.__mbscIOSLock++
          }
          s && n.classList.add("mbsc-popup-ctx"),
            t.focusTrap && ye(o, "focusin", this._onFocus),
            t.focusElm &&
              !t.focusOnOpen &&
              ye(t.focusElm, "keydown", this._onKeyDown),
            ye(this._scrollCont, "touchmove", this._onContentScroll, {
              passive: !1
            }),
            ye(this._scrollCont, "wheel", this._onContentScroll, {
              passive: !1
            }),
            ye(this._scrollCont, "mousewheel", this._onContentScroll, {
              passive: !1
            }),
            setTimeout(function() {
              ye(a, Wt, e._onMouseDown),
                ye(a, Ft, e._onMouseUp),
                ye(a, At, e._onDocClick)
            }),
            this._hook("onOpen", { target: this._wrapper })
        }
        this._shouldPosition &&
          setTimeout(function() {
            e._onResize()
          }),
          (this._justOpened = !1),
          (this._justClosed = !1),
          (this._shouldPosition = !1)
      }),
      (n.prototype._destroy = function() {
        this._isOpen &&
          (this._onClosed(),
          this._unlisten(),
          ci === this && (ci = this._prevModal))
      }),
      (n.prototype._onOpen = function() {
        var e = this
        ue && this._animation
          ? ((this._isOpening = !0), (this._isClosing = !1))
          : this._onOpened(),
          (this._justOpened = !0),
          (this._preventClose = !1),
          setTimeout(function() {
            ;(e._prevModal = ci), (ci = e)
          })
      }),
      (n.prototype._onClose = function() {
        var e = this
        ue && this._animation
          ? ((this._isClosing = !0), (this._isOpening = !1))
          : setTimeout(function() {
              e._onClosed(), e.setState({ isReady: !1 })
            }),
          (this._hasWidth = !1),
          this._unlisten()
      }),
      (n.prototype._onOpened = function() {
        var e = this.s
        if (e.focusOnOpen) {
          var t = e.activeElm,
            n = t ? (F(t) ? this._popup.querySelector(t) : t) : this._active
          n && n.focus && n.focus()
        }
        ye(this._win, "keydown", this._onWndKeyDown),
          ye(this._scrollCont, "scroll", this._onScroll)
      }),
      (n.prototype._onClosed = function() {
        var e,
          t,
          n = this,
          i = this._ctx,
          s = this._prevFocus && this._prevFocus.focus && this.s.focusOnClose
        i.mbscModals--,
          (this._justClosed = !0),
          this._needsLock &&
            (i.__mbscIOSLock--,
            i.__mbscIOSLock ||
              (i.classList.remove("mbsc-popup-open-ios"),
              i.parentNode.classList.remove("mbsc-popup-open-ios"),
              (i.style.left = ""),
              (i.style.top = ""),
              (e = this._scrollCont),
              (t = i.__mbscScrollLeft),
              e.scrollTo ? e.scrollTo(t, e.scrollY) : (e.scrollLeft = t),
              (function(e, t) {
                e.scrollTo ? e.scrollTo(e.scrollX, t) : (e.scrollTop = t)
              })(this._scrollCont, i.__mbscScrollTop))),
          this._hasContext &&
            !i.mbscModals &&
            i.classList.remove("mbsc-popup-ctx"),
          this._hook("onClosed", { focus: s }),
          s && this._prevFocus.focus(),
          setTimeout(function() {
            ci === n && (ci = n._prevModal)
          })
      }),
      (n.prototype._unlisten = function() {
        be(this._win, "keydown", this._onWndKeyDown),
          be(this._scrollCont, "scroll", this._onScroll),
          be(this._scrollCont, "touchmove", this._onContentScroll, {
            passive: !1
          }),
          be(this._scrollCont, "wheel", this._onContentScroll, { passive: !1 }),
          be(this._scrollCont, "mousewheel", this._onContentScroll, {
            passive: !1
          }),
          be(this._doc, Wt, this._onMouseDown),
          be(this._doc, Ft, this._onMouseUp),
          be(this._doc, At, this._onDocClick),
          this.s.focusTrap && be(this._win, "focusin", this._onFocus),
          this.s.focusElm && be(this.s.focusElm, "keydown", this._onKeyDown),
          this._observer && (this._observer.detach(), (this._observer = null))
      }),
      (n.prototype._close = function(e) {
        this._isOpen &&
          (undefined === this.s.isOpen && this.setState({ isOpen: !1 }),
          this._hook("onClose", { source: e }))
      }),
      (n.defaults = {
        buttonVariant: "flat",
        cancelText: "Cancel",
        closeOnEsc: !0,
        closeOnOverlayClick: !0,
        closeText: "Close",
        contentPadding: !0,
        display: "center",
        focusOnClose: !0,
        focusOnOpen: !0,
        focusTrap: !0,
        maxWidth: 600,
        okText: "Ok",
        scrollLock: !0,
        setText: "Set",
        showArrow: !0,
        showOverlay: !0
      }),
      n
    )
  })(Yt),
  fi = di,
  gi = /*#__PURE__*/ (function(e) {
    function n() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t._setActive = function(e) {
          t._active = e
        }),
        (t._setContent = function(e) {
          t._content = e
        }),
        (t._setLimitator = function(e) {
          t._limitator = e
        }),
        (t._setPopup = function(e) {
          t._popup = e
        }),
        (t._setWrapper = function(e) {
          t._wrapper = e
        }),
        t
      )
    }
    return (
      t(n, e),
      (n.prototype._template = function(e, t) {
        var n = this,
          i = this._hb,
          s = this._rtl,
          a = this._theme,
          o = e.display
        return this._isModal
          ? this._isVisible
            ? mt(
                fi,
                { context: this._ctx },
                mt(
                  "div",
                  {
                    className:
                      "mbsc-font mbsc-popup-wrapper mbsc-popup-wrapper-" +
                      o +
                      a +
                      s +
                      " " +
                      this._className +
                      (e.fullScreen
                        ? " mbsc-popup-wrapper-" + o + "-full"
                        : "") +
                      (this._touchUi ? "" : " mbsc-popup-pointer") +
                      (this._round ? " mbsc-popup-round" : "") +
                      (this._hasContext ? " mbsc-popup-wrapper-ctx" : "") +
                      (t.isReady ? "" : " mbsc-popup-hidden"),
                    ref: this._setWrapper,
                    onKeyDown: this._onKeyDown
                  },
                  e.showOverlay &&
                    mt("div", {
                      className:
                        "mbsc-popup-overlay mbsc-popup-overlay-" +
                        o +
                        a +
                        (this._isClosing ? " mbsc-popup-overlay-out" : "") +
                        (this._isOpening && t.isReady
                          ? " mbsc-popup-overlay-in"
                          : ""),
                      onClick: this._onOverlayClick
                    }),
                  mt("div", {
                    className: "mbsc-popup-limits mbsc-popup-limits-" + o,
                    ref: this._setLimitator,
                    style: this._limits
                  }),
                  mt(
                    "div",
                    {
                      className:
                        "mbsc-popup " +
                        a +
                        i +
                        " mbsc-popup-" +
                        o +
                        (e.fullScreen ? "-full" : "") +
                        (t.bubblePos && t.showArrow && "anchored" === o
                          ? " mbsc-popup-anchored-" + t.bubblePos
                          : "") +
                        (this._isClosing
                          ? " mbsc-popup-" + this._animation + "-out"
                          : "") +
                        (this._isOpening && t.isReady
                          ? " mbsc-popup-" + this._animation + "-in"
                          : ""),
                      role: "dialog",
                      ref: this._setPopup,
                      style: this._style,
                      onClick: this._onPopupClick,
                      onAnimationEnd: this._onAnimationEnd
                    },
                    "anchored" === o &&
                      t.showArrow &&
                      mt(
                        "div",
                        {
                          className:
                            "mbsc-popup-arrow-wrapper mbsc-popup-arrow-wrapper-" +
                            t.bubblePos +
                            a
                        },
                        mt("div", {
                          className:
                            "mbsc-popup-arrow mbsc-popup-arrow-" +
                            t.bubblePos +
                            a,
                          style: t.arrowPos
                        })
                      ),
                    mt("div", {
                      className: "mbsc-popup-focus",
                      tabIndex: -1,
                      ref: this._setActive
                    }),
                    mt(
                      "div",
                      {
                        className:
                          "mbsc-popup-body mbsc-popup-body-" +
                          o +
                          a +
                          i +
                          (e.fullScreen
                            ? " mbsc-popup-body-" + o + "-full"
                            : "") +
                          (this._round ? " mbsc-popup-body-round" : "")
                      },
                      this._headerText &&
                        mt("div", {
                          className:
                            "mbsc-popup-header mbsc-popup-header-" +
                            o +
                            a +
                            i +
                            (this._buttons
                              ? ""
                              : " mbsc-popup-header-no-buttons"),
                          dangerouslySetInnerHTML: this._headerText
                        }),
                      mt(
                        "div",
                        {
                          className:
                            "mbsc-popup-content" +
                            (e.contentPadding ? " mbsc-popup-padding" : ""),
                          ref: this._setContent
                        },
                        e.children
                      ),
                      this._buttons &&
                        mt(
                          "div",
                          {
                            className:
                              "mbsc-popup-buttons mbsc-popup-buttons-" +
                              o +
                              a +
                              s +
                              i +
                              (this._flexButtons
                                ? " mbsc-popup-buttons-flex"
                                : "") +
                              (e.fullScreen
                                ? " mbsc-popup-buttons-" + o + "-full"
                                : "")
                          },
                          this._buttons.map(function(t, a) {
                            return mt(
                              Qt,
                              {
                                color: t.color,
                                className:
                                  "mbsc-popup-button mbsc-popup-button-" +
                                  o +
                                  s +
                                  i +
                                  (n._flexButtons
                                    ? " mbsc-popup-button-flex"
                                    : "") +
                                  " " +
                                  (t.cssClass || ""),
                                icon: t.icon,
                                disabled: t.disabled,
                                key: a,
                                theme: e.theme,
                                themeVariant: e.themeVariant,
                                variant: t.variant || e.buttonVariant,
                                onClick: t.handler
                              },
                              t.text
                            )
                          })
                        )
                    )
                  )
                )
              )
            : null
          : mt(Fe, null, e.children)
      }),
      n
    )
  })(vi)
function yi(e, t, n, i) {
  var s
  if (!(t < n || t > i)) {
    if (U(e)) {
      var a = e.length,
        o = t % a
      s = e[o >= 0 ? o : o + a]
    } else s = e(t)
    return s
  }
}
var bi = /*#__PURE__*/ (function(e) {
    function n() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t._currPos = 0),
        (t._delta = 0),
        (t._endPos = 0),
        (t._lastRaf = 0),
        (t._maxSnapScroll = 0),
        (t._margin = 0),
        (t._scrollEnd = Q(function() {
          he(t._raf), (t._raf = !1), t._onEnd(), (t._hasScrolled = !1)
        }, 200)),
        (t._onStart = function(e) {
          var n = t.s
          t._hook("onStart", {}),
            (n.changeOnEnd && t._isScrolling) ||
              (!n.mouseSwipe && !e.isTouch) ||
              !n.swipe ||
              ((t._started = !0),
              (t._hasScrolled = t._isScrolling),
              (t._currX = e.startX),
              (t._currY = e.startY),
              (t._delta = 0),
              (t._velocityX = 0),
              (t._velocityY = 0),
              (t._startPos = Te(t._scrollEl, t._isVertical)),
              (t._timestamp = +new Date()),
              t._isScrolling &&
                (he(t._raf), (t._raf = !1), t._scroll(t._startPos)))
        }),
        (t._onMove = function(e) {
          var n = e.domEvent,
            i = t.s
          t._isVertical || i.scrollLock || t._hasScrolled
            ? n.cancelable && n.preventDefault()
            : "touchmove" === n.type &&
              (Math.abs(e.deltaY) > 7 || !i.swipe) &&
              (t._started = !1),
            t._started &&
              ((t._delta = t._isVertical ? e.deltaY : e.deltaX),
              (t._hasScrolled || Math.abs(t._delta) > t._threshold) &&
                (t._hasScrolled || t._hook("onGestureStart", {}),
                (t._hasScrolled = !0),
                (t._isScrolling = !0),
                t._raf ||
                  (t._raf = de(function() {
                    return t._move(e)
                  }))))
        }),
        (t._onEnd = function() {
          if (((t._started = !1), t._hasScrolled)) {
            var e,
              n = t.s,
              i = 17 * (t._isVertical ? t._velocityY : t._velocityX),
              s = t._maxSnapScroll,
              a = t._delta
            ;(a += i * i * 0.5 * (i < 0 ? -1 : 1)),
              s && (a = Y(a, -t._round * s, t._round * s))
            var o = Y(
                J((t._startPos + a) / t._round) * t._round,
                t._min,
                t._max
              ),
              r = J((-o * t._rtlNr) / n.itemSize) + t._offset,
              l =
                a > 0 ? (t._isVertical ? 270 : 360) : t._isVertical ? 90 : 180,
              c = r - n.selectedIndex
            ;(e = n.time || Math.max(1e3, 3 * Math.abs(o - t._currPos))),
              t._hook("onGestureEnd", { direction: l, index: r }),
              (t._delta = 0),
              t._scroll(o, e),
              c &&
                !n.changeOnEnd &&
                (t._hook("onIndexChange", { index: r, diff: c }),
                n.selectedIndex === t._prevIndex &&
                  n.selectedIndex !== r &&
                  t.forceUpdate())
          }
        }),
        (t._onClick = function(e) {
          t._hasScrolled &&
            ((t._hasScrolled = !1), e.stopPropagation(), e.preventDefault())
        }),
        (t._onScroll = function(e) {
          ;(e.target.scrollTop = 0), (e.target.scrollLeft = 0)
        }),
        (t._onMouseWheel = function(e) {
          var n = t._isVertical
            ? undefined === e.deltaY
              ? e.wheelDelta || e.detail
              : e.deltaY
            : e.deltaX
          if (t._el.contains(e.target) && n && t.s.mousewheel) {
            if (
              (e.preventDefault(),
              t._hook("onStart", {}),
              t._started ||
                ((t._delta = 0),
                (t._velocityX = 0),
                (t._velocityY = 0),
                (t._startPos = t._currPos),
                t._hook("onGestureStart", {})),
              e.deltaMode && 1 === e.deltaMode && (n *= 15),
              (n = Y(-n, -t._scrollSnap, t._scrollSnap)),
              (t._delta += n),
              t._maxSnapScroll &&
                Math.abs(t._delta) > t._round * t._maxSnapScroll &&
                (n = 0),
              t._startPos + t._delta < t._min &&
                ((t._startPos = t._min), (t._delta = 0), (n = 0)),
              t._startPos + t._delta > t._max &&
                ((t._startPos = t._max), (t._delta = 0), (n = 0)),
              t._raf ||
                (t._raf = de(function() {
                  return t._move()
                })),
              !n && t._started)
            )
              return
            ;(t._hasScrolled = !0),
              (t._isScrolling = !0),
              (t._started = !0),
              t._scrollEnd()
          }
        }),
        (t._onTrackStart = function(e) {
          e.stopPropagation()
          var n = {
            domEvent: e,
            startX: Xt(e, "X", !0),
            startY: Xt(e, "Y", !0)
          }
          if (
            (t._onStart(n),
            (t._trackStartX = n.startX),
            (t._trackStartY = n.startY),
            e.target === t._scrollbarEl)
          )
            ye(t._doc, Ft, t._onTrackEnd),
              ye(t._doc, "mousemove", t._onTrackMove)
          else {
            var i = Ne(t._scrollbarContEl).top,
              s = (n.startY - i) / t._barContSize
            ;(t._startPos = t._currPos = t._max + (t._min - t._max) * s),
              (t._hasScrolled = !0),
              t._onEnd()
          }
        }),
        (t._onTrackMove = function(e) {
          var n = t._barContSize,
            i = Xt(e, "X", !0),
            s = Xt(e, "Y", !0),
            a = (t._isVertical ? s - t._trackStartY : i - t._trackStartX) / n
          t._isInfinite
            ? (t._delta = -(t._maxSnapScroll * t._round * 2 + n) * a)
            : (t._delta = (t._min - t._max - n) * a),
            (t._hasScrolled || Math.abs(t._delta) > t._threshold) &&
              (t._hasScrolled || t._hook("onGestureStart", {}),
              (t._hasScrolled = !0),
              (t._isScrolling = !0),
              t._raf ||
                (t._raf = de(function() {
                  return t._move({ endX: i, endY: s }, !t._isInfinite)
                })))
        }),
        (t._onTrackEnd = function() {
          ;(t._delta = 0),
            (t._startPos = t._currPos),
            t._onEnd(),
            be(t._doc, Ft, t._onTrackEnd),
            be(t._doc, "mousemove", t._onTrackMove)
        }),
        (t._onTrackClick = function(e) {
          e.stopPropagation()
        }),
        t
      )
    }
    return (
      t(n, e),
      (n.prototype._render = function(e, t) {
        var n = this._prevS,
          i = e.batchSize,
          s = e.batchSize3d,
          a = e.itemNr || 1,
          o = e.itemSize,
          r = e.selectedIndex,
          l = n.selectedIndex,
          c = undefined === t.index ? r : t.index,
          d = [],
          h = [],
          u = r - l,
          _ = c - this._currIndex,
          m = e.minIndex,
          p = e.maxIndex,
          v = e.items,
          f = e.offset
        ;(this._currIndex = c),
          (this._isVertical = "Y" === e.axis),
          (this._threshold = this._isVertical ? e.thresholdY : e.thresholdX),
          (this._rtlNr = !this._isVertical && e.rtl ? -1 : 1),
          (this._round = e.snap ? o : 1)
        for (var g = this._round; g > 44; ) g /= 2
        if (((this._scrollSnap = J(44 / g) * g), v)) {
          for (var y = c - i; y < c + a + i; y++)
            d.push({ key: y, data: yi(v, y, m, p) })
          if (e.scroll3d)
            for (y = c - s; y < c + a + s; y++)
              h.push({ key: y, data: yi(v, y, m, p) })
          ;(this.visibleItems = d),
            (this.visible3dItems = h),
            (this._maxSnapScroll = i),
            (this._isInfinite = "function" == typeof v)
        }
        undefined === this._offset && (this._offset = r)
        var b = -(r - this._offset) * o * this._rtlNr
        if (Math.abs(u) > i && b !== this._endPos) {
          var D = u + i * (u > 0 ? -1 : 1)
          ;(this._offset += D), (this._margin -= D)
        }
        if (
          (f && f !== n.offset && ((this._offset += f), (this._margin -= f)),
          _ && (this._margin += _),
          (this._max =
            undefined !== m ? -(m - this._offset) * o * this._rtlNr : 1 / 0),
          (this._min =
            undefined !== p
              ? -(p - this._offset - (e.spaceAround ? 0 : a - 1)) *
                o *
                this._rtlNr
              : -1 / 0),
          -1 === this._rtlNr)
        ) {
          var C = this._min
          ;(this._min = this._max), (this._max = C)
        }
        this._min > this._max && (this._min = this._max)
        var w = e.visibleSize * o
        ;(this._barContSize = w),
          (this._barSize = Math.max(20, (w * w) / (this._max - this._min + w))),
          (this._cssClass = this._className + " mbsc-ltr")
      }),
      (n.prototype._mounted = function() {
        ;(this._doc = De(this._el)),
          ye(this._el, At, this._onClick, !0),
          ye(
            this.s.scroll3d ? this._innerEl : this._el,
            "scroll",
            this._onScroll
          ),
          ye(this._doc, "mousewheel", this._onMouseWheel, {
            passive: !1,
            capture: !0
          }),
          ye(this._doc, "wheel", this._onMouseWheel, {
            passive: !1,
            capture: !0
          }),
          ye(this._scrollbarContEl, Wt, this._onTrackStart),
          ye(this._scrollbarContEl, At, this._onTrackClick),
          (this._unlisten = Zt(this._el, {
            onEnd: this._onEnd,
            onMove: this._onMove,
            onStart: this._onStart,
            prevDef: !0
          }))
      }),
      (n.prototype._updated = function() {
        var e = this.s,
          t = e.batchSize,
          n = e.itemSize,
          i = e.selectedIndex,
          s = this._prevIndex,
          a =
            !e.prevAnim && ((undefined !== s && s !== i) || this._isAnimating),
          o = -(i - this._offset) * n * this._rtlNr
        e.margin &&
          (this._scrollEl.style.marginTop = this._isVertical
            ? (this._margin - t) * n + "px"
            : ""),
          this._started ||
            this._scroll(o, a ? this._isAnimating || e.time || 1e3 : 0),
          (this._prevIndex = i)
      }),
      (n.prototype._destroy = function() {
        be(this._el, At, this._onClick, !0),
          be(
            this.s.scroll3d ? this._innerEl : this._el,
            "scroll",
            this._onScroll
          ),
          be(this._doc, "mousewheel", this._onMouseWheel, {
            passive: !1,
            capture: !0
          }),
          be(this._doc, "wheel", this._onMouseWheel, {
            passive: !1,
            capture: !0
          }),
          be(this._scrollbarContEl, Wt, this._onTrackStart),
          be(this._scrollbarContEl, At, this._onTrackClick),
          he(this._raf),
          (this._raf = !1),
          this._scroll(0),
          this._unlisten()
      }),
      (n.prototype._anim = function(e) {
        var t = this
        return (this._raf = de(function() {
          var n = t.s,
            i = +new Date()
          if (t._raf) {
            if ((t._currPos - t._endPos) * -e < 4)
              return (
                (t._currPos = t._endPos),
                (t._raf = !1),
                (t._isAnimating = 0),
                (t._isScrolling = !1),
                t._infinite(t._currPos),
                t._hook("onAnimationEnd", {}),
                void t._scrollbarContEl.classList.remove(
                  "mbsc-scroller-bar-started"
                )
              )
            i - t._lastRaf > 100 &&
              ((t._lastRaf = i),
              (t._currPos = Te(t._scrollEl, t._isVertical)),
              n.changeOnEnd || t._infinite(t._currPos)),
              (t._raf = t._anim(e))
          }
        }))
      }),
      (n.prototype._infinite = function(e) {
        var t = this.s
        if (t.itemSize) {
          var n = J((-e * this._rtlNr) / t.itemSize) + this._offset,
            i = n - this._currIndex
          i &&
            (t.changeOnEnd
              ? this._hook("onIndexChange", { index: n, diff: i })
              : this.setState({ index: n }))
        }
      }),
      (n.prototype._scroll = function(e, t) {
        var n = this.s,
          i = n.itemSize,
          s = this._isVertical,
          a = this._scrollEl.style,
          o = ve ? ve + "T" : "t",
          r = t ? fe + "transform " + J(t) + "ms " + n.easing : ""
        if (
          ((a[o + "ransform"] =
            "translate3d(" + (s ? "0," + e + "px," : e + "px,0,") + "0)"),
          (a[o + "ransition"] = r),
          (this._endPos = e),
          n.scroll3d)
        ) {
          var l = this._scrollEl3d.style,
            c = 360 / (2 * n.batchSize3d)
          ;(l[o + "ransform"] =
            "translateY(-50%) rotateX(" + (-e / i) * c + "deg)"),
            (l[o + "ransition"] = r)
        }
        if (this._scrollbarEl) {
          var d = this._scrollbarEl.style,
            h = this._isInfinite
              ? (this._maxSnapScroll * this._round - this._delta) /
                (this._maxSnapScroll * this._round * 2)
              : (e - this._max) / (this._min - this._max),
            u = Y(
              (this._barContSize - this._barSize) * h,
              0,
              this._barContSize - this._barSize
            )
          ;(d[o + "ransform"] =
            "translate3d(" + (s ? "0," + u + "px," : u + "px,0,") + "0)"),
            (d[o + "ransition"] = r)
        }
        t
          ? (he(this._raf),
            (this._isAnimating = t),
            this._scrollbarContEl.classList.add("mbsc-scroller-bar-started"),
            (this._raf = this._anim(e > this._currPos ? 1 : -1)))
          : ((this._currPos = e), n.changeOnEnd || this._infinite(e))
      }),
      (n.prototype._move = function(e, t) {
        var n = this._currX,
          i = this._currY,
          s = this._timestamp,
          a = this._maxSnapScroll
        if (e) {
          ;(this._currX = e.endX),
            (this._currY = e.endY),
            (this._timestamp = +new Date())
          var o = this._timestamp - s
          if (o > 0 && o < 100) {
            var r = (this._currX - n) / o,
              l = (this._currY - i) / o
            ;(this._velocityX = 0.7 * r + 0.3 * this._velocityX),
              (this._velocityY = 0.7 * l + 0.3 * this._velocityY)
          }
        }
        a &&
          !t &&
          (this._delta = Y(this._delta, -this._round * a, this._round * a)),
          this._scroll(
            Y(
              this._startPos + this._delta,
              this._min - this.s.itemSize,
              this._max + this.s.itemSize
            )
          ),
          (this._raf = !1)
      }),
      (n.defaults = {
        axis: "Y",
        batchSize: 40,
        easing: "cubic-bezier(0.190, 1.000, 0.220, 1.000)",
        mouseSwipe: !0,
        mousewheel: !0,
        prevDef: !0,
        selectedIndex: 0,
        spaceAround: !0,
        stopProp: !0,
        swipe: !0,
        thresholdX: 10,
        thresholdY: 5
      }),
      n
    )
  })(Yt),
  Di = /*#__PURE__*/ (function(e) {
    function n() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t._setInnerEl = function(e) {
          t._innerEl = e
        }),
        (t._setScrollEl = function(e) {
          t._scrollEl = e
        }),
        (t._setScrollEl3d = function(e) {
          t._scrollEl3d = e
        }),
        (t._setScrollbarEl = function(e) {
          t._scrollbarEl = e
        }),
        (t._setScrollbarContEl = function(e) {
          t._scrollbarContEl = e
        }),
        t
      )
    }
    return (
      t(n, e),
      (n.prototype._template = function(e) {
        var t,
          n = this,
          i = e.children
        return (
          e.itemRenderer &&
            ((i = this.visibleItems.map(function(t) {
              return e.itemRenderer(t, n._offset)
            })),
            e.scroll3d &&
              (t = this.visible3dItems.map(function(t) {
                return e.itemRenderer(t, n._offset, !0)
              }))),
          mt(
            "div",
            { ref: this._setEl, className: this._cssClass, style: e.styles },
            mt(
              "div",
              {
                ref: this._setInnerEl,
                className: e.innerClass,
                style: e.innerStyles
              },
              mt(
                "div",
                {
                  ref: this._setScrollEl,
                  className: "mbsc-scrollview-scroll" + this._rtl
                },
                i
              )
            ),
            e.scroll3d &&
              mt(
                "div",
                {
                  ref: this._setScrollEl3d,
                  style: { height: e.itemSize + "px" },
                  className: "mbsc-scroller-items-3d"
                },
                t
              ),
            mt(
              "div",
              {
                ref: this._setScrollbarContEl,
                className:
                  "mbsc-scroller-bar-cont " +
                  this._rtl +
                  (e.scrollBar && this._barSize !== this._barContSize
                    ? ""
                    : " mbsc-scroller-bar-hidden") +
                  (this._started ? " mbsc-scroller-bar-started" : "")
              },
              mt("div", {
                className: "mbsc-scroller-bar" + this._theme,
                ref: this._setScrollbarEl,
                style: { height: this._barSize + "px" }
              })
            )
          )
        )
      }),
      n
    )
  })(bi),
  Ci = /*#__PURE__*/ (function(e) {
    function n() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t._onClick = function(e) {
          t._cellClick("onDayClick", e)
        }),
        (t._onRightClick = function(e) {
          t._cellClick("onDayRightClick", e)
        }),
        (t._onLabelClick = function(e) {
          t._labelClick("onLabelClick", e)
        }),
        (t._onLabelDoubleClick = function(e) {
          t._labelClick("onLabelDoubleClick", e)
        }),
        (t._onLabelRightClick = function(e) {
          t._labelClick("onLabelRightClick", e)
        }),
        (t._onLabelHoverIn = function(e) {
          t._labelClick("onLabelHoverIn", e)
        }),
        (t._onLabelHoverOut = function(e) {
          t._labelClick("onLabelHoverOut", e)
        }),
        (t._width = function(e) {
          var n = t.s
          if (
            (undefined === e && (e = 100),
            undefined === n.dayWidths || undefined === n.dayIndex)
          )
            return e + "%"
          for (var i = e / 100, s = -3, a = n.dayIndex; a < n.dayIndex + i; a++)
            s += n.dayWidths[a]
          if (
            t._el &&
            (!t._labelContWidth || n.dayWidths !== t._prevS.dayWidths)
          ) {
            var o = t._el.querySelector(".mbsc-calendar-labels")
            t._labelContWidth = o.getBoundingClientRect().width
          }
          return t._labelContWidth
            ? (s / t._labelContWidth) * 100 + "%"
            : s + "px"
        }),
        t
      )
    }
    return (
      t(n, e),
      (n.prototype._mounted = function() {
        var e,
          t,
          n,
          i = this
        this._unlisten = Zt(this._el, {
          click: !0,
          onBlur: function() {
            i.setState({ hasFocus: !1 })
          },
          onDoubleClick: function(e) {
            var t = i.s
            t.clickToCreate &&
              "single" !== t.clickToCreate &&
              t.labels &&
              !t.disabled &&
              t.display &&
              (i._hook("onLabelUpdateStart", e),
              i._hook("onLabelUpdateEnd", e)),
              i._cellClick("onDayDoubleClick", e.domEvent)
          },
          onEnd: function(s) {
            e &&
              (s.domEvent.preventDefault(),
              i._hook("onLabelUpdateEnd", s),
              (e = !1)),
              clearTimeout(n),
              (e = !1),
              (t = !1)
          },
          onFocus: function() {
            i.setState({ hasFocus: !0 })
          },
          onHoverIn: function(e) {
            var t = i.s
            t.disabled || i.setState({ hasHover: !0 }),
              i._hook("onHoverIn", {
                date: new Date(t.date),
                domEvent: e,
                hidden: !t.display,
                outer: t.outer,
                target: i._el
              })
          },
          onHoverOut: function(e) {
            var t = i.s
            i.setState({ hasHover: !1 }),
              i._hook("onHoverOut", {
                date: new Date(t.date),
                domEvent: e,
                hidden: !t.display,
                outer: t.outer,
                target: i._el
              })
          },
          onKeyDown: function(e) {
            switch (e.keyCode) {
              case 13:
              case 32:
                e.preventDefault(), i._onClick(e)
            }
          },
          onMove: function(s) {
            e && i.s.dragToCreate
              ? (s.domEvent.preventDefault(), i._hook("onLabelUpdateMove", s))
              : t &&
                i.s.dragToCreate &&
                (Math.abs(s.deltaX) > 7 || Math.abs(s.deltaY) > 7)
              ? ((e = !s.isTouch), i._hook("onLabelUpdateStart", s))
              : clearTimeout(n)
          },
          onStart: function(s) {
            var a = i.s
            if (
              ((s.create = !0),
              !a.disabled &&
                (a.dragToCreate || a.clickToCreate) &&
                a.labels &&
                !e)
            ) {
              var o = (function(e, t, n) {
                for (; e && !He(e, t); ) {
                  if (e === n || e.nodeType === e.DOCUMENT_NODE) return null
                  e = e.parentNode
                }
                return e
              })(s.domEvent.target, ".mbsc-calendar-text", i._el)
              o ||
                (s.isTouch && a.dragToCreate
                  ? (n = setTimeout(function() {
                      i._hook("onLabelUpdateStart", s),
                        i._hook("onLabelUpdateModeOn", s),
                        (e = !0)
                    }, 350))
                  : "single" === a.clickToCreate
                  ? (i._hook("onLabelUpdateStart", s), (e = !0))
                  : (t = !s.isTouch))
            }
          }
        })
      }),
      (n.prototype._render = function(e, t) {
        var n = new Date(),
          i = e.date,
          s = e.colors,
          a = e.display,
          o = e.dragData,
          r = e.hoverEnd,
          l = e.hoverStart,
          c = e.labels,
          d = e.rangeEnd,
          h = e.rangeStart,
          u = new Date(i),
          _ = dn(u),
          m = pn(n, u),
          p = c && c.events,
          v = s && s[0],
          f = v && v.background,
          g = v && v.highlight,
          y = "",
          b = ""
        ;(this._draggedLabel = o && o.draggedDates && o.draggedDates[_]),
          (this._draggedLabelOrig = o && o.originDates && o.originDates[_]),
          (this._todayClass = m ? " mbsc-calendar-today" : ""),
          (this._cellStyles =
            f && a ? { backgroundColor: f, color: Se(f) } : undefined),
          (this._circleStyles = g
            ? { backgroundColor: g, color: Se(v.highlight) }
            : undefined),
          (this._ariaLabel =
            "day" === e.type
              ? (m ? e.todayText + ", " : "") +
                e.day +
                ", " +
                e.month +
                " " +
                e.text
              : "month" === e.type
              ? e.month
              : ""),
          a &&
            (((h && i >= h && i <= (d || h)) ||
              (d && i <= d && i >= (h || d))) &&
              (b =
                " mbsc-range-day" +
                (i === (h || d) ? " mbsc-range-day-start" : "") +
                (i === (d || h) ? " mbsc-range-day-end" : "")),
            l &&
              r &&
              i >= l &&
              i <= r &&
              (b +=
                " mbsc-range-hover" +
                (i === l ? " mbsc-range-hover-start mbsc-hover" : "") +
                (i === r ? " mbsc-range-hover-end mbsc-hover" : ""))),
          e.marks &&
            e.marks.forEach(function(e) {
              y += e.cellCssClass ? " " + e.cellCssClass : ""
            }),
          s &&
            s.forEach(function(e) {
              y += e.cellCssClass ? " " + e.cellCssClass : ""
            }),
          p &&
            p.forEach(function(e) {
              y += e.cellCssClass ? " " + e.cellCssClass : ""
            }),
          (this._cssClass =
            "mbsc-calendar-cell mbsc-flex-1-0-0 mbsc-calendar-" +
            e.type +
            this._theme +
            this._rtl +
            this._hb +
            y +
            (c ? " mbsc-calendar-day-labels" : "") +
            (s ? " mbsc-calendar-day-colors" : "") +
            (e.outer ? " mbsc-calendar-day-outer" : "") +
            (e.hasMarks ? " mbsc-calendar-day-marked" : "") +
            (e.disabled ? " mbsc-disabled" : "") +
            (a ? "" : " mbsc-calendar-day-empty") +
            (e.selected ? " mbsc-selected" : "") +
            (t.hasFocus ? " mbsc-focus" : "") +
            (!t.hasHover || (i !== l && i !== r && (l || r))
              ? ""
              : " mbsc-hover") +
            (this._draggedLabel ? " mbsc-calendar-day-highlight" : "") +
            b),
          (this._data = { date: u, events: p, selected: e.selected })
      }),
      (n.prototype._destroy = function() {
        this._unlisten()
      }),
      (n.prototype._cellClick = function(e, t) {
        var n = this.s
        n.display &&
          this._hook(e, {
            date: new Date(n.date),
            disabled: n.disabled,
            domEvent: t,
            outer: n.outer,
            selected: n.selected,
            source: "calendar",
            target: this._el
          })
      }),
      (n.prototype._labelClick = function(e, t) {
        var n = this.s
        ;(t.date = new Date(n.date)),
          (t.labels = n.labels.events),
          this._hook(e, t)
      }),
      n
    )
  })(Yt),
  wi = {},
  ki = /*#__PURE__*/ (function(e) {
    function i() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t._onClick = function(e) {
          t._isDrag ? e.stopPropagation() : t._triggerEvent("onClick", e)
        }),
        (t._onRightClick = function(e) {
          t._triggerEvent("onRightClick", e)
        }),
        (t._onDocTouch = function(e) {
          be(t._doc, "touchstart", t._onDocTouch),
            be(t._doc, Wt, t._onDocTouch),
            (t._isDrag = !1),
            t._hook("onDragModeOff", { data: t.s.event })
        }),
        (t._updateState = function(e) {
          t.s.showText && t.setState(e)
        }),
        (t._triggerEvent = function(e, n) {
          t._hook(e, { domEvent: n, label: t.s.event, target: t._el })
        }),
        t
      )
    }
    return (
      t(i, e),
      (i.prototype._mounted = function() {
        var e,
          t = this,
          i = this.s,
          s = i.event,
          a = s ? s.id + (s.nr ? "_" + s.nr : "") : i.id,
          o = i.isPicker,
          r = wi[a]
        r || ((r = new l()), (wi[a] = r)),
          (this._unsubscribe = r.subscribe(this._updateState)),
          (this._doc = De(this._el)),
          (this._unlisten = Zt(this._el, {
            keepFocus: !0,
            onBlur: function() {
              o || r.next({ hasFocus: !1 })
            },
            onDoubleClick: function(e) {
              e.domEvent.stopPropagation(),
                t._hook("onDoubleClick", {
                  domEvent: e.domEvent,
                  label: t.s.event,
                  target: t._el
                })
            },
            onEnd: function(i) {
              if (t._isDrag) {
                var s = t.s,
                  a = n({}, i)
                a.domEvent.preventDefault(),
                  (a.data = s.event),
                  s.resize && e
                    ? ((a.resize = !0), (a.direction = e))
                    : s.drag && (a.drag = !0),
                  t._hook("onDragEnd", a),
                  s.isUpdate || (t._isDrag = !1)
              }
              clearTimeout(t._touchTimer), (e = undefined)
            },
            onFocus: function() {
              o || r.next({ hasFocus: !0 })
            },
            onHoverIn: function(e) {
              t._isDrag ||
                o ||
                (r.next({ hasHover: !0 }), t._triggerEvent("onHoverIn", e))
            },
            onHoverOut: function(e) {
              r.next({ hasHover: !1 }), t._triggerEvent("onHoverOut", e)
            },
            onKeyDown: function(e) {
              var n = t.s.event
              switch (e.keyCode) {
                case 13:
                case 32:
                  t._el.click(), e.preventDefault()
                  break
                case 8:
                case 46:
                  n &&
                    !1 !== n.editable &&
                    t._hook("onDelete", {
                      domEvent: e,
                      event: n,
                      source: "calendar"
                    })
              }
            },
            onMove: function(i) {
              var s = t.s,
                a = n({}, i)
              if (((a.data = s.event), e)) (a.resize = !0), (a.direction = e)
              else {
                if (!s.drag) return
                a.drag = !0
              }
              s.event &&
                !1 !== s.event.editable &&
                (t._isDrag
                  ? (a.domEvent.preventDefault(), t._hook("onDragMove", a))
                  : (Math.abs(a.deltaX) > 7 || Math.abs(a.deltaY) > 7) &&
                    (clearTimeout(t._touchTimer),
                    a.isTouch || ((t._isDrag = !0), t._hook("onDragStart", a))))
            },
            onStart: function(i) {
              var s = t.s,
                a = n({}, i),
                o = a.domEvent.target
              if (
                ((a.data = s.event),
                s.resize && o.classList.contains("mbsc-calendar-label-resize"))
              )
                (e = o.classList.contains("mbsc-calendar-label-resize-start")
                  ? "start"
                  : "end"),
                  (a.resize = !0),
                  (a.direction = e)
              else {
                if (!s.drag) return
                a.drag = !0
              }
              s.event &&
                !1 !== s.event.editable &&
                ((!t._isDrag && a.isTouch) || a.domEvent.stopPropagation(),
                t._isDrag
                  ? t._hook("onDragStart", a)
                  : a.isTouch &&
                    (t._touchTimer = setTimeout(function() {
                      t._hook("onDragModeOn", a),
                        t._hook("onDragStart", a),
                        (t._isDrag = !0)
                    }, 350)))
            }
          })),
          this._isDrag &&
            (ye(this._doc, "touchstart", this._onDocTouch),
            ye(this._doc, Wt, this._onDocTouch))
      }),
      (i.prototype._destroy = function() {
        if (this._unsubscribe) {
          var e = this.s,
            t = e.event,
            n = t ? t.id + (t.nr ? "_" + t.nr : "") : e.id,
            i = wi[n]
          i.unsubscribe(this._unsubscribe), i.nr || delete wi[n]
        }
        be(this._doc, "touchstart", this._onDocTouch),
          be(this._doc, Wt, this._onDocTouch),
          this._unlisten && this._unlisten()
      }),
      (i.prototype._render = function(e, t) {
        var n,
          i,
          s,
          a,
          o,
          r = e.event,
          l = new Date(e.date),
          c = e.render || e.renderContent,
          d = !1
        if (
          ((this._isDrag = this._isDrag || e.isUpdate),
          (this._html = this._content = undefined),
          (this._title =
            e.more || e.count || !e.showEventTooltip
              ? undefined
              : Le(r.tooltip || r.title || r.text)),
          (this._tabIndex =
            e.isActiveMonth && e.showText && !e.count && !e.isPicker ? 0 : -1),
          r)
        ) {
          var h = r.allDay,
            u = h ? undefined : e
          ;(n = r.start ? bn(r.start, u) : null),
            (i = r.end ? bn(r.end, u) : null)
          var _ = n && i && cn(e, h, n, i, !0),
            m = kn(mn(l, e), 7),
            p = e.lastDay && e.lastDay < m ? e.lastDay : m
          ;(s = !(d = n && _ && !pn(n, _)) || (n && pn(n, l))),
            (a = !d || (_ && pn(_, l))),
            (o = !d || (e.showText ? _ < p : a)),
            (this._hasResizeStart = e.resize && s),
            (this._hasResizeEnd = e.resize && o)
          var v = r.color
          if (!v && r.resource && e.resourcesMap) {
            var f = e.resourcesMap[U(r.resource) ? r.resource[0] : r.resource]
            v = f && f.color
          }
          e.showText && (this._textColor = v ? Se(v) : undefined),
            (this._color =
              e.render || e.template
                ? undefined
                : r.textColor && !v
                ? "transparent"
                : v)
        }
        if (r && e.showText && (c || e.contentTemplate || e.template)) {
          var g = r.allDay || !n || (d && !s && !a)
          if (
            ((this._data = {
              end: !g && a && i ? Dn(e.timeFormat, i, e) : "",
              id: r.id,
              isMultiDay: d,
              original: r,
              start: !g && s && n ? Dn(e.timeFormat, n, e) : "",
              title: this._title
            }),
            c)
          ) {
            var y = c(this._data)
            F(y)
              ? ((this._html = this._safeHtml(y)), (this._shouldEnhance = !0))
              : (this._content = y)
          }
        } else
          this._html = this._safeHtml(
            e.more || e.count || (e.showText && (r.title || r.text)) || ""
          )
        this._cssClass =
          "mbsc-calendar-text" +
          this._theme +
          this._rtl +
          (t.hasFocus && !e.inactive ? " mbsc-calendar-label-active " : "") +
          (!t.hasHover || e.inactive || this._isDrag
            ? ""
            : " mbsc-calendar-label-hover") +
          (e.more
            ? " mbsc-calendar-text-more"
            : e.render || e.template
            ? " mbsc-calendar-custom-label"
            : " mbsc-calendar-label") +
          (e.inactive ? " mbsc-calendar-label-inactive" : "") +
          (e.isUpdate ? " mbsc-calendar-label-dragging" : "") +
          (e.hidden ? " mbsc-calendar-label-hidden" : "") +
          (s ? " mbsc-calendar-label-start" : "") +
          (o ? " mbsc-calendar-label-end" : "") +
          (r && !1 === r.editable ? " mbsc-readonly-event" : "")
      }),
      i
    )
  })(Yt),
  xi = /*#__PURE__*/ (function(e) {
    function n() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(n, e),
      (n.prototype._template = function(e) {
        var t = e.event && !1 !== e.event.editable
        return mt(
          "div",
          {
            className: this._cssClass,
            ref: this._setEl,
            title: this._title,
            style: { color: this._color },
            onClick: this._onClick,
            onContextMenu: this._onRightClick,
            "data-id": e.showText && e.event ? e.event.id : null,
            tabIndex: this._tabIndex
          },
          this._hasResizeStart &&
            t &&
            mt("div", {
              className:
                "mbsc-calendar-label-resize mbsc-calendar-label-resize-start" +
                this._rtl +
                (e.isUpdate ? " mbsc-calendar-label-resize-start-touch" : "")
            }),
          this._hasResizeEnd &&
            t &&
            mt("div", {
              className:
                "mbsc-calendar-label-resize mbsc-calendar-label-resize-end" +
                this._rtl +
                (e.isUpdate ? " mbsc-calendar-label-resize-end-touch" : "")
            }),
          e.showText &&
            !e.more &&
            !e.render &&
            mt("div", {
              className: "mbsc-calendar-label-background" + this._theme
            }),
          e.showText && !e.more && e.render
            ? this._html
              ? mt("div", { dangerouslySetInnerHTML: this._html })
              : this._content
            : mt(
                "div",
                {
                  className: "mbsc-calendar-label-inner" + this._theme,
                  style: { color: this._textColor }
                },
                mt(
                  "div",
                  {
                    className: "mbsc-calendar-label-text" + this._theme,
                    dangerouslySetInnerHTML: this._html,
                    style: { color: e.event && e.event.textColor }
                  },
                  this._content
                )
              )
        )
      }),
      n
    )
  })(ki),
  Ti = /*#__PURE__*/ (function(e) {
    function n() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(n, e),
      (n.prototype._renderEvent = function(e, t, n, i, s, a) {
        return mt(xi, {
          key: a,
          count: t.count
            ? t.count + " " + (t.count > 1 ? e.eventsText : e.eventText)
            : undefined,
          date: e.date,
          dataTimezone: e.dataTimezone,
          displayTimezone: e.displayTimezone,
          drag: e.dragToMove,
          resize: e.dragToResize,
          event: t.event,
          exclusiveEndDates: e.exclusiveEndDates,
          firstDay: e.firstDay,
          hidden: i,
          id: t.id,
          inactive:
            !s &&
            t.event &&
            e.dragData &&
            e.dragData.draggedEvent &&
            t.event.id === e.dragData.draggedEvent.id,
          isActiveMonth: e.isActiveMonth,
          isPicker: e.isPicker,
          isUpdate: s,
          lastDay: t.lastDay,
          more: t.more,
          resourcesMap: e.resourcesMap,
          rtl: e.rtl,
          showEventTooltip: e.showEventTooltip,
          showText: n,
          theme: e.theme,
          timeFormat: e.timeFormat,
          timezonePlugin: e.timezonePlugin,
          render: e.renderLabel,
          renderContent: e.renderLabelContent,
          onClick: this._onLabelClick,
          onDoubleClick: this._onLabelDoubleClick,
          onRightClick: this._onLabelRightClick,
          onHoverIn: this._onLabelHoverIn,
          onHoverOut: this._onLabelHoverOut,
          onDelete: e.onLabelDelete,
          onDragStart: e.onLabelUpdateStart,
          onDragMove: e.onLabelUpdateMove,
          onDragEnd: e.onLabelUpdateEnd,
          onDragModeOn: e.onLabelUpdateModeOn,
          onDragModeOff: e.onLabelUpdateModeOff
        })
      }),
      (n.prototype._renderLabel = function(e, t) {
        var n = t.id
        return t.placeholder
          ? mt("div", {
              className: "mbsc-calendar-text mbsc-calendar-text-placeholder",
              key: n
            })
          : t.more || t.count
          ? this._renderEvent(e, t, !0, !1, !1, n)
          : t.multiDay
          ? [
              mt(
                "div",
                {
                  className: "mbsc-calendar-label-wrapper",
                  style: { width: this._width(t.width) },
                  key: n
                },
                this._renderEvent(e, t, !0)
              ),
              this._renderEvent(e, t, !1, !1, !1, "-" + n)
            ]
          : this._renderEvent(e, t, t.showText, !1, !1, n)
      }),
      (n.prototype._template = function(e) {
        var t,
          n = this,
          i = this._draggedLabel,
          s = this._draggedLabelOrig,
          a = this._theme
        return (
          e.renderDay && (t = e.renderDay(this._data)),
          e.renderDayContent && (t = e.renderDayContent(this._data)),
          F(t) &&
            ((t = mt("div", { dangerouslySetInnerHTML: this._safeHtml(t) })),
            (this._shouldEnhance = !0)),
          mt(
            "div",
            {
              role: "gridcell",
              "aria-label": this._ariaLabel,
              ref: this._setEl,
              className: this._cssClass,
              tabIndex: e.disabled ? undefined : e.active ? 0 : -1,
              onClick: this._onClick,
              onContextMenu: this._onRightClick,
              style: this._cellStyles
            },
            mt(
              "div",
              {
                className:
                  "mbsc-calendar-cell-inner mbsc-calendar-" +
                  e.type +
                  "-inner" +
                  a +
                  ("day" === e.type ? "" : this._hb) +
                  (e.display ? "" : " mbsc-calendar-day-hidden")
              },
              e.renderDay
                ? t
                : mt(
                    Fe,
                    null,
                    1 === e.text &&
                      mt(
                        "div",
                        {
                          className: "mbsc-calendar-month-name" + a + this._rtl
                        },
                        e.monthShort
                      ),
                    mt(
                      "div",
                      {
                        className:
                          "mbsc-calendar-cell-text mbsc-calendar-" +
                          e.type +
                          "-text" +
                          a +
                          this._todayClass,
                        style: this._circleStyles
                      },
                      e.text
                    ),
                    e.marks &&
                      mt(
                        "div",
                        null,
                        mt(
                          "div",
                          { className: "mbsc-calendar-marks" + a + this._rtl },
                          e.marks.map(function(e, t) {
                            return mt("div", {
                              className:
                                "mbsc-calendar-mark " +
                                (e.markCssClass || "") +
                                a,
                              key: t,
                              style: { background: e.color }
                            })
                          })
                        )
                      ),
                    e.renderDayContent && t
                  ),
              e.labels &&
                mt(
                  "div",
                  null,
                  s &&
                    s.event &&
                    mt(
                      "div",
                      {
                        className:
                          "mbsc-calendar-labels mbsc-calendar-labels-dragging"
                      },
                      mt(
                        "div",
                        { style: { width: this._width(s.width || 100) } },
                        this._renderEvent(
                          e,
                          { id: 0, event: s.event },
                          !0,
                          !!e.dragData.draggedDates,
                          !0
                        )
                      )
                    ),
                  i &&
                    i.event &&
                    mt(
                      "div",
                      {
                        className:
                          "mbsc-calendar-labels mbsc-calendar-labels-dragging"
                      },
                      mt(
                        "div",
                        {
                          className: "mbsc-calendar-label-wrapper",
                          style: { width: this._width(i.width || 100) }
                        },
                        this._renderEvent(
                          e,
                          { id: 0, event: i.event },
                          !0,
                          !1,
                          !0
                        )
                      )
                    ),
                  mt(
                    "div",
                    { className: "mbsc-calendar-labels" },
                    e.labels.data.map(function(t) {
                      return n._renderLabel(e, t)
                    })
                  ),
                  mt("div", {
                    className:
                      "mbsc-calendar-text mbsc-calendar-text-placeholder"
                  })
                )
            )
          )
        )
      }),
      n
    )
  })(Ci),
  Si = function(e) {
    var t = e.dayNames,
      n = e.firstDay,
      i = e.hidden,
      s = e.rtl,
      a = e.theme,
      o = e.dayNamesShort,
      r = e.showWeekNumbers,
      l = e.hasScroll
    return mt(
      "div",
      {
        className:
          "mbsc-calendar-week-days mbsc-flex" + (i ? " mbsc-hidden" : "")
      },
      r &&
        mt("div", {
          className:
            "mbsc-calendar-week-day mbsc-flex-none mbsc-calendar-week-nr" +
            a +
            s
        }),
      R.map(function(e, i) {
        return mt(
          "div",
          {
            "aria-label": t[(i + n) % 7],
            className: "mbsc-calendar-week-day mbsc-flex-1-0-0" + a + s,
            key: i
          },
          o[(i + n) % 7]
        )
      }),
      l && mt("div", { className: "mbsc-schedule-fake-scroll-y" })
    )
  }
function Ei(e, t, n, i, s) {
  var a = dn(e)
  if ((i && +e < i) || (s && +e > s)) return !0
  if (n && n[a]) return !1
  var o = t && t[a]
  if (o)
    for (var r = 0, l = o; r < l.length; r++) {
      var c = l[r]
      if (!(c.start && c.end && pn(c.start, c.end))) return c
    }
  return !1
}
var Mi = /*#__PURE__*/ (function(e) {
    function n() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(n, e),
      (n.prototype._isActive = function(e) {
        return this.s.isActive && e === this.s.activeDate
      }),
      (n.prototype._isInvalid = function(e) {
        var t = this.s
        return Ei(new Date(e), t.invalid, t.valid, +t.min, +t.max)
      }),
      (n.prototype._isSelected = function(e) {
        return !!this.s.selectedDates[+e]
      }),
      (n.prototype._getWeekNr = function(e, t) {
        var n = new Date(t)
        return e.getWeekNumber(
          e.getDate(
            n.getFullYear(),
            n.getMonth(),
            n.getDate() + ((7 - e.firstDay + 1) % 7)
          )
        )
      }),
      (n.prototype._render = function(e) {
        var t = e.weeks,
          n = e.firstDay,
          i = new Date(e.firstPageDay),
          s = e.getYear(i),
          a = e.getMonth(i),
          o = e.getDay(i),
          r = e.getDate(s, a, o).getDay(),
          l = n - r > 0 ? 7 : 0,
          c = [],
          d = 0
        ;(this._rowHeights = []),
          (this._rows = []),
          (this._days = Array.apply(0, Array(7)))
        for (var h = 0; h < 7 * t; h++) {
          var u = e.getDate(s, a, h + n - l - r + o),
            _ = dn(u),
            m = e.getMonth(u),
            p = m !== a && "week" !== e.calendarType,
            v = e.marked && e.marked[_],
            f = v ? (e.showSingleMark ? [{}] : v) : null,
            g = e.labels && e.labels[_],
            y = g ? g.data.length : 0,
            b = h % 7 == 0
          if (e.variableRow) {
            if (b && p && h) break
            y > d && (d = y),
              h % 7 == 6 &&
                (this._rowHeights.push(
                  d * (e.labelHeight || 20) + (e.cellTextHeight || 0) + 3
                ),
                (d = 0))
          }
          b && ((c = []), this._rows.push(c)),
            c.push({
              colors: e.colors && e.colors[_],
              date: +u,
              day: e.dayNames[u.getDay()],
              display: !p || e.showOuter,
              labels: g,
              marks: f,
              month: e.monthNames[m],
              monthShort: e.monthNamesShort[m],
              outer: p,
              text: e.getDay(u)
            })
        }
      }),
      n
    )
  })(Yt),
  Li = /*#__PURE__*/ (function(e) {
    function n() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(n, e),
      (n.prototype._template = function(e) {
        var t = this,
          n = e.showWeekDays
            ? mt(Si, {
                dayNames: e.dayNames,
                dayNamesShort: e.dayNamesShort,
                firstDay: e.firstDay,
                rtl: this._rtl,
                showWeekNumbers: e.showWeekNumbers,
                theme: this._theme
              })
            : null
        return mt(
          "div",
          {
            role: "grid",
            className:
              "mbsc-calendar-table mbsc-flex-col mbsc-flex-1-1" +
              (e.isActive ? " mbsc-calendar-table-active" : "")
          },
          n,
          this._rows.map(function(n, i) {
            return mt(
              "div",
              {
                role: "row",
                className: "mbsc-calendar-row mbsc-flex mbsc-flex-1-0",
                key: i,
                style: { minHeight: t._rowHeights[i] }
              },
              e.showWeekNumbers &&
                mt(
                  "div",
                  {
                    role: "gridcell",
                    className:
                      "mbsc-calendar-cell mbsc-flex-none mbsc-calendar-day mbsc-calendar-week-nr" +
                      t._theme
                  },
                  t._getWeekNr(e, n[0].date)
                ),
              n.map(function(n, i) {
                return mt(Ti, {
                  active: n.display && t._isActive(n.date),
                  clickToCreate: e.clickToCreate,
                  colors: n.colors,
                  date: n.date,
                  day: n.day,
                  dayIndex: i,
                  dayWidths: e.cellSizes,
                  disabled: t._isInvalid(n.date),
                  display: n.display,
                  dataTimezone: e.dataTimezone,
                  displayTimezone: e.displayTimezone,
                  dragToCreate: e.dragToCreate,
                  dragToResize: e.dragToResize,
                  dragToMove: e.dragToMove,
                  eventText: e.eventText,
                  eventsText: e.eventsText,
                  exclusiveEndDates: e.exclusiveEndDates,
                  firstDay: e.firstDay,
                  hasMarks: e.hasMarks,
                  hoverEnd: e.hoverEnd,
                  hoverStart: e.hoverStart,
                  isActiveMonth: e.isActive,
                  isPicker: e.isPicker,
                  key: n.date,
                  labels: n.labels,
                  dragData: e.dragData,
                  marks: n.marks,
                  month: n.month,
                  monthShort: n.monthShort,
                  onDayClick: e.onDayClick,
                  onDayDoubleClick: e.onDayDoubleClick,
                  onDayRightClick: e.onDayRightClick,
                  onLabelClick: e.onLabelClick,
                  onLabelDoubleClick: e.onLabelDoubleClick,
                  onLabelRightClick: e.onLabelRightClick,
                  onLabelHoverIn: e.onLabelHoverIn,
                  onLabelHoverOut: e.onLabelHoverOut,
                  onLabelDelete: e.onLabelDelete,
                  onLabelUpdateStart: e.onLabelUpdateStart,
                  onLabelUpdateMove: e.onLabelUpdateMove,
                  onLabelUpdateEnd: e.onLabelUpdateEnd,
                  onLabelUpdateModeOn: e.onLabelUpdateModeOn,
                  onLabelUpdateModeOff: e.onLabelUpdateModeOff,
                  outer: n.outer,
                  renderDay: e.renderDay,
                  renderDayContent: e.renderDayContent,
                  renderLabel: e.renderLabel,
                  renderLabelContent: e.renderLabelContent,
                  rangeEnd: e.rangeEnd,
                  rangeStart: e.rangeStart,
                  resourcesMap: e.resourcesMap,
                  rtl: e.rtl,
                  showEventTooltip: e.showEventTooltip,
                  selected: t._isSelected(n.date),
                  text: n.text,
                  theme: e.theme,
                  timeFormat: e.timeFormat,
                  timezonePlugin: e.timezonePlugin,
                  todayText: e.todayText,
                  type: "day",
                  onHoverIn: e.onDayHoverIn,
                  onHoverOut: e.onDayHoverOut
                })
              })
            )
          })
        )
      }),
      n
    )
  })(Mi),
  Ni = 0,
  Hi = /*#__PURE__*/ (function(e) {
    function i() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t._setHeader = function(e) {
          t._headerElement = e
        }),
        (t._setBody = function(e) {
          t._body = e
        }),
        (t._setPickerCont = function(e) {
          t._pickerCont = e
        }),
        (t._renderMonthView = function(e, i) {
          var s = t.s,
            a = t.state
          return mt(
            Li,
            n({}, i, {
              activeDate: t._active,
              calendarType: s.calendarType,
              cellSizes: a.cellSizes,
              cellTextHeight: a.cellTextHeight,
              clickToCreate: s.clickToCreate,
              colors: t._colors,
              dayNames: s.dayNames,
              dayNamesShort: t._dayNames,
              dataTimezone: s.dataTimezone,
              displayTimezone: s.displayTimezone,
              eventText: s.eventText,
              eventsText: s.eventsText,
              exclusiveEndDates: s.exclusiveEndDates,
              firstDay: s.firstDay,
              firstPageDay: e,
              getDate: s.getDate,
              getDay: s.getDay,
              getMonth: s.getMonth,
              getWeekNumber: s.getWeekNumber,
              getYear: s.getYear,
              hasMarks: !!t._marked,
              hoverEnd: s.hoverEnd,
              hoverStart: s.hoverStart,
              isPicker: s.isPicker,
              invalid: t._invalid,
              labels: t._labelsLayout,
              labelHeight: a.labelHeight,
              marked: t._marked,
              max: t._maxDate,
              min: t._minDate,
              monthNames: s.monthNames,
              monthNamesShort: s.monthNamesShort,
              onDayClick: t._onDayClick,
              onDayDoubleClick: s.onDayDoubleClick,
              onDayRightClick: s.onDayRightClick,
              onDayHoverIn: t._onDayHoverIn,
              onDayHoverOut: t._onDayHoverOut,
              onLabelClick: t._onLabelClick,
              onLabelDoubleClick: s.onLabelDoubleClick,
              onLabelRightClick: s.onLabelRightClick,
              onLabelHoverIn: s.onLabelHoverIn,
              onLabelHoverOut: s.onLabelHoverOut,
              onLabelDelete: s.onLabelDelete,
              rangeEnd: s.rangeEnd,
              rangeStart: s.rangeStart,
              resourcesMap: s.resourcesMap,
              rtl: s.rtl,
              selectedDates: s.selectedDates,
              showEventTooltip: s.showEventTooltip,
              showOuter: t._showOuter,
              showWeekDays: !t._isVertical && !t._variableRow,
              showWeekNumbers: s.showWeekNumbers,
              showSingleMark: !!t._marksMap,
              todayText: s.todayText,
              theme: s.theme,
              timeFormat: s.timeFormat,
              timezonePlugin: s.timezonePlugin,
              valid: t._valid,
              weeks: t._weeks,
              renderDay: s.renderDay,
              renderDayContent: s.renderDayContent,
              renderLabel: s.renderLabel,
              renderLabelContent: s.renderLabelContent,
              variableRow: t._variableRow
            })
          )
        }),
        (t._renderMonth = function(e, n) {
          var i = t.s,
            s = e.key,
            a =
              s >= t._pageIndex &&
              s < t._pageIndex + t._pageNr &&
              "month" === t._view,
            o = {
              dragData: i.dragData,
              dragToCreate: i.dragToCreate,
              dragToMove: i.dragToMove,
              dragToResize: i.dragToResize,
              isActive: a,
              onLabelUpdateEnd: i.onLabelUpdateEnd,
              onLabelUpdateModeOff: i.onLabelUpdateModeOff,
              onLabelUpdateModeOn: i.onLabelUpdateModeOn,
              onLabelUpdateMove: i.onLabelUpdateMove,
              onLabelUpdateStart: i.onLabelUpdateStart
            }
          return mt(
            "div",
            {
              className:
                "mbsc-calendar-slide" +
                (a ? " mbsc-calendar-slide-active" : "") +
                t._theme +
                t._rtl,
              key: s,
              style: t._getPageStyle(s, n, t._pageNr)
            },
            t._renderMonthView(t._getPageDay(s), o)
          )
        }),
        (t._renderYears = function(e, n) {
          var i = t.s,
            s = e.key,
            a = t._getPageYears(s),
            o = i.getYear(new Date(t._active)),
            r = i.getYear(new Date(t._activeMonth))
          return mt(
            "div",
            {
              className:
                "mbsc-calendar-picker-slide mbsc-calendar-slide" +
                t._theme +
                t._rtl,
              key: s,
              style: t._getPageStyle(s, n)
            },
            mt(
              "div",
              { role: "grid", className: "mbsc-calendar-table mbsc-flex-col" },
              P.map(function(e, n) {
                return mt(
                  "div",
                  {
                    role: "row",
                    className: "mbsc-calendar-row mbsc-flex mbsc-flex-1-0",
                    key: n
                  },
                  z.map(function(e, s) {
                    var l = a + 3 * n + s,
                      c = +i.getDate(l, 0, 1)
                    return mt(Ti, {
                      active: l === r,
                      date: c,
                      display: !0,
                      selected: l === o,
                      disabled: l < t._minYears || l > t._maxYears,
                      rtl: i.rtl,
                      text: l + i.yearSuffix,
                      theme: i.theme,
                      type: "year",
                      onDayClick: t._onYearClick,
                      key: l
                    })
                  })
                )
              })
            )
          )
        }),
        (t._renderYear = function(e, n) {
          var i = t.s,
            s = e.key,
            a = t._getPageYear(s),
            o = new Date(t._activeMonth),
            r = i.getYear(o),
            l = i.getMonth(o),
            c = new Date(t._active),
            d = i.getYear(c),
            h = i.getMonth(c)
          return mt(
            "div",
            {
              className:
                "mbsc-calendar-picker-slide mbsc-calendar-slide" +
                t._theme +
                t._rtl,
              key: s,
              style: t._getPageStyle(s, n)
            },
            mt(
              "div",
              { role: "grid", className: "mbsc-calendar-table mbsc-flex-col" },
              P.map(function(e, n) {
                return mt(
                  "div",
                  {
                    role: "row",
                    className: "mbsc-calendar-row mbsc-flex mbsc-flex-1-0",
                    key: n
                  },
                  z.map(function(e, s) {
                    var o = i.getDate(a, 3 * n + s, 1),
                      c = i.getYear(o),
                      u = i.getMonth(o)
                    return mt(Ti, {
                      active: c === r && u === l,
                      date: +o,
                      display: !0,
                      selected: c === d && u === h,
                      disabled: o < t._minYear || o >= t._maxYear,
                      month: i.monthNames[u],
                      rtl: i.rtl,
                      text: i.monthNamesShort[u],
                      theme: i.theme,
                      type: "month",
                      onDayClick: t._onMonthClick,
                      key: +o
                    })
                  })
                )
              })
            )
          )
        }),
        t
      )
    }
    return (
      t(i, e),
      (i.prototype._template = function(e, t) {
        var i = this
        Ni++
        var s = this._variableRow,
          a =
            (this._isVertical || (s && 1 == +e.size)) && e.showCalendar
              ? mt(Si, {
                  dayNames: e.dayNames,
                  dayNamesShort: this._dayNames,
                  rtl: this._rtl,
                  theme: this._theme,
                  firstDay: e.firstDay,
                  hasScroll: t.hasScrollY,
                  hidden: "month" !== this._view && !this._hasPicker,
                  showWeekNumbers: e.showWeekNumbers
                })
              : null,
          o = {
            axis: this._axis,
            batchSize: 1,
            changeOnEnd: !0,
            className: "mbsc-calendar-scroll-wrapper" + this._theme,
            data: Ni,
            easing: "ease-out",
            itemSize: t.pickerSize,
            items: this._months,
            mousewheel: this._mousewheel,
            prevAnim: this._prevAnim,
            rtl: e.rtl,
            snap: !0,
            time: 200
          },
          r = mt(
            "div",
            {
              ref: this._setPickerCont,
              className: this._hasPicker ? "mbsc-calendar-picker-wrapper" : ""
            },
            ("multi-year" === t.view ||
              "multi-year" === t.viewClosing ||
              "multi-year" === e.selectView) &&
              mt(
                "div",
                {
                  onAnimationEnd: this._onViewAnimationEnd,
                  className: this._getPickerClass("multi-year")
                },
                mt(
                  Di,
                  n(
                    {
                      key: "years",
                      itemRenderer: this._renderYears,
                      maxIndex: this._maxYearsIndex,
                      minIndex: this._minYearsIndex,
                      onGestureEnd: this._onGestureEnd,
                      onIndexChange: this._onYearsPageChange,
                      selectedIndex: this._yearsIndex
                    },
                    o
                  )
                )
              ),
            ("year" === t.view ||
              "year" === t.viewClosing ||
              "year" === e.selectView) &&
              mt(
                "div",
                {
                  onAnimationEnd: this._onViewAnimationEnd,
                  className: this._getPickerClass("year")
                },
                mt(
                  Di,
                  n(
                    {
                      key: "year",
                      itemRenderer: this._renderYear,
                      maxIndex: this._maxYearIndex,
                      minIndex: this._minYearIndex,
                      onGestureEnd: this._onGestureEnd,
                      onIndexChange: this._onYearPageChange,
                      selectedIndex: this._yearIndex
                    },
                    o
                  )
                )
              )
          )
        return mt(
          "div",
          {
            className: this._cssClass,
            ref: this._setEl,
            style: this._dim,
            onClick: G
          },
          mt(
            "div",
            {
              className:
                "mbsc-calendar-wrapper mbsc-flex-col mbsc-flex-1-1" +
                this._theme +
                this._hb +
                (e.hasContent || !e.showCalendar
                  ? " mbsc-calendar-wrapper-fixed"
                  : "")
            },
            mt(
              "div",
              {
                className:
                  "mbsc-calendar-header" +
                  this._theme +
                  this._hb +
                  (this._isVertical || s
                    ? " mbsc-calendar-header-vertical"
                    : ""),
                ref: this._setHeader
              },
              e.showControls &&
                (function() {
                  var t, n
                  if (e.renderHeader)
                    F((t = e.renderHeader())) &&
                      (t !== i._headerHTML &&
                        ((i._headerHTML = t), (i._shouldEnhanceHeader = !0)),
                      (n = i._safeHtml(t)))
                  else {
                    var s = i._pageNr > 1
                    t = mt(
                      Fe,
                      null,
                      mt(ai, {
                        className:
                          "mbsc-calendar-title-wrapper" +
                          (s ? " mbsc-calendar-title-wrapper-multi" : "")
                      }),
                      mt(ni, {
                        className:
                          "mbsc-calendar-button-prev" +
                          (s ? " mbsc-calendar-button-prev-multi" : "")
                      }),
                      e.showToday &&
                        mt(si, { className: "mbsc-calendar-header-today" }),
                      mt(ii, {
                        className:
                          "mbsc-calendar-button-next" +
                          (s ? " mbsc-calendar-button-next-multi" : "")
                      })
                    )
                  }
                  var a = mt(
                    "div",
                    {
                      className: "mbsc-calendar-controls" + i._theme,
                      dangerouslySetInnerHTML: n
                    },
                    t
                  )
                  return mt(Jn.Provider, {
                    children: a,
                    value: { instance: i }
                  })
                })(),
              a
            ),
            mt(
              "div",
              {
                className:
                  "mbsc-calendar-body mbsc-flex-col mbsc-flex-1-1" +
                  this._theme,
                ref: this._setBody,
                onKeyDown: this._onKeyDown
              },
              e.showCalendar &&
                mt(
                  "div",
                  {
                    className:
                      "mbsc-calendar-body-inner mbsc-flex-col mbsc-flex-1-1" +
                      (s ? " mbsc-calendar-body-inner-variable" : "")
                  },
                  this._isGrid
                    ? mt(
                        "div",
                        {
                          className:
                            "mbsc-calendar-grid mbsc-flex-1-1 mbsc-flex-col" +
                            this._theme +
                            this._hb
                        },
                        this._monthsMulti.map(function(t, n) {
                          return mt(
                            "div",
                            {
                              key: n,
                              className:
                                "mbsc-calendar-grid-row mbsc-flex mbsc-flex-1-1"
                            },
                            t.map(function(t, n) {
                              return mt(
                                "div",
                                {
                                  key: n,
                                  className:
                                    "mbsc-calendar-grid-item mbsc-flex-col mbsc-flex-1-1" +
                                    i._theme
                                },
                                mt(
                                  "div",
                                  {
                                    className:
                                      "mbsc-calendar-month-title" + i._theme
                                  },
                                  e.monthNames[new Date(t).getMonth()]
                                ),
                                i._renderMonthView(t, { isActive: !0 })
                              )
                            })
                          )
                        })
                      )
                    : s
                    ? mt(
                        "div",
                        {
                          className:
                            "mbsc-calendar-slide mbsc-calendar-slide-active " +
                            this._getPickerClass("month")
                        },
                        this._renderMonthView(+this._firstDay, {
                          dragData: e.dragData,
                          dragToCreate: e.dragToCreate,
                          dragToMove: e.dragToMove,
                          dragToResize: e.dragToResize,
                          isActive: !0,
                          onLabelUpdateEnd: e.onLabelUpdateEnd,
                          onLabelUpdateModeOff: e.onLabelUpdateModeOff,
                          onLabelUpdateModeOn: e.onLabelUpdateModeOn,
                          onLabelUpdateMove: e.onLabelUpdateMove,
                          onLabelUpdateStart: e.onLabelUpdateStart
                        })
                      )
                    : "month" === e.selectView &&
                      mt(
                        "div",
                        {
                          className: this._getPickerClass("month"),
                          onAnimationEnd: this._onViewAnimationEnd
                        },
                        mt(
                          Di,
                          n({}, o, {
                            itemNr: this._pageNr,
                            itemSize: t.pageSize / this._pageNr,
                            itemRenderer: this._renderMonth,
                            maxIndex: this._maxIndex,
                            minIndex: this._minIndex,
                            mouseSwipe: e.mouseSwipe,
                            onAnimationEnd: this._onAnimationEnd,
                            onGestureStart: this._onGestureStart,
                            onIndexChange: this._onPageChange,
                            onStart: this._onStart,
                            selectedIndex: this._pageIndex,
                            swipe: e.swipe
                          })
                        )
                      ),
                  !this._hasPicker && r
                )
            )
          ),
          this.props.children,
          this._hasPicker &&
            mt(
              gi,
              {
                anchor: this._pickerBtn,
                closeOnScroll: !0,
                contentPadding: !1,
                context: e.context,
                cssClass: "mbsc-calendar-popup",
                display: "anchored",
                isOpen: "month" !== this._view,
                locale: e.locale,
                onClose: this._onPickerClose,
                onOpen: this._onPickerOpen,
                rtl: e.rtl,
                scrollLock: !1,
                showOverlay: !1,
                theme: e.theme,
                themeVariant: e.themeVariant
              },
              mt(
                "div",
                { onKeyDown: this._onKeyDown },
                mt(
                  "div",
                  { className: "mbsc-calendar-controls" + this._theme },
                  mt(
                    "div",
                    {
                      className:
                        "mbsc-calendar-picker-button-wrapper mbsc-calendar-title-wrapper" +
                        this._theme
                    },
                    mt(
                      Qt,
                      {
                        className: "mbsc-calendar-button",
                        onClick: this._onPickerBtnClick,
                        theme: e.theme,
                        themeVariant: e.themeVariant,
                        type: "button",
                        variant: "flat"
                      },
                      this._viewTitle,
                      e.downIcon &&
                        mt(Ut, {
                          svg: "multi-year" === t.view ? e.downIcon : e.upIcon,
                          theme: e.theme
                        })
                    )
                  ),
                  mt(Qt, {
                    className: "mbsc-calendar-button",
                    ariaLabel: e.prevText,
                    disabled: this._isPrevDisabled(!0),
                    iconSvg: this._prevIcon,
                    onClick: this.prevPage,
                    theme: e.theme,
                    themeVariant: e.themeVariant,
                    type: "button",
                    variant: "flat"
                  }),
                  mt(Qt, {
                    className: "mbsc-calendar-button",
                    ariaLabel: e.nextText,
                    disabled: this._isNextDisabled(!0),
                    iconSvg: this._nextIcon,
                    onClick: this.nextPage,
                    theme: e.theme,
                    themeVariant: e.themeVariant,
                    type: "button",
                    variant: "flat"
                  })
                ),
                r
              )
            )
        )
      }),
      (i.prototype._updated = function() {
        e.prototype._updated.call(this),
          this._shouldEnhanceHeader &&
            (Dt(this._headerElement, { view: this }),
            (this._shouldEnhanceHeader = !1))
      }),
      i
    )
  })(Kn),
  Oi = /*#__PURE__*/ (function() {
    function e() {
      ;(this.onInstanceReady = new l()), (this.onComponentChange = new l())
    }
    return (
      Object.defineProperty(e.prototype, "instance", {
        get: function() {
          return this.inst
        },
        set: function(e) {
          ;(this.inst = e), this.onInstanceReady.next(e)
        },
        enumerable: !0,
        configurable: !0
      }),
      e
    )
  })(),
  Ii = /*#__PURE__*/ (function(e) {
    function n() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(n, e),
      (n.prototype._template = function(e) {
        return mt(
          "div",
          { ref: this._setEl, className: this._cssClass },
          e.children
        )
      }),
      n
    )
  })(
    /*#__PURE__*/ (function(e) {
      function n() {
        return (null !== e && e.apply(this, arguments)) || this
      }
      return (
        t(n, e),
        (n.prototype._render = function(e) {
          this._cssClass =
            this._className + " mbsc-list-header" + this._theme + this._hb
        }),
        n
      )
    })(Yt)
  ),
  zi = /*#__PURE__*/ (function(e) {
    function s() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(s, e),
      (s.prototype._template = function(e) {
        var t = this.props
        t.actionable
        var s = t.children
        t.className,
          t.data,
          t.drag,
          t.ripple,
          t.rtl,
          t.theme,
          t.themeVariant,
          t.onHoverIn,
          t.onHoverOut,
          t.onDragEnd,
          t.onDragMove,
          t.onDragStart,
          t.onDragModeOn,
          t.onDragModeOff
        var a = i(t, [
          "actionable",
          "children",
          "className",
          "data",
          "drag",
          "ripple",
          "rtl",
          "theme",
          "themeVariant",
          "onHoverIn",
          "onHoverOut",
          "onDragEnd",
          "onDragMove",
          "onDragStart",
          "onDragModeOn",
          "onDragModeOff"
        ])
        return mt(
          "div",
          n({ tabIndex: 0, ref: this._setEl, className: this._cssClass }, a),
          s
        )
      }),
      s
    )
  })(
    /*#__PURE__*/ (function(e) {
      function i() {
        return (null !== e && e.apply(this, arguments)) || this
      }
      return (
        t(i, e),
        (i.prototype._mounted = function() {
          var e,
            t,
            i = this
          this._unlisten = Zt(this._el, {
            click: !0,
            onBlur: function() {
              i.setState({ hasFocus: !1 })
            },
            onEnd: function(s) {
              if (e) {
                var a = n({}, s)
                a.domEvent.preventDefault(),
                  (a.data = i.s.data),
                  (a.drag = !0),
                  i._hook("onDragEnd", a),
                  (e = !1)
              }
              clearTimeout(t)
            },
            onFocus: function() {
              i.setState({ hasFocus: !0 })
            },
            onHoverIn: function(e) {
              i.s.actionable && i.setState({ hasHover: !0 }),
                i._hook("onHoverIn", { domEvent: e })
            },
            onHoverOut: function(e) {
              i.setState({ hasHover: !1 }),
                i._hook("onHoverOut", { domEvent: e })
            },
            onKeyDown: function(e) {
              switch (e.keyCode) {
                case 13:
                case 32:
                  i._el.click(), e.preventDefault()
              }
            },
            onMove: function(s) {
              var a = i.s,
                o = n({}, s)
              ;(o.data = a.data),
                (o.drag = !0),
                (o.external = !0),
                (!e && o.isTouch) || o.domEvent.preventDefault(),
                e
                  ? i._hook("onDragMove", o)
                  : (Math.abs(o.deltaX) > 7 || Math.abs(o.deltaY) > 7) &&
                    (clearTimeout(t),
                    !o.isTouch &&
                      a.drag &&
                      !1 !== a.data.editable &&
                      ((e = !0), i._hook("onDragStart", o)))
            },
            onPress: function() {
              i.s.actionable && i.setState({ isActive: !0 })
            },
            onRelease: function() {
              i.setState({ isActive: !1 })
            },
            onStart: function(s) {
              var a = i.s
              return (
                s.isTouch &&
                  a.drag &&
                  !1 !== a.data.editable &&
                  !e &&
                  (t = setTimeout(function() {
                    var t = n({}, s)
                    ;(t.data = a.data),
                      (t.drag = !0),
                      i._hook("onDragModeOn", t),
                      i._hook("onDragStart", t),
                      (e = !0)
                  }, 350)),
                { ripple: a.actionable && a.ripple }
              )
            }
          })
        }),
        (i.prototype._render = function(e, t) {
          this._cssClass =
            this._className +
            " mbsc-list-item" +
            this._theme +
            this._hb +
            this._rtl +
            (e.actionable ? " mbsc-list-item-actionable" : "") +
            (t.hasFocus ? " mbsc-focus" : "") +
            (t.hasHover ? " mbsc-hover" : "") +
            (t.isActive ? " mbsc-active" : "")
        }),
        (i.prototype._destroy = function() {
          this._unlisten()
        }),
        (i.defaults = { actionable: !0, ripple: !1 }),
        (i._name = "ListItem"),
        i
      )
    })(Yt)
  ),
  Pi = /*#__PURE__*/ (function(e) {
    function n() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(n, e),
      (n.prototype._template = function(e) {
        return mt(
          "div",
          { ref: this._setEl, className: this._cssClass },
          e.children
        )
      }),
      n
    )
  })(
    /*#__PURE__*/ (function(e) {
      function n() {
        return (null !== e && e.apply(this, arguments)) || this
      }
      return (
        t(n, e),
        (n.prototype._render = function(e) {
          this._cssClass =
            this._className + this._rtl + " mbsc-font mbsc-list" + this._theme
        }),
        n
      )
    })(Yt)
  ),
  Ri = new l()
function Yi(e) {
  return Ri.subscribe(e)
}
function Ui(e) {
  Ri.unsubscribe(e)
}
var Ai = /*#__PURE__*/ (function(e) {
    function i() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(i, e),
      (i.prototype._render = function(e) {
        e.dragData !== this._prevS.dragData &&
          (this._dragData = F(e.dragData)
            ? JSON.parse(e.dragData.toString())
            : e.dragData)
      }),
      (i.prototype._updated = function() {
        var e = this,
          t = this.s.element || this._el
        if (undefined === this._unlisten && t) {
          var i, s, a
          t.classList.add("mbsc-draggable")
          var o = De(t).body,
            r = function(e) {
              ;(i.style.left = e.endX + "px"), (i.style.top = e.endY + "px")
            }
          this._unlisten = Zt(t, {
            onEnd: function(t) {
              if (s) {
                var r = n({}, t)
                r.domEvent.preventDefault(),
                  (r.action = "externalDrop"),
                  (r.event = e._dragData),
                  (r.create = !0),
                  (r.eventName = "onDragEnd"),
                  Ri.next(r),
                  (s = !1),
                  o.removeChild(i)
              }
              clearTimeout(a)
            },
            onMove: function(t) {
              var l = n({}, t)
              ;(l.event = e._dragData),
                (l.clone = i),
                (l.create = !0),
                (l.external = !0),
                (!s && l.isTouch) || l.domEvent.preventDefault(),
                s
                  ? (r(t), (l.eventName = "onDragMove"), Ri.next(l))
                  : (Math.abs(l.deltaX) > 7 || Math.abs(l.deltaY) > 7) &&
                    (clearTimeout(a),
                    l.isTouch ||
                      (r(t),
                      o.appendChild(i),
                      (l.eventName = "onDragStart"),
                      Ri.next(l),
                      (s = !0)))
            },
            onStart: function(l) {
              var c = n({}, l)
              s ||
                ((i = t.cloneNode(!0)).classList.add("mbsc-drag-clone"),
                (c.event = e._dragData),
                (c.create = !0),
                (c.external = !0),
                c.isTouch &&
                  (a = setTimeout(function() {
                    r(l),
                      o.appendChild(i),
                      (c.clone = i),
                      (c.eventName = "onDragModeOn"),
                      Ri.next(c),
                      (c.eventName = "onDragStart"),
                      Ri.next(c),
                      (s = !0)
                  }, 350)))
            }
          })
        }
      }),
      (i.prototype._destroy = function() {
        this._unlisten && this._unlisten()
      }),
      i
    )
  })(Yt),
  Wi = 0
function Fi(e, t, n) {
  "jsonp" === n
    ? (function(e, t) {
        if (ne) {
          var n = te.createElement("script"),
            i = "mbscjsonp" + ++Wi
          ;(ne[i] = function(e) {
            n.parentNode.removeChild(n), delete ne[i], e && t(e)
          }),
            (n.src = e + (e.indexOf("?") >= 0 ? "&" : "?") + "callback=" + i),
            te.body.appendChild(n)
        }
      })(e, t)
    : (function(e, t) {
        var n = new XMLHttpRequest()
        n.open("GET", e, !0),
          (n.onload = function() {
            n.status >= 200 && n.status < 400 && t(JSON.parse(n.response))
          }),
          (n.onerror = function() {}),
          n.send()
      })(e, t)
}
var Vi,
  Bi = { getJson: Fi }
function Xi(e) {
  return (
    Vi || (Vi = ji.luxon.DateTime.local().zoneName), e && "local" !== e ? e : Vi
  )
}
y.http = Bi
var qi = /*#__PURE__*/ (function() {
    function e(e, t) {
      void 0 === t && (t = "utc"), (this._mbsc = !0), (t = Xi(t))
      var i = ji.luxon.DateTime,
        s = { zone: t }
      if (((this.zone = t), B(e))) this.dt = i.utc().setZone(t)
      else if (gn(e) || W(e)) this.dt = i.fromMillis(+e, s)
      else if (F(e)) this.dt = i.fromISO(e, s)
      else if (U(e)) {
        for (
          var a = [
              "year",
              "month",
              "day",
              "hour",
              "minute",
              "second",
              "millisecond"
            ],
            o = {},
            r = 0;
          r < e.length && r < 7;
          r++
        )
          o[a[r]] = e[r] + (1 === r ? 1 : 0)
        1 === i.fromObject.length
          ? (this.dt = i.fromObject(n({}, o, s)))
          : (this.dt = i.fromObject(o, s))
      }
    }
    return (
      (e.prototype.clone = function() {
        return new e(this, this.zone)
      }),
      (e.prototype.createDate = function(e, t, n, i, s, a, o) {
        return ji.createDate(
          { displayTimezone: this.zone },
          e,
          t,
          n,
          i,
          s,
          a,
          o
        )
      }),
      (e.prototype[Symbol.toPrimitive] = function(e) {
        return this.dt.toJSDate()[Symbol.toPrimitive](e)
      }),
      (e.prototype.toDateString = function() {
        return this.dt.toFormat("ccc MMM dd yyyy")
      }),
      (e.prototype.toISOString = function() {
        return this.dt.toISO()
      }),
      (e.prototype.toJSON = function() {
        return this.dt.toISO()
      }),
      (e.prototype.valueOf = function() {
        return this.dt.valueOf()
      }),
      (e.prototype.getDate = function() {
        return this.dt.day
      }),
      (e.prototype.getDay = function() {
        return this.dt.weekday % 7
      }),
      (e.prototype.getFullYear = function() {
        return this.dt.year
      }),
      (e.prototype.getHours = function() {
        return this.dt.hour
      }),
      (e.prototype.getMilliseconds = function() {
        return this.dt.millisecond
      }),
      (e.prototype.getMinutes = function() {
        return this.dt.minute
      }),
      (e.prototype.getMonth = function() {
        return this.dt.month - 1
      }),
      (e.prototype.getSeconds = function() {
        return this.dt.second
      }),
      (e.prototype.getTime = function() {
        return this.valueOf()
      }),
      (e.prototype.getTimezoneOffset = function() {
        return -this.dt.offset
      }),
      (e.prototype.getUTCDate = function() {
        return this.dt.toUTC().day
      }),
      (e.prototype.getUTCDay = function() {
        return this.dt.toUTC().weekday % 7
      }),
      (e.prototype.getUTCFullYear = function() {
        return this.dt.toUTC().year
      }),
      (e.prototype.getUTCHours = function() {
        return this.dt.toUTC().hour
      }),
      (e.prototype.getUTCMilliseconds = function() {
        return this.dt.toUTC().millisecond
      }),
      (e.prototype.getUTCMinutes = function() {
        return this.dt.toUTC().minute
      }),
      (e.prototype.getUTCMonth = function() {
        return this.dt.toUTC().month - 1
      }),
      (e.prototype.getUTCSeconds = function() {
        return this.dt.toUTC().second
      }),
      (e.prototype.setMilliseconds = function(e) {
        return this.setter({ millisecond: e }).millisecond
      }),
      (e.prototype.setSeconds = function(e, t) {
        return this.setter({ second: e, millisecond: t }).second
      }),
      (e.prototype.setMinutes = function(e, t, n) {
        return this.setter({ minute: e, second: t, millisecond: n }).minute
      }),
      (e.prototype.setHours = function(e, t, n, i) {
        return this.setter({ hour: e, minute: t, second: n, millisecond: i })
          .hour
      }),
      (e.prototype.setDate = function(e) {
        return this.setter({ day: e }).day
      }),
      (e.prototype.setMonth = function(e, t) {
        return e++, this.setter({ month: e, day: t }).month - 1
      }),
      (e.prototype.setFullYear = function(e, t, n) {
        return this.setter({ year: e, month: t, day: n }).year
      }),
      (e.prototype.setTime = function(e) {
        return (this.dt = ji.luxon.DateTime.fromMillis(e)), this.dt.valueOf()
      }),
      (e.prototype.setTimezone = function(e) {
        ;(e = Xi(e)), (this.zone = e), (this.dt = this.dt.setZone(e))
      }),
      (e.prototype.setUTCMilliseconds = function(e) {
        return 0
      }),
      (e.prototype.setUTCSeconds = function(e, t) {
        return 0
      }),
      (e.prototype.setUTCMinutes = function(e, t, n) {
        return 0
      }),
      (e.prototype.setUTCHours = function(e, t, n, i) {
        return 0
      }),
      (e.prototype.setUTCDate = function(e) {
        return 0
      }),
      (e.prototype.setUTCMonth = function(e, t) {
        return 0
      }),
      (e.prototype.setUTCFullYear = function(e, t, n) {
        return 0
      }),
      (e.prototype.toUTCString = function() {
        return ""
      }),
      (e.prototype.toTimeString = function() {
        return ""
      }),
      (e.prototype.toLocaleDateString = function() {
        return ""
      }),
      (e.prototype.toLocaleTimeString = function() {
        return ""
      }),
      (e.prototype.setter = function(e) {
        return (this.dt = this.dt.set(e)), this.dt
      }),
      e
    )
  })(),
  ji = {
    luxon: undefined,
    parse: function(e, t) {
      return new qi(e, t.dataTimezone || t.displayTimezone)
    },
    createDate: function(e, t, n, i, s, a, o, r) {
      var l = e.displayTimezone
      return X(t) || F(t) || B(n)
        ? new qi(t, l)
        : new qi([t || 1970, n || 0, i || 1, s || 0, a || 0, o || 0, r || 0], l)
    }
  }
function Gi(e) {
  return e && "local" !== e ? e : Ji.moment.tz.guess()
}
var Ki = /*#__PURE__*/ (function() {
    function e(e, t) {
      ;(this._mbsc = !0), (this.timezone = Gi(t)), this.init(e)
    }
    return (
      (e.prototype.clone = function() {
        return new e(this, this.timezone)
      }),
      (e.prototype.createDate = function(e, t, n, i, s, a, o) {
        return Ji.createDate(
          { displayTimezone: this.timezone },
          e,
          t,
          n,
          i,
          s,
          a,
          o
        )
      }),
      (e.prototype[Symbol.toPrimitive] = function(e) {
        return this.m.toDate()[Symbol.toPrimitive](e)
      }),
      (e.prototype.toDateString = function() {
        return this.m.format("ddd MMM DD YYYY")
      }),
      (e.prototype.toISOString = function() {
        return this.m.toISOString()
      }),
      (e.prototype.toJSON = function() {
        return this.m.toISOString()
      }),
      (e.prototype.valueOf = function() {
        return this.m.valueOf()
      }),
      (e.prototype.getDate = function() {
        return this.m.date()
      }),
      (e.prototype.getDay = function() {
        return this.m.day()
      }),
      (e.prototype.getFullYear = function() {
        return this.m.year()
      }),
      (e.prototype.getHours = function() {
        return this.m.hours()
      }),
      (e.prototype.getMilliseconds = function() {
        return this.m.milliseconds()
      }),
      (e.prototype.getMinutes = function() {
        return this.m.minutes()
      }),
      (e.prototype.getMonth = function() {
        return this.m.month()
      }),
      (e.prototype.getSeconds = function() {
        return this.m.seconds()
      }),
      (e.prototype.getTime = function() {
        return this.m.valueOf()
      }),
      (e.prototype.getTimezoneOffset = function() {
        return -this.m.utcOffset()
      }),
      (e.prototype.getUTCDate = function() {
        return this.utc().date()
      }),
      (e.prototype.getUTCDay = function() {
        return this.utc().day()
      }),
      (e.prototype.getUTCFullYear = function() {
        return this.utc().year()
      }),
      (e.prototype.getUTCHours = function() {
        return this.utc().hours()
      }),
      (e.prototype.getUTCMilliseconds = function() {
        return this.utc().milliseconds()
      }),
      (e.prototype.getUTCMinutes = function() {
        return this.utc().minutes()
      }),
      (e.prototype.getUTCMonth = function() {
        return this.utc().month()
      }),
      (e.prototype.getUTCSeconds = function() {
        return this.utc().seconds()
      }),
      (e.prototype.setMilliseconds = function(e) {
        return this.m.set({ millisecond: e }).milliseconds()
      }),
      (e.prototype.setSeconds = function(e, t) {
        return this.m.set({ seconds: e, milliseconds: t }).seconds()
      }),
      (e.prototype.setMinutes = function(e, t, n) {
        return this.m.set({ minutes: e, seconds: t, milliseconds: n }).minutes()
      }),
      (e.prototype.setHours = function(e, t, n, i) {
        return this.m
          .set({ hours: e, minutes: t, seconds: n, milliseconds: i })
          .hours()
      }),
      (e.prototype.setDate = function(e) {
        return this.m.set({ date: e }).date()
      }),
      (e.prototype.setMonth = function(e, t) {
        return this.m.set({ month: e, date: t }).month()
      }),
      (e.prototype.setFullYear = function(e, t, n) {
        return this.m.set({ year: e, month: t, date: n }).year()
      }),
      (e.prototype.setTime = function(e) {
        return this.init(e), this.m.valueOf()
      }),
      (e.prototype.setTimezone = function(e) {
        ;(this.timezone = Gi(e)), this.m.tz(this.timezone)
      }),
      (e.prototype.setUTCMilliseconds = function(e) {
        return 0
      }),
      (e.prototype.setUTCSeconds = function(e, t) {
        return 0
      }),
      (e.prototype.setUTCMinutes = function(e, t, n) {
        return 0
      }),
      (e.prototype.setUTCHours = function(e, t, n, i) {
        return 0
      }),
      (e.prototype.setUTCDate = function(e) {
        return 0
      }),
      (e.prototype.setUTCMonth = function(e, t) {
        return 0
      }),
      (e.prototype.setUTCFullYear = function(e, t, n) {
        return 0
      }),
      (e.prototype.toUTCString = function() {
        return ""
      }),
      (e.prototype.toTimeString = function() {
        return ""
      }),
      (e.prototype.toLocaleDateString = function() {
        return ""
      }),
      (e.prototype.toLocaleTimeString = function() {
        return ""
      }),
      (e.prototype.init = function(e) {
        var t = Ji.moment.tz,
          n = B(e) || F(e) || W(e) || U(e) ? e : +e,
          i = F(e) && an.test(e)
        this.m = i ? t(n, "HH:mm:ss", this.timezone) : t(n, this.timezone)
      }),
      (e.prototype.utc = function() {
        return this.m.clone().utc()
      }),
      e
    )
  })(),
  Ji = {
    moment: undefined,
    parse: function(e, t) {
      return new Ki(e, t.dataTimezone || t.displayTimezone)
    },
    createDate: function(e, t, n, i, s, a, o, r) {
      var l = e.displayTimezone
      return X(t) || F(t) || B(n)
        ? new Ki(t, l)
        : new Ki([t || 1970, n || 0, i || 1, s || 0, a || 0, o || 0, r || 0], l)
    }
  },
  $i = 1
function Zi(e, t, i, s, a, o) {
  var r = i,
    l = s,
    c = new Map(),
    d = []
  a && (r = bn(a, t)), o ? (l = bn(o, t)) : a && (l = kn(r, 1))
  var h = On(e, r, l, t)
  for (var u in h)
    if (u)
      for (var _ = 0, m = h[u]; _ < m.length; _++) {
        var p = m[_],
          v = bn(p.start, t),
          f = bn(p.end, t)
        if (p.start) {
          if (!c.has(p) && ln(r, l, v, f)) {
            var g = n({}, p)
            ;(t.dataTimezone || t.displayTimezone) &&
              ((g.start = v.toISOString()), (g.end = f.toISOString())),
              c.set(p, !0),
              d.push(g)
          }
        } else d.push(p)
      }
  return d
}
function Qi() {
  return "mbsc_" + $i++
}
function es(e, t, n, i, s, a, o, r, l, c) {
  var d = t.color || (r && r.color),
    h = new Date(n),
    u = t.start || t.date,
    _ = t.recurring ? t.original.start : t.start,
    m = t.allDay || !_,
    p = u ? bn(u, m ? undefined : e) : null,
    v = t.end ? bn(t.end, m ? undefined : e) : null,
    f = cn(e, t.allDay, p, v, l),
    g = p && f && !pn(p, f),
    y = !g || pn(p, h),
    b = !g || pn(f, h),
    D = m || (!c && g && !y && !b),
    C = !D && (y || c) && p ? Dn(s, p) : "",
    w = !D && (b || c) && v ? Dn(s, v) : "",
    k = t.title || t.text || "",
    x = Le(k),
    T = x + (D ? "" : ", " + C + " - " + w)
  return {
    allDay: m,
    allDayText: D ? a : "",
    color: d,
    currentResource: r,
    end: w,
    endDate: v || (p ? new Date(p) : null),
    html: k,
    id: t.id,
    isMultiDay: g,
    lastDay: !D && g && b ? o : "",
    original: t,
    position: {},
    resource: t.resource,
    slot: t.slot,
    start: C,
    startDate: p,
    style: { background: d, color: i && d ? Se(d) : "" },
    title: x,
    tooltip: e.showEventTooltip ? t.tooltip || T : undefined,
    uid: t.id + (t.recurring ? "_" + t.nr : "")
  }
}
function ts(e) {
  var t = []
  if (e)
    for (var n = 0, i = e; n < i.length; n++) {
      var s = i[n]
      undefined === s.id && (s.id = Qi()), t.push(s)
    }
  return t
}
function ns(e, t, n, i, s, a, o, r) {
  if ("start-end" === o) {
    var l = Ei(n, e, t, s, a),
      c = Ei(i, e, t, s, a)
    if (l) return l
    if (c) return c
  } else
    for (
      var d = r ? i : hn(kn(i, 1)), h = hn(n);
      h < d;
      h.setDate(h.getDate() + 1)
    ) {
      var u = Ei(h, e, t, s, a)
      if (u) return u
    }
  return !1
}
var is = /*#__PURE__*/ (function(e) {
    function i() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t.state = {
          activeDate: undefined,
          eventList: [],
          popoverList: [],
          selectedDate: undefined
        }),
        (t.print = G),
        (t._pageLoad = 0),
        (t._selectedDates = {}),
        (t._shouldScrollSchedule = 0),
        (t._update = 0),
        (t._onScroll = Z(function() {
          if (!t._isListScrolling && !t._viewChanged)
            for (var e in t._listDays)
              if (t._listDays[e]) {
                var n = t._listDays[e]
                if (n.offsetTop + n.offsetHeight - t._list.scrollTop > 0) {
                  ;+e !== t._selected &&
                    ((t._shouldSkipScroll = !0),
                    t.setState({ selectedDate: +e }),
                    t._selectedChange(new Date(+e)))
                  break
                }
              }
        })),
        (t._isListScrolling = 0),
        (t._onWeekDayClick = function(e) {
          e !== t._selected &&
            ((t._skipScheduleScroll = !0),
            t.setState({ selectedDate: e }),
            t._selectedChange(new Date(e)))
        }),
        (t._onDayClick = function(e) {
          var n = +e.date,
            i = dn(e.date),
            s = t.state,
            a = qn(t._eventMap[i], t.s.eventOrder),
            o = t._showEventPopover,
            r =
              undefined === o
                ? !t._showEventLabels && !t._showEventList && !t._showSchedule
                : o,
            l = !1 !== o && t._moreLabelClicked,
            c =
              (r || l) &&
              (!s.showPopover || (s.showPopover && n !== s.popoverDate)) &&
              a &&
              a.length > 0
          ;(e.events = a),
            t._hook("onCellClick", e),
            (t._moreLabelClicked = !1),
            e.disabled ||
              (t.setState({ selectedDate: n }),
              n !== t._selected &&
                ((t._skipScheduleScroll = !0), t._selectedChange(e.date))),
            c &&
              setTimeout(function() {
                ;(t._anchor = e.target),
                  (t._popoverClass = t._popoverClass.replace(
                    " mbsc-popover-hidden",
                    ""
                  )),
                  t.setState({
                    popoverDate: n,
                    popoverList: a.map(function(e) {
                      return t._getEventData(e, n)
                    }),
                    showPopover: !0
                  })
              })
        }),
        (t._onActiveChange = function(e) {
          var n = t._getValidDay(e.date, e.dir),
            i = { activeDate: n }
          ;(t._active = n),
            t._update++,
            (t._skipScheduleScroll = e.pageChange && !e.nav),
            (e.pageChange || e.today) &&
              ((i.selectedDate = n), t._selectedChange(new Date(n))),
            t.setState(i)
        }),
        (t._onGestureStart = function(e) {
          t._hidePopover()
        }),
        (t._onDayDoubleClick = function(e) {
          t._dayClick("onCellDoubleClick", e)
        }),
        (t._onDayRightClick = function(e) {
          t._dayClick("onCellRightClick", e)
        }),
        (t._onCellHoverIn = function(e) {
          ;(e.events = t._eventMap[dn(e.date)]), t._hook("onCellHoverIn", e)
        }),
        (t._onCellHoverOut = function(e) {
          ;(e.events = t._eventMap[dn(e.date)]), t._hook("onCellHoverOut", e)
        }),
        (t._onEventHoverIn = function(e) {
          t._hoverTimer = setTimeout(function() {
            ;(t._isHover = !0), t._eventClick("onEventHoverIn", e)
          }, 150)
        }),
        (t._onEventHoverOut = function(e) {
          clearTimeout(t._hoverTimer),
            t._isHover &&
              ((t._isHover = !1), t._eventClick("onEventHoverOut", e))
        }),
        (t._onEventClick = function(e) {
          !1 !== t._eventClick("onEventClick", e) && t._hidePopover()
        }),
        (t._onEventDoubleClick = function(e) {
          t._eventClick("onEventDoubleClick", e)
        }),
        (t._onEventRightClick = function(e) {
          t._eventClick("onEventRightClick", e)
        }),
        (t._onLabelHoverIn = function(e) {
          t._hoverTimer = setTimeout(function() {
            ;(t._isHover = !0), t._labelClick("onEventHoverIn", e)
          }, 150)
        }),
        (t._onLabelHoverOut = function(e) {
          clearTimeout(t._hoverTimer),
            t._isHover &&
              ((t._isHover = !1), t._labelClick("onEventHoverOut", e))
        }),
        (t._onLabelClick = function(e) {
          t._hook("onLabelClick", e),
            t._labelClick("onEventClick", e),
            e.label || (t._moreLabelClicked = !0)
        }),
        (t._onLabelDoubleClick = function(e) {
          t._labelClick("onEventDoubleClick", e)
        }),
        (t._onLabelRightClick = function(e) {
          t._labelClick("onEventRightClick", e)
        }),
        (t._onCellClick = function(e) {
          t._cellClick("onCellClick", e)
        }),
        (t._onCellDoubleClick = function(e) {
          t._cellClick("onCellDoubleClick", e)
        }),
        (t._onCellRightClick = function(e) {
          t._cellClick("onCellRightClick", e)
        }),
        (t._onPageChange = function(e) {
          setTimeout(function() {
            t._hidePopover()
          }),
            (t._isPageChange = !0),
            t._hook("onPageChange", e)
        }),
        (t._onPageLoading = function(e) {
          var n = t.s,
            i = On(t._events, e.viewStart, e.viewEnd, n)
          ;(t._colorsMap = On(n.colors, e.viewStart, e.viewEnd, n)),
            (t._invalidsMap = On(n.invalid, e.viewStart, e.viewEnd, n, !0)),
            (t._validsMap = On(n.valid, e.viewStart, e.viewEnd, n, !0)),
            (t._eventMap = i),
            (t._firstDay = mn(e.firstDay, n, t._firstWeekDay)),
            (t._lastDay = e.lastDay),
            n.labels || (!t._showEventLabels && !t._showEventCount)
              ? n.marked || (e.inst._marksMap = i)
              : (e.inst._labelsMap = i),
            e.viewChanged && t._hook("onPageLoading", e)
        }),
        (t._onPageLoaded = function(e) {
          ;(t._shouldAnimateScroll = t._isPageChange), (t._isPageChange = !1)
          var n = t._showEventList || t._showSchedule || t._showTimeline,
            i = t._showSchedule
              ? t._scheduleType
              : t._showTimeline
              ? t._timelineType
              : t._eventListType
          if (n && (!t._showCalendar || "day" !== i)) {
            var s = t.s,
              a = e.month,
              o = t._showEventList && a && "month" === i,
              r = o ? a : e.firstDay,
              l = o
                ? s.getDate(s.getYear(a), s.getMonth(a) + t._eventListSize, 1)
                : e.lastDay
            t._setEventList(r, l)
          }
          t._hook("onPageLoaded", e)
        }),
        (t._onPopoverClose = function() {
          t._hidePopover()
        }),
        (t._onResize = function(e) {
          var n
          if (t._showEventList && h) {
            var i = e.target,
              s = i.offsetHeight,
              a = i.getBoundingClientRect().top
            n = s - t._list.getBoundingClientRect().top + a > 170
          }
          t.setState({ height: e.height, isListScrollable: n, width: e.width })
        }),
        (t._getDragDates = function(e, n, i) {
          for (
            var s = {},
              a = t._firstWeekDay,
              o = cn(t.s, i.allDay, e, n, !0),
              r = hn(kn(o, 1)),
              l = hn(e);
            l < r;
            l.setDate(l.getDate() + 1)
          ) {
            var c = l.getDay(),
              d = a - c > 0 ? 7 : 0
            pn(e, l) || c === a
              ? (s[dn(l)] = {
                  event: i,
                  width: 100 * Math.min(_n(l, o) + 1, 7 + a - c - d)
                })
              : (s[dn(l)] = {})
          }
          return s
        }),
        (t._onLabelUpdateModeOn = function(e) {
          var n = e.create ? t._tempEvent : e.data
          if (n) {
            var i = bn(n.start),
              s = bn(n.end || i)
            t.setState({
              isTouchDrag: !0,
              labelDragData: {
                draggedEvent: n,
                originDates: e.external ? undefined : t._getDragDates(i, s, n)
              }
            })
          }
        }),
        (t._onLabelUpdateModeOff = function(e) {
          t.setState({ isTouchDrag: !1, labelDragData: undefined })
        }),
        (t._onLabelUpdateStart = function(e) {
          var i = t.s,
            s = t._el,
            a = t._showWeekNumbers
              ? s
                  .querySelector(".mbsc-calendar-week-nr")
                  .getBoundingClientRect().width
              : 0,
            o = s.querySelectorAll(".mbsc-calendar-slide")[
              "all" === t._calendarLabelList || A(t._calendarLabelList) ? 0 : 1
            ],
            r = o.getBoundingClientRect(),
            l = s.querySelector(".mbsc-calendar-week-days"),
            c = o.querySelectorAll(".mbsc-calendar-row")
          if (((t._areaTop = 0), l)) {
            var d = l.getBoundingClientRect()
            t._areaTop = d.top + d.height
          }
          ;(t._areaLeft = r.left + (i.rtl ? 0 : a)),
            (t._areaBottom = r.top + r.height),
            (t._areaRight = t._areaLeft + r.width - (i.rtl ? a : 0)),
            (t._calCellWidth = (t._areaRight - t._areaLeft) / 7)
          var h = 0
          ;(t._rowTops = []),
            c.forEach(function(n, i) {
              var s = n.getBoundingClientRect().top - t._areaTop
              t._rowTops.push(s), e.endY - t._areaTop > s && (h = i)
            })
          var u = e.create ? undefined : i,
            _ = $(
              (i.rtl ? t._areaRight - e.endX : e.endX - t._areaLeft) /
                t._calCellWidth
            ),
            m = kn(t._firstDay, 7 * h + _),
            p = yn(u, m.getFullYear(), m.getMonth(), m.getDate()),
            v = kn(p, 1),
            f = i.exclusiveEndDates ? v : yn(u, +v - 1)
          if (e.create) {
            var g = i.extendDefaultEvent
              ? i.extendDefaultEvent({ start: p })
              : undefined
            t._tempEvent = n(
              { allDay: !0, end: f, id: Qi(), start: p, title: i.newEventText },
              e.event,
              g
            )
          }
        }),
        (t._onLabelUpdateMove = function(e) {
          var i = t.s,
            s = e.create ? t._tempEvent : e.data,
            a = s.allDay ? undefined : i
          if (
            e.endY > t._areaTop &&
            e.endY < t._areaBottom &&
            e.endX > t._areaLeft &&
            e.endX < t._areaRight
          ) {
            var o = t.state.labelDragData,
              r = $(
                (i.rtl ? t._areaRight - e.endX : e.endX - t._areaLeft) /
                  t._calCellWidth
              ),
              l = $(
                (i.rtl ? t._areaRight - e.startX : e.startX - t._areaLeft) /
                  t._calCellWidth
              ),
              c = 0,
              d = 0
            t._rowTops.forEach(function(n, i) {
              e.startY - t._areaTop > n && (d = i),
                e.endY - t._areaTop > n && (c = i)
            })
            var h = 7 * (c - d) + (r - l)
            if (r !== t._tempDay || c !== t._tempWeek) {
              var u = bn(s.start, a),
                _ = bn(s.end, a) || u,
                m = n({}, s),
                p = u,
                v = _
              if (e.external) {
                var f = rn(u),
                  g = +_ - +u
                ;(p = yn(i, +kn(t._firstDay, 7 * c + r) + f)),
                  (v = yn(i, +p + g))
              } else if (e.drag) (p = kn(u, h)), (v = kn(_, h))
              else {
                var y = i.rtl ? -1 : 1,
                  b = e.create
                    ? c === d
                      ? e.deltaX * y > 0
                      : h > 0
                    : "end" === e.direction,
                  D = _n(u, _)
                b ? (v = kn(_, Math.max(-D, h))) : (p = kn(u, Math.min(D, h))),
                  v < p && (b ? (v = yn(a, p)) : (p = yn(a, v)))
              }
              ;(m.start = p),
                (m.end = v),
                /mbsc-popover-hidden/.test(t._popoverClass) ||
                  (t._popoverClass = t._popoverClass + " mbsc-popover-hidden"),
                t.setState({
                  labelDragData: {
                    draggedDates: t._getDragDates(p, v, m),
                    draggedEvent: m,
                    originDates: o && o.originDates
                  }
                }),
                (t._tempDay = r),
                (t._tempWeek = c)
            }
          }
        }),
        (t._onLabelUpdateEnd = function(e) {
          var n = t.state,
            i = e.create,
            s = n.labelDragData || {},
            a = i ? t._tempEvent : e.data,
            o = s.draggedEvent || a,
            r = bn(a.start),
            l = bn(a.end),
            c = bn(o.start),
            d = bn(o.end),
            h = i || +r != +c || +l != +d,
            u = { allDay: a.allDay, endDate: d, original: a, startDate: c },
            _ =
              !h ||
              t._onEventDragEnd({
                action: e.action || (n.labelDragData ? "drag" : "click"),
                collision: ns(
                  t._invalidsMap,
                  t._validsMap,
                  c,
                  d,
                  t._minDate,
                  t._maxDate,
                  t.s.invalidateEvent,
                  t.s.exclusiveEndDates
                ),
                create: i,
                domEvent: e.domEvent,
                event: u,
                source: "calendar"
              }),
            m = n.isTouchDrag && (!i || _)
          t.setState({
            isTouchDrag: m,
            labelDragData: m
              ? {
                  draggedEvent: o,
                  originDates: _
                    ? t._getDragDates(c, d, u.original)
                    : s.originDates
                }
              : {}
          }),
            e.drag && t._hidePopover(),
            (t._tempWeek = -1),
            (t._tempDay = -1)
        }),
        (t._onEventDragEnd = function(e) {
          var i = t.s,
            s = e.action,
            a = e.resource,
            o = e.slot,
            r = e.collision,
            l = e.create,
            c = e.source,
            d = e.event,
            h = d.original,
            u = h.recurring ? h.original : h,
            _ = n({}, u),
            m = n({}, u),
            p = tn(h.start, i),
            v = tn(d.startDate, i),
            f = tn(d.endDate, i),
            g = d.allDay,
            y = m.recurring
          y
            ? (m.recurringException = Nn(m.recurringException).concat([p]))
            : ((m.allDay = g),
              (m.start = v),
              (m.end = f),
              undefined !== a && (m.resource = a),
              undefined !== o && (m.slot = o))
          var b = !1,
            D = y ? n({}, u) : u
          if (
            ((l || y) &&
              (y && delete D.recurring,
              (y || undefined === D.id) && (D.id = Qi()),
              undefined !== a && (D.resource = a),
              undefined !== o && (D.slot = o),
              (D.start = v),
              (D.end = f),
              (D.allDay = g),
              (b =
                !1 !==
                t._hook(
                  "onEventCreate",
                  n(
                    { action: s, domEvent: e.domEvent, event: D, source: c },
                    y && { originEvent: h }
                  )
                )),
              !1 !== r &&
                ((b = !1),
                t._hook(
                  "onEventCreateFailed",
                  n(
                    { action: s, event: D, invalid: r, source: c },
                    y && { originEvent: h }
                  )
                ))),
            (l && !y) ||
              ((b =
                !1 !==
                t._hook(
                  "onEventUpdate",
                  n(
                    { domEvent: e.domEvent, event: m, oldEvent: _, source: c },
                    y && { newEvent: D, oldEventOccurrence: h }
                  )
                )),
              !1 !== r &&
                ((b = !1),
                t._hook(
                  "onEventUpdateFailed",
                  n(
                    { event: m, invalid: r, oldEvent: _, source: c },
                    y && { newEvent: D, oldEventOccurrence: h }
                  )
                ))),
            b &&
              ((l || y) &&
                (t._events.push(D),
                (t._triggerCreated = { action: s, event: D, source: c })),
              (l && !y) ||
                (y
                  ? ((d.id = D.id),
                    (d.original = D),
                    (u.recurringException = m.recurringException))
                  : ((u.start = v),
                    (u.end = f),
                    (u.allDay = g),
                    undefined !== a && (u.resource = a),
                    undefined !== o && (u.slot = o)),
                (t._triggerUpdated = { event: u, oldEvent: _, source: c })),
              (t._refresh = !0),
              "calendar" !== c))
          ) {
            var C = void 0,
              w = void 0
            t._showCalendar && "day" === t._scheduleType
              ? (w = hn(kn((C = new Date(t._selected)), 1)))
              : ((C = t._firstDay), (w = t._lastDay)),
              (t._eventMap = On(t._events, C, w, i)),
              t.forceUpdate()
          }
          return b
        }),
        (t._onExternalDrag = function(e) {
          if (t.s.externalDrop && t._showCalendar)
            switch (e.eventName) {
              case "onDragModeOff":
                t._onLabelUpdateModeOff(e)
                break
              case "onDragModeOn":
                t._onLabelUpdateModeOn(e)
                break
              case "onDragStart":
                t._onLabelUpdateStart(e)
                break
              case "onDragMove":
                var n = e.clone
                e.endY > t._areaTop &&
                e.endY < t._areaBottom &&
                e.endX > t._areaLeft &&
                e.endX < t._areaRight
                  ? ((n.style.display = "none"),
                    t._onLabelUpdateMove(e),
                    (t._onCalendar = !0))
                  : t._onCalendar &&
                    ((n.style.display = "table"),
                    t.setState({ labelDragData: {} }),
                    (t._tempWeek = -1),
                    (t._tempDay = -1),
                    (t._onCalendar = !1))
                break
              case "onDragEnd":
                e.endY > t._areaTop &&
                e.endY < t._areaBottom &&
                e.endX > t._areaLeft &&
                e.endX < t._areaRight
                  ? t._onLabelUpdateEnd(e)
                  : t.setState({ labelDragData: undefined })
            }
        }),
        (t._onEventDelete = function(e) {
          var i = e.event
          if (t.s.dragToCreate || t.s.clickToCreate)
            if (i.recurring) {
              var s = i.original,
                a = n({}, s),
                o = n({}, s),
                r = tn(i.start, t.s)
              ;(o.recurringException = Nn(o.recurringException).concat([r])),
                !1 !==
                  t._hook("onEventUpdate", {
                    domEvent: e.domEvent,
                    event: o,
                    oldEvent: a
                  }) &&
                  ((s.recurringException = o.recurringException),
                  (t._triggerUpdated = {
                    event: s,
                    oldEvent: a,
                    source: e.source
                  })),
                t.refresh()
            } else {
              !1 !==
                t._hook("onEventDelete", { domEvent: e.domEvent, event: i }) &&
                ((t._events = t._events.filter(function(e) {
                  return e.id !== i.id
                })),
                (t._triggerDeleted = { event: i, source: e.source }),
                t.refresh())
            }
        }),
        t
      )
    }
    return (
      t(i, e),
      (i.prototype.addEvent = function(e) {
        for (var t = [], n = 0, i = ts(U(e) ? e : [e]); n < i.length; n++) {
          var s = i[n]
          t.push("" + s.id), this._events.push(s)
        }
        return this.refresh(), t
      }),
      (i.prototype.getEvents = function(e, t) {
        return Zi(this._events, this.s, this._firstDay, this._lastDay, e, t)
      }),
      (i.prototype.getInvalids = function(e, t) {
        return Zi(this.s.invalid, this.s, this._firstDay, this._lastDay, e, t)
      }),
      (i.prototype.setEvents = function(e) {
        for (var t = [], n = ts(e), i = 0, s = n; i < s.length; i++) {
          var a = s[i]
          t.push("" + a.id)
        }
        return (this._events = n), this.refresh(), t
      }),
      (i.prototype.removeEvent = function(e) {
        for (
          var t = U(e) ? e : [e], n = this._events, i = n.length, s = 0, a = t;
          s < a.length;
          s++
        )
          for (var o = a[s], r = !1, l = 0; !r && l < i; ) {
            var c = n[l]
            ;(c.id !== o && c.id !== o.id) || ((r = !0), n.splice(l, 1)), l++
          }
        this.refresh()
      }),
      (i.prototype.navigate = function(e, t) {
        var n = +bn(e),
          i = n !== this._selectedDateTime
        i && (this._shouldAnimateScroll = !!t),
          undefined === this.s.selectedDate
            ? (!this._showSchedule && !this._showTimeline) || i
              ? this.setState({ selectedDate: n })
              : (this._shouldScrollSchedule++, this.forceUpdate())
            : i && this._selectedChange(e)
      }),
      (i.prototype.updateEvent = function(e) {
        for (
          var t = U(e) ? e : [e], i = this._events, s = i.length, a = 0, o = t;
          a < o.length;
          a++
        )
          for (var r = o[a], l = !1, c = 0; !l && c < s; ) {
            i[c].id === r.id && ((l = !0), i.splice(c, 1, n({}, r))), c++
          }
        this.refresh()
      }),
      (i.prototype.refresh = function() {
        ;(this._refresh = !0), this.forceUpdate()
      }),
      (i.prototype._isToday = function(e) {
        return pn(new Date(e), new Date())
      }),
      (i.prototype._render = function(e, t) {
        var n,
          i,
          s,
          a = this,
          o = this._prevS,
          r = this._showDate,
          l =
            e.displayTimezone !== o.displayTimezone ||
            e.dataTimezone !== o.dataTimezone,
          c = !1
        if (
          ((this._colorEventList =
            undefined === e.eventTemplate &&
            undefined === e.renderEvent &&
            e.colorEventList),
          undefined === e.exclusiveEndDates &&
            (e.exclusiveEndDates = !!e.displayTimezone),
          V(e.min)
            ? (this._minDate = -1 / 0)
            : o.min !== e.min && (this._minDate = +bn(e.min)),
          V(e.max)
            ? (this._maxDate = 1 / 0)
            : o.max !== e.max && (this._maxDate = +bn(e.max)),
          undefined !== e.selectedDate
            ? (i = +bn(e.selectedDate))
            : (this._defaultDate ||
                (this._defaultDate = +(undefined !== e.defaultSelectedDate
                  ? bn(e.defaultSelectedDate)
                  : new Date())),
              (i = t.selectedDate || this._defaultDate)),
          (this.eventList = t.eventList),
          e.data !== o.data &&
            ((this._events = ts(e.data)), (this._refresh = !0)),
          (e.invalid !== o.invalid || e.colors !== o.colors || l) &&
            (this._refresh = !0),
          e.view !== o.view || e.firstDay !== o.firstDay)
        ) {
          var d = e.firstDay,
            h = e.view || {},
            u = h.agenda || {},
            _ = h.calendar || {},
            m = h.schedule || {},
            p = h.timeline || {},
            v = +(u.size || 1),
            f = u.type || "month",
            g = +(m.size || 1),
            y = m.type || "week",
            b = undefined !== m.startDay ? m.startDay : d,
            D = undefined !== m.endDay ? m.endDay : (d + 6) % 7,
            C = m.startTime,
            w = m.endTime,
            k = m.timeCellStep || 60,
            x = m.timeLabelStep || 60,
            T = !!h.calendar,
            S = _.count,
            E = !!h.agenda,
            M = !!h.schedule,
            L =
              undefined !== m.days
                ? m.days
                : !T &&
                  M &&
                  !(
                    "day" === y &&
                    e.resources &&
                    e.resources.length > 1 &&
                    g < 2
                  ),
            N = !!h.timeline,
            H = p.weekNumbers,
            O = undefined !== p.startDay ? p.startDay : d,
            I = undefined !== p.endDay ? p.endDay : (d + 6) % 7,
            z = p.startTime,
            P = p.endTime,
            R = N && !!e.slots && e.slots.length > 0,
            U = p.eventList || R,
            A = +(p.size || 1),
            W = p.type || "week",
            F = "month" === W || U ? 1440 : 60,
            B = R ? F : p.timeCellStep || F,
            X = R ? F : p.timeLabelStep || F,
            q = _.type || "month",
            j =
              undefined !== _.labels
                ? !!_.labels
                : !(
                    E ||
                    M ||
                    N ||
                    e.marked ||
                    "year" === q ||
                    ("month" === q && _.size)
                  )
          ;(this._calendarScroll = _.scroll),
            (this._calendarSize = _.size || 1),
            (this._calendarLabelList = _.labels),
            (this._calendarType = q),
            (this._showEventPopover = _.popover),
            (this._showOuterDays = _.outerDays),
            (this._showWeekNumbers = _.weekNumbers),
            (this._popoverClass = _.popoverClass || ""),
            (this._showScheduleAllDay = undefined === m.allDay || m.allDay),
            (v === this._eventListSize &&
              f === this._eventListType &&
              T === this._showCalendar &&
              S === this._showEventCount &&
              j === this._showEventLabels &&
              E === this._showEventList &&
              g === this._scheduleSize &&
              y === this._scheduleType &&
              M === this._showSchedule &&
              L === this._showScheduleDays &&
              b === this._scheduleStartDay &&
              D === this._scheduleEndDay &&
              C === this._scheduleStartTime &&
              w === this._scheduleEndTime &&
              k === this._scheduleTimeCellStep &&
              x === this._scheduleTimeLabelStep &&
              N === this._showTimeline &&
              O === this._timelineStartDay &&
              I === this._timelineEndDay &&
              z === this._timelineStartTime &&
              P === this._timelineEndTime &&
              A === this._timelineSize &&
              W === this._timelineType &&
              B === this._timelineTimeCellStep &&
              X === this._timelineTimeLabelStep &&
              U === this._timelineListing) ||
              (this._refresh = !0),
            (this._eventListSize = v),
            (this._eventListType = f),
            (this._scheduleType = y),
            (this._showCalendar = T),
            (this._showEventCount = S),
            (this._showEventLabels = j),
            (this._showEventList = E),
            (this._showSchedule = M),
            (this._showScheduleDays = L),
            (this._scheduleStartDay = b),
            (this._scheduleEndDay = D),
            (this._scheduleStartTime = C),
            (this._scheduleEndTime = w),
            (this._scheduleSize = g),
            (this._scheduleTimeCellStep = k),
            (this._scheduleTimeLabelStep = x),
            (this._showTimeline = N),
            (this._showTimelineWeekNumbers = H),
            (this._timelineSize = A),
            (this._timelineType = W),
            (this._timelineStartDay = O),
            (this._timelineEndDay = I),
            (this._timelineListing = U),
            (this._timelineStartTime = z),
            (this._timelineEndTime = P),
            (this._timelineTimeCellStep = B),
            (this._timelineTimeLabelStep = X),
            (this._timelineRowHeight = p.rowHeight),
            (this._rangeType = M ? y : N ? W : f),
            (this._rangeStartDay = M ? b : N ? O : undefined),
            (this._rangeEndDay = M ? D : N ? I : undefined),
            (this._showDate =
              (M && "day" === y) || (E && "day" === f && v < 2)),
            (this._firstWeekDay = M ? b : N ? O : d),
            (this._viewChanged = !0)
        }
        if (
          ((this._refresh || e.locale !== o.locale || e.theme !== o.theme) &&
            ((c = !0), this._pageLoad++),
          e.resources !== o.resources &&
            (this._resourcesMap = (e.resources || []).reduce(function(e, t) {
              return (e[t.id] = t), e
            }, {})),
          e.refDate !== o.refDate && (this._refDate = bn(e.refDate)),
          this._refDate ||
            this._showCalendar ||
            (!this._showSchedule && !this._showTimeline) ||
            (this._refDate = hn(new Date())),
          i !== this._selectedDateTime || this._viewChanged)
        ) {
          var G =
            this._showCalendar &&
            (this._showSchedule || this._showTimeline || this._showEventList)
              ? +(function(e, t, n, i, s, a, o) {
                  var r,
                    l,
                    c = !0,
                    d = !0,
                    h = 0,
                    u = 0
                  if (
                    (+e < n && (e = new Date(n)),
                    +e > i && (e = new Date(i)),
                    !s)
                  ) {
                    var _ = t.getYear(e),
                      m = t.getMonth(e),
                      p = t.getDate(_, m - 1, 1),
                      v = t.getDate(_, m + 2, 1)
                    ;(a = On(t.valid, p, v, t, !0)),
                      (s = On(t.invalid, p, v, t, !0))
                  }
                  if (!Ei(e, s, a, n, i)) return e
                  for (r = e, l = e; c && +r < i && h < 100; )
                    (c = Ei((r = kn(r, 1)), s, a, n, i)), h++
                  for (; d && +l > n && u < 100; )
                    (d = Ei((l = kn(l, -1)), s, a, n, i)), u++
                  return 1 !== o || c
                    ? -1 !== o || d
                      ? vn(e, r, t)
                        ? r
                        : vn(e, l, t)
                        ? l
                        : u >= h && !c
                        ? r
                        : l
                      : l
                    : r
                })(
                  new Date(i),
                  e,
                  this._minDate,
                  this._maxDate,
                  undefined,
                  undefined,
                  1
                )
              : Y(i, this._minDate, this._maxDate)
          ;(G = this._getValidDay(G)),
            i !== G &&
              ((i = G),
              setTimeout(function() {
                a._selectedChange(new Date(i))
              })),
            this._skipScheduleScroll ||
              i === this._selectedDateTime ||
              this._shouldScrollSchedule++,
            (this._selectedDateTime = i)
        }
        ;((n = +(s = hn(new Date(i)))) === this._selected &&
          r === this._showDate &&
          e.locale === o.locale &&
          o.dateFormatLong === e.dateFormatLong) ||
          (this._selectedDateHeader = this._showDate
            ? Dn(e.dateFormatLong, s, e)
            : ""),
          n !== this._selected &&
            ((this._shouldScroll =
              !this._isPageChange && !this._shouldSkipScroll),
            (this._shouldAnimateScroll =
              undefined !== this._shouldAnimateScroll
                ? this._shouldAnimateScroll
                : undefined !== this._selected),
            (this._selected = n),
            (this._selectedDates = {}),
            (this._selectedDates[n] = !0),
            (this._active = n),
            (c = !0)),
          c &&
            this._showCalendar &&
            ("day" === this._eventListType ||
              "day" === this._scheduleType ||
              "day" === this._timelineType) &&
            this._setEventList(s, kn(s, 1)),
          (this._refresh = !1),
          (this._cssClass =
            this._className +
            " mbsc-eventcalendar" +
            (this._showEventList ? " mbsc-eventcalendar-agenda" : "") +
            (this._showSchedule ? " mbsc-eventcalendar-schedule" : "") +
            (this._showTimeline ? " mbsc-eventcalendar-timeline" : ""))
      }),
      (i.prototype._mounted = function() {
        this._unsubscribe = Yi(this._onExternalDrag)
      }),
      (i.prototype._updated = function() {
        var e = this
        if (
          (this._shouldScroll &&
            this.state.isListScrollable &&
            (this._scrollToDay(),
            (this._shouldScroll = !1),
            (this._shouldAnimateScroll = undefined)),
          this._shouldLoadDays &&
            ((this._shouldLoadDays = !1),
            Oe(this._list.querySelectorAll("[mbsc-timestamp]"), function(t) {
              e._listDays[t.getAttribute("mbsc-timestamp")] = t
            })),
          this._shouldEnhance &&
            (this._shouldEnhance =
              "popover" === this._shouldEnhance
                ? this._popoverList
                : this._list),
          this._triggerCreated)
        ) {
          var t = this._triggerCreated,
            i =
              "calendar" === t.source
                ? this._calendarView._body.querySelector(
                    '.mbsc-calendar-table-active .mbsc-calendar-text[data-id="' +
                      t.event.id +
                      '"]'
                  )
                : this._el.querySelector(
                    '.mbsc-schedule-event[data-id="' + t.event.id + '"]'
                  )
          this._hook(
            "onEventCreated",
            n({}, this._triggerCreated, { target: i })
          ),
            (this._triggerCreated = null)
        }
        if (this._triggerUpdated) {
          var s = this._triggerUpdated
          i =
            "calendar" === s.source
              ? this._calendarView._body.querySelector(
                  '.mbsc-calendar-table-active .mbsc-calendar-text[data-id="' +
                    s.event.id +
                    '"]'
                )
              : this._el.querySelector(
                  '.mbsc-schedule-event[data-id="' + s.event.id + '"]'
                )
          this._hook(
            "onEventUpdated",
            n({}, this._triggerUpdated, { target: i })
          ),
            (this._triggerUpdated = null)
        }
        this._triggerDeleted &&
          (this._hook("onEventDeleted", n({}, this._triggerDeleted)),
          (this._triggerDeleted = null)),
          this._viewChanged &&
            setTimeout(function() {
              e._viewChanged = !1
            }, 10),
          (this._shouldSkipScroll = !1),
          (this._skipScheduleScroll = !1)
      }),
      (i.prototype._destroy = function() {
        Ui(this._unsubscribe)
      }),
      (i.prototype._getAgendaEvents = function(e, t, n) {
        var i = this,
          s = [],
          a = this.s
        if (n && this._showEventList)
          for (
            var o = function(e) {
                var t = n[dn(e)]
                if (t && t.length) {
                  var o = qn(t, a.eventOrder)
                  s.push({
                    date: Dn(a.dateFormatLong, e, a),
                    events: o.map(function(t) {
                      return i._getEventData(t, +e)
                    }),
                    timestamp: +e
                  })
                }
              },
              r = hn(e);
            r < t;
            r.setDate(r.getDate() + 1)
          )
            o(r)
        return s
      }),
      (i.prototype._getEventData = function(e, t) {
        var n,
          i = this.s
        if (!e.color && e.resource) {
          var s = U(e.resource) ? e.resource : [e.resource]
          n = (this._resourcesMap || {})[s[0]]
        }
        var a = es(
          i,
          e,
          t,
          this._colorEventList,
          i.timeFormat,
          i.allDayText,
          i.toText,
          n,
          !0
        )
        return (a.html = this._safeHtml(a.html)), a
      }),
      (i.prototype._getValidDay = function(e, t) {
        void 0 === t && (t = 1)
        var n = this._rangeStartDay,
          i = this._rangeEndDay
        if (
          !this._showCalendar &&
          "day" === this._rangeType &&
          undefined !== n &&
          undefined !== i
        ) {
          var s = new Date(e),
            a = s.getDay(),
            o = 0
          if (
            ((i < n ? a > i && a < n : a > i || a < n) &&
              (o = t < 0 ? i - a : n - a),
            o)
          )
            return +kn(s, (o += t < 0 ? (o > 0 ? -7 : 0) : o < 0 ? 7 : 0))
        }
        return e
      }),
      (i.prototype._setEventList = function(e, t) {
        var n = this
        setTimeout(function() {
          ;(n._eventListHTML = undefined),
            (n._shouldScroll = !0),
            (n._listDays = null),
            n._scrollToDay(0),
            n.setState({ eventList: n._getAgendaEvents(e, t, n._eventMap) })
        })
      }),
      (i.prototype._hidePopover = function() {
        this.setState({ showPopover: !1 })
      }),
      (i.prototype._scrollToDay = function(e) {
        var t = this
        if (this._list) {
          var n = e,
            i = void 0
          if (undefined === e && this._listDays) {
            var s = this._listDays[this._selected]
            s && ((n = s.offsetTop), (i = this._shouldAnimateScroll))
          }
          undefined !== n &&
            (this._isListScrolling++,
            Me(this._list, n, i, !1, !1, function() {
              setTimeout(function() {
                t._isListScrolling--
              }, 150)
            }))
        }
      }),
      (i.prototype._selectedChange = function(e) {
        this._emit("selectedDateChange", e),
          this._hook("onSelectedDateChange", { date: e })
      }),
      (i.prototype._cellClick = function(e, t) {
        this._hook(e, n({ target: t.domEvent.currentTarget }, t))
      }),
      (i.prototype._dayClick = function(e, t) {
        var n = dn(t.date),
          i = qn(this._eventMap[n], this.s.eventOrder)
        ;(t.events = i), this._hook(e, t)
      }),
      (i.prototype._labelClick = function(e, t) {
        t.label &&
          this._hook(e, {
            date: t.date,
            domEvent: t.domEvent,
            event: t.label,
            source: "calendar"
          })
      }),
      (i.prototype._eventClick = function(e, t) {
        return (t.date = new Date(t.date)), this._hook(e, t)
      }),
      (i.defaults = n({}, Un, {
        actionableEvents: !0,
        allDayText: "All-day",
        data: [],
        dragTimeStep: 15,
        newEventText: "New event",
        noEventsText: "No events",
        showControls: !0,
        showEventTooltip: !0,
        toText: "End",
        view: { calendar: { type: "month" } }
      })),
      (i._name = "Eventcalendar"),
      i
    )
  })(Yt),
  ss = "mbsc-def"
function as(e, t, n, i, s, a) {
  for (
    var o = "start-end" === s,
      r = a ? n : hn(kn(n, 1)),
      l = 0,
      c = Object.keys(e);
    l < c.length;
    l++
  )
    for (var d = e[c[l]], h = hn(t); h < r; h.setDate(h.getDate() + 1)) {
      var u = d[dn(h)]
      if (u) {
        if (u.allDay && (!o || pn(h, t) || pn(h, n))) return u.allDay
        if (!i)
          for (var _ = 0, m = u.invalids; _ < m.length; _++) {
            var p = m[_]
            if (o) {
              if (ln(p.startDate, p.endDate, t, t, !0)) return p.original
              if (ln(p.startDate, p.endDate, n, n)) return p.original
            } else if (ln(p.startDate, p.endDate, t, n)) return p.original
          }
      }
    }
  return !1
}
function os(e, t, n, i) {
  for (
    var s = n.allDay,
      a = n.startDate,
      o = s ? cn(e, s, a, n.endDate) : n.endDate,
      r = s ? yn(e, a.getFullYear(), a.getMonth(), a.getDate()) : a,
      l = s
        ? yn(e, o.getFullYear(), o.getMonth(), o.getDate(), 23, 59, 59, 999)
        : o,
      c = !1,
      d = 0,
      h = t;
    d < h.length;
    d++
  ) {
    for (
      var u = h[d], _ = 0, m = !1, p = void 0, v = 0, f = u;
      v < f.length;
      v++
    ) {
      for (var g = f[v], y = !1, b = 0, D = g; b < D.length; b++) {
        var C = D[b],
          w = C.allDay,
          k = C.startDate,
          x = w ? cn(e, w, k, C.endDate) : C.endDate
        ln(
          w ? yn(e, k.getFullYear(), k.getMonth(), k.getDate()) : k,
          w
            ? yn(e, x.getFullYear(), x.getMonth(), x.getDate(), 23, 59, 59, 999)
            : x,
          r,
          l,
          !0
        ) &&
          ((y = !0),
          (m = !0),
          p ? (i[n.uid] = i[n.uid] || _) : (i[C.uid] = _ + 1))
      }
      y || p || (p = g), _++
    }
    m && (p ? p.push(n) : u.push([n]), (c = !0))
  }
  c || ((i[n.uid] = 0), t.push([[n]]))
}
function rs(e) {
  return (e = Math.abs(J(e))) > 60
    ? 60 * J(e / 60)
    : 60 % e == 0
    ? e
    : [6, 10, 12, 15, 20, 30].reduce(function(t, n) {
        return Math.abs(n - e) < Math.abs(t - e) ? n : t
      })
}
function ls(e, t, n, i, s, a) {
  i && i > e && (e = i)
  var o = rn(e)
  return (
    (t > o || (undefined !== s && undefined !== a && !xn(e.getDay(), s, a))) &&
      (o = t),
    (100 * (o - t)) / n
  )
}
function cs(e, t, n, i, s) {
  e = e || {}
  var a = Object.keys(e),
    o = {},
    r = t.map(function(e) {
      return e.id
    }),
    l = n.map(function(e) {
      return e.id
    })
  r.forEach(function(e) {
    ;(o[e] = {}),
      l.forEach(function(t) {
        o[e][t] = {}
      })
  })
  for (
    var c = function(t) {
        for (
          var n = function(e) {
              var n = e.resource,
                a = e.slot,
                c = undefined !== n && i ? (U(n) ? n : [n]) : r,
                d = undefined !== a && s ? [a] : l
              c.forEach(function(n) {
                var i = o[n]
                i &&
                  d.forEach(function(n) {
                    var s = i[n]
                    s && (s[t] || (s[t] = []), s[t].push(e))
                  })
              })
            },
            a = 0,
            c = e[t];
          a < c.length;
          a++
        ) {
          n(c[a])
        }
      },
      d = 0,
      h = a;
    d < h.length;
    d++
  ) {
    c(h[d])
  }
  return o
}
function ds(e, t) {
  return new Date(+new Date(e) + t)
}
var hs = /*#__PURE__*/ (function(e) {
    function i() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t._onScroll = function() {}),
        (t._onEventDragModeOn = function(e) {
          var n = e.create ? t._tempEvent : e.event,
            i = e.create ? t._tempResource : e.resource,
            s = e.create ? t._tempSlot : e.slot
          t.setState({
            dragData: {
              draggedEvent: n,
              originDates: e.external ? undefined : t._getDragDates(n, i, s),
              resource: i
            },
            isTouchDrag: !0
          })
        }),
        (t._onEventDragModeOff = function() {
          t.setState({ dragData: undefined, isTouchDrag: !1 })
        }),
        (t._calcGridDimensions = function() {
          var e = t.s,
            n = t._resources,
            i = t._isTimeline,
            s = t._days * (i ? 1 : n.length),
            a = t._gridCont,
            o = t._scrollCont,
            r = a.getBoundingClientRect(),
            l = o.getBoundingClientRect()
          ;(t._gridLeft = e.rtl ? r.right - a.scrollWidth : r.left),
            (t._gridRight = e.rtl ? r.right : r.left + a.scrollWidth),
            (t._gridTop = r.top),
            (t._gridContTop = l.top),
            (t._gridContBottom = l.bottom),
            (t._gridContLeft = l.left),
            (t._gridContRight = l.right),
            (t._allDayTop = t._gridContTop),
            (t._colWidth = a.scrollWidth / s),
            (t._colHeight = i ? a.scrollHeight : r.height)
        }),
        (t._onEventDragStart = function(e) {
          var i = t.s,
            s = i.eventList,
            a = t._isTimeline,
            o = t._resources,
            r = t._slots,
            l = i.dragTimeStep,
            c = t._gridCont,
            d = e.startX,
            h = e.startY,
            u = t._groupByResource,
            _ = u ? t._days : t._hasSlots ? t._slots.length : o.length
          ;(t._resWidth = t._resCont ? t._resCont.offsetWidth : 0),
            (t._scrollY = 0),
            (t._scrollX = 0),
            t._calcGridDimensions()
          var m = i.rtl ? t._gridRight - d : d - t._gridLeft,
            p = Y(h - t._gridTop, 8, t._colHeight - 9),
            v = $(m / t._colWidth),
            f = 0,
            g = v,
            y = 0
          if (a) {
            var b = c.querySelectorAll(".mbsc-timeline-row")
            ;(t._rowTops = []),
              (y = $(m / (t._colWidth / r.length)) % r.length),
              b.forEach(function(e, n) {
                var i = e.getBoundingClientRect().top - t._gridTop
                t._rowTops.push(i), p > i && (f = n)
              })
          } else {
            var D = t._el.querySelector(".mbsc-schedule-all-day-wrapper"),
              C = D && D.getBoundingClientRect()
            ;(t._allDayTop = C ? C.top : t._gridContTop),
              (f = u ? $(v / _) : v % _),
              (g = u ? v % _ : $(v / _))
          }
          if (e.create) {
            var w = e.click,
              k = !a && i.showAllDay && e.endY < t._gridContTop,
              x =
                "day" === i.type && 1 === i.size
                  ? t._firstDay
                  : t._weekDays[g].dateObj,
              T = s || (!e.external && !w) ? 6e4 * l : t._stepCell,
              S = t._getGridTime(x, m, p, g, w ? t._stepCell / 6e4 : l),
              E = k || s ? x : S,
              M = Tn(yn(k ? undefined : i, +E + T), w ? 1 : l),
              L = e.external ? undefined : o[f],
              N = L ? L.id : undefined,
              H = e.external ? undefined : r[y],
              O = H ? H.id : undefined,
              I = i.extendDefaultEvent
                ? i.extendDefaultEvent({ resource: N, slot: O, start: E })
                : undefined,
              z = n(
                {
                  allDay: k,
                  end: M,
                  id: Qi(),
                  resource: L && N !== ss ? N : undefined,
                  slot: H && O !== ss ? O : undefined,
                  start: E,
                  title: i.newEventText
                },
                I,
                e.event
              ),
              P = t._getEventData(z, +x, L)
            if (e.event) {
              var R = +P.endDate - +P.startDate
              ;(P.startDate = x), (P.endDate = new Date(+x + R))
            }
            ;(t._tempEvent = P), (t._tempResource = N), (t._tempSlot = O)
          }
        }),
        (t._onEventDragMove = function(e) {
          clearTimeout(t._scrollTimer)
          var i = t.s,
            s = i.rtl,
            a = s ? -1 : 1,
            o = t._slots,
            r = t._groupByResource,
            l = t._isTimeline,
            c = t.state.dragData,
            d = i.dragTimeStep,
            h = i.timeFormat,
            u = i.eventList,
            _ = e.startX,
            m = Y(e.endX, t._gridContLeft, t._gridContRight - 1),
            p = Y(e.endY, t._gridContTop, t._gridContBottom - 1),
            v = p - e.startY + t._scrollY,
            f = s ? _ - m + t._scrollX : m - _ + t._scrollX,
            g = l ? f : v,
            y = l ? t._colWidth : t._colHeight - 16,
            b = Y(
              s ? t._gridRight + t._scrollX - m : m - t._gridLeft + t._scrollX,
              0,
              t._gridRight - t._gridLeft - 1
            ),
            D = Y(p - t._gridTop + t._scrollY, 8, t._colHeight - 9),
            C = $((s ? t._gridRight - _ : _ - t._gridLeft) / t._colWidth),
            w = $(b / t._colWidth),
            k = i.showAllDay && e.endY < t._gridContTop,
            x = t._scrollCont,
            T = C,
            S = w,
            E = 0,
            M = 0,
            L = !1,
            N = t._gridContBottom - e.endY,
            H = e.endY - t._gridContTop,
            O = e.endX - t._gridContLeft,
            I = t._gridContRight - e.endX,
            z = (x.scrollWidth - x.clientWidth) * a,
            P = s ? 0 : z,
            R = s ? z : 0
          if (
            (N < 30 &&
              x.scrollTop < x.scrollHeight - x.clientHeight &&
              ((x.scrollTop += 5), (t._scrollY += 5), (L = !0)),
            H < 30 &&
              !k &&
              x.scrollTop > 0 &&
              ((x.scrollTop -= 5), (t._scrollY -= 5), (L = !0)),
            O < 30 + (s ? 0 : t._resWidth) &&
              x.scrollLeft > R &&
              ((x.scrollLeft -= 5), (t._scrollX -= 5 * a), (L = !0)),
            I < 30 + (s ? t._resWidth : 0) &&
              x.scrollLeft < P &&
              ((x.scrollLeft += 5), (t._scrollX += 5 * a), (L = !0)),
            L &&
              (t._scrollTimer = setTimeout(function() {
                t._onEventDragMove(e)
              }, 20)),
            l)
          )
            (M = $(b / (t._colWidth / o.length)) % o.length),
              t._rowTops.forEach(function(e, t) {
                D > e && (E = t)
              })
          else {
            var U = r ? t._days : t._resources.length
            ;(T = r ? C % U : $(C / U)),
              (S = r ? w % U : $(w / U)),
              (E = r ? $(w / U) : w % U)
          }
          var A,
            W = e.create ? t._tempEvent : e.event,
            F = W.startDate,
            V = W.endDate,
            B = +V - +F,
            X = t._time,
            q = $((X * g) / y),
            j = o[M].id,
            G = t._resources[E].id,
            K = W.allDay,
            J = K ? undefined : i,
            Z = K || u,
            Q = F,
            ee = V,
            te = t._weekDays[T].dateObj,
            ne = t._weekDays[S].dateObj,
            ie = "day" === i.type && 1 === i.size ? 0 : _n(te, ne),
            se = ie - S + T
          if (e.drag || e.external) {
            if (
              ((K = k || (l && W.allDay)),
              (Z = k || u || (l && W.allDay)),
              (J = K ? undefined : i),
              (W.allDay && !l && !k) || (e.external && !k))
            ) {
              var ae = hn(kn(F, ie))
              Q = t._getGridTime(ae, b, D, S, d)
            } else
              Q = Tn(
                l && !Z
                  ? yn(i, +F + q + (864e5 - X) * ie + X * se)
                  : yn(J, +kn(F, ie) + (Z ? 0 : q)),
                d
              )
            ee = yn(J, +Q + B)
          } else {
            var oe = l ? 0 : w - C,
              re = e.create ? (oe ? oe > 0 : g > 0) : "end" === e.direction,
              le = _n(F, V),
              ce = e.create ? t._tempResource : e.resource
            !l &&
              r &&
              ce !== G &&
              c &&
              c.draggedEvent &&
              (ie =
                _n(c.draggedEvent.startDate, c.draggedEvent.endDate) *
                (re ? 1 : -1)),
              re
                ? l && !Z
                  ? (ee = Tn(yn(i, +V + q + ie * (864e5 - X) + X * se), d))
                  : ((ee = Tn(
                      yn(J, +(A = kn(V, Math.max(-le, ie))) + (Z ? 0 : q)),
                      d
                    )),
                    !Z &&
                      (rn(ee) > t._endTime + 1 || ee >= kn(hn(A), 1)) &&
                      (ee = yn(i, +hn(A) + t._endTime + 1)))
                : l && !Z
                ? (Q = Tn(yn(i, +F + q + ie * (864e5 - X) + X * se), d))
                : ((Q = Tn(
                    yn(J, +(A = kn(F, Math.min(le, ie))) + (Z ? 0 : q)),
                    d
                  )),
                  !Z &&
                    (rn(Q) < t._startTime || Q < hn(A)) &&
                    (Q = yn(i, +hn(A) + t._startTime))),
              (G = ce),
              Z && ee < Q && (re ? (ee = yn(i, Q)) : (Q = yn(i, ee))),
              !Z &&
                (ee < Q || Math.abs(+ee - +Q) < 6e4 * d) &&
                (re ? (ee = yn(i, +Q + 6e4 * d)) : (Q = yn(i, +ee - 6e4 * d)))
          }
          if (
            t._tempStart !== +Q ||
            t._tempEnd !== +ee ||
            t._tempAllDay !== K ||
            t._tempResource !== G ||
            t._tempSlot !== j
          ) {
            var de = n({}, W)
            ;(de.startDate = Q),
              (de.endDate = ee),
              (de.start = Dn(h, Q)),
              (de.end = Dn(h, ee)),
              (de.allDay = K),
              (t._tempStart = +Q),
              (t._tempEnd = +ee),
              (t._tempAllDay = K),
              (t._tempResource = G),
              (t._tempSlot = j),
              t.setState({
                dragData: {
                  draggedDates: t._getDragDates(de, G, j),
                  draggedEvent: de,
                  originDates: c && c.originDates,
                  resource: G,
                  slot: j
                }
              })
          }
        }),
        (t._onEventDragEnd = function(e) {
          clearTimeout(t._scrollTimer)
          var n = t.s,
            i = e.create,
            s = t.state,
            a = s.dragData
          if (
            (i && !a && ((a = {}).draggedEvent = t._tempEvent),
            a && a.draggedEvent)
          ) {
            var o = e.event,
              r = a.draggedEvent,
              l = r.startDate,
              c = r.endDate,
              d = r.allDay,
              h = r.original,
              u = e.resource,
              _ = undefined === a.resource ? u : a.resource,
              m = undefined === h.resource ? _ : h.resource,
              p = i ? t._tempSlot : e.slot,
              v = undefined === a.slot ? p : a.slot,
              f = {},
              g =
                i ||
                +l != +o.startDate ||
                +c != +o.endDate ||
                d !== o.allDay ||
                u !== _ ||
                p !== v,
              y = m,
              b = void 0
            if (u !== _ && !i && !t._isSingleResource)
              if (U(m) && m.length && _) {
                var D = m.indexOf(u)
                ;-1 === m.indexOf(_) && (y = m.slice()).splice(D, 1, _)
              } else y = _
            b =
              y && n.resources
                ? U(y)
                  ? y
                  : [y]
                : t._resources.map(function(e) {
                    return e.id
                  })
            for (var C = 0, w = b; C < w.length; C++) {
              var k = w[C]
              t._invalids[k] && (f[k] = t._invalids[k][v])
            }
            var x =
                !g ||
                n.onEventDragEnd({
                  action: e.action || (s.dragData ? "drag" : "click"),
                  collision: as(
                    f,
                    l,
                    c,
                    d,
                    n.invalidateEvent,
                    n.exclusiveEndDates
                  ),
                  create: i,
                  domEvent: e.domEvent,
                  event: r,
                  resource: y !== ss ? y : undefined,
                  slot: v !== ss ? v : undefined,
                  source: t._isTimeline ? "timeline" : "schedule"
                }),
              T = s.isTouchDrag && (!i || x)
            if (x && T && u !== _ && !h.color) {
              var S = ee(t._resources, function(e) {
                  return e.id === _
                }),
                E = S && S.color
              E
                ? ((r.color = E),
                  (r.style.background = E),
                  (r.style.color = Se(E)))
                : ((r.color = undefined), (r.style = {}))
            }
            t.setState({
              dragData: T
                ? {
                    draggedEvent: r,
                    originDates: x ? t._getDragDates(r, _, v) : a.originDates
                  }
                : undefined,
              isTouchDrag: T
            }),
              (t._tempStart = 0),
              (t._tempEnd = 0),
              (t._tempAllDay = undefined)
          }
        }),
        (t._onExternalDrag = function(e) {
          if (t.s.externalDrop) {
            var n =
              e.endY < t._gridContBottom &&
              e.endY > t._allDayTop &&
              e.endX > t._gridContLeft &&
              e.endX < t._gridContRight
            switch (e.eventName) {
              case "onDragModeOff":
                t._onEventDragModeOff()
                break
              case "onDragModeOn":
                t._onEventDragModeOn(e)
                break
              case "onDragStart":
                t._onEventDragStart(e)
                break
              case "onDragMove":
                var i = e.clone
                n
                  ? ((i.style.display = "none"),
                    t._onEventDragMove(e),
                    (t._onCalendar = !0))
                  : t._onCalendar &&
                    (clearTimeout(t._scrollTimer),
                    (i.style.display = "table"),
                    t.setState({ dragData: {} }),
                    (t._tempStart = 0),
                    (t._tempEnd = 0),
                    (t._tempAllDay = undefined),
                    (t._onCalendar = !1))
                break
              case "onDragEnd":
                n
                  ? t._onEventDragEnd(e)
                  : t.setState({ dragData: undefined, isTouchDrag: !1 })
            }
          }
        }),
        t
      )
    }
    return (
      t(i, e),
      (i.prototype._isToday = function(e) {
        return pn(new Date(e), new Date())
      }),
      (i.prototype._formatTime = function(e) {
        var t = this.s.timeFormat
        return Dn(
          /a/i.test(t) && 36e5 === this._stepLabel && e % 36e5 == 0
            ? t.replace(/.[m]+/i, "")
            : t,
          new Date(+new Date(0, 0, 1) + e)
        )
      }),
      (i.prototype._getEventPos = function(e, t, n) {
        var i = this.s,
          s = e.allDay ? undefined : i,
          a = yn(s, t.getFullYear(), t.getMonth(), t.getDate()),
          o = this._firstDay,
          r = this._lastDay,
          l = this._isTimeline,
          c = !l && !this._groupByResource,
          d = e.allDay,
          h = this._startTime,
          u = this._endTime,
          _ = e.start,
          m = e.startDate,
          p = e.end,
          v = cn(i, d, m, e.endDate),
          f = +m == +v ? 1 : 0
        if (d || l) {
          if (!n.get(e.original) || this._hasSlots || c) {
            var g = i.startDay,
              y = i.endDay,
              b = !pn(m, v)
            l &&
              b &&
              rn(m) > u &&
              (m = new Date(m)).setHours($(u / 36e5), $(u / 6e4) % 60)
            var D = ls(m, h, this._time, o, g, y) + "%",
              C = i.eventList,
              w = yn(s, o.getFullYear(), o.getMonth(), o.getDate()),
              k = yn(s, r.getFullYear(), r.getMonth(), r.getDate()),
              x = (function(e, t, n, i, s, a, o, r, l, c) {
                var d = wn(e),
                  h = wn(t),
                  u = $(a / 36e5),
                  _ = $(a / 6e4) % 60,
                  m = $(o / 36e5),
                  p = $(o / 6e4) % 60
                ;+e < +i && (d = i),
                  +t > +s && (h = s),
                  a > rn(d) && d.setHours(u, _),
                  o < rn(h) && h.setHours(m, p),
                  pn(d, h) ||
                    (rn(d) > o && d.setHours(m, p),
                    rn(h) < a && h.setHours(u, _))
                var v = 0
                if (pn(d, h)) v = c ? n : +h - +d
                else
                  for (var f = hn(d); f <= h; f.setDate(f.getDate() + 1))
                    xn(f.getDay(), r, l) &&
                      (!c && pn(f, d)
                        ? (v += n - rn(d) + a)
                        : !c && pn(f, h)
                        ? (v += rn(h) - a)
                        : (v += n))
                return (100 * v) / n
              })(m, v, this._time, w, k, h, u, g, y, d || C),
              T = l
                ? C || d
                  ? {
                      left: i.rtl ? "" : "0",
                      right: i.rtl ? "0" : "",
                      width: (this._hasSlots ? 100 : x) + "%"
                    }
                  : {
                      height: this._setRowHeight ? "" : "100%",
                      left: i.rtl ? "" : D,
                      right: i.rtl ? D : "",
                      top: "0",
                      width: x + "%"
                    }
                : { width: (b && !c ? x : 100) + "%" },
              S = rn(m) < u && v > w,
              E = rn(v) + f > h
            if (d || C || (b && (S || E)) || (S && E))
              return (
                n.set(e.original, !0),
                { end: p, endDate: v, position: T, start: _, startDate: m }
              )
          }
        } else if (
          (m < a && ((_ = ""), (m = yn(i, a))),
          v >= hn(kn(a, 1)) &&
            ((p = ""), (v = yn(i, a)).setHours(23, 59, 59, 999)),
          rn(m) < u && rn(v) + f > h && v >= m)
        ) {
          var M = (function(e, t, n, i, s) {
            var a = rn(e),
              o = rn(t)
            return i > a && (a = i), s < o && (o = s), (100 * (o - a)) / n
          })(m, v, this._time, h, u)
          return {
            cssClass: M < 2 ? " mbsc-schedule-event-small-height" : "",
            end: p,
            endDate: v,
            position: {
              height: M + "%",
              top: ls(m, h, this._time) + "%",
              width: "100%"
            },
            start: _,
            startDate: m
          }
        }
      }),
      (i.prototype._getEventData = function(e, t, n) {
        var i = this.s,
          s = es(
            i,
            e,
            t,
            !0,
            i.timeFormat,
            i.allDayText,
            "",
            n,
            !1,
            this._isTimeline
          )
        if (
          ((s.html = this._safeHtml(s.html)),
          e.allDay && +s.endDate == +s.startDate)
        ) {
          var a = hn(kn(s.startDate, 1))
          s.endDate = i.exclusiveEndDates ? a : yn(i, +a - 1)
        }
        return s
      }),
      (i.prototype._getEvents = function(e, t, n) {
        for (
          var i,
            s = this,
            a = this.s,
            o = this._days,
            r = this._resources,
            l = this._slots,
            c = this._groupByResource,
            d = this._isTimeline,
            h = a.eventList,
            u = [],
            _ = {},
            m = cs(n, r, l, !!a.resources, !!a.slots),
            p = {},
            v = {},
            f = [],
            g = function(n) {
              var r = n.id,
                g = new Map(),
                b = 0
              if (((p[r] = []), (c || d) && ((f = []), u.push(f), !d || h)))
                for (var D = 0, C = l; D < C.length; D++) {
                  var w = C[D].id,
                    k = m[r][w]
                  v[w] = Xn(a, k, e, t, -1, o, !h, a.startDay, !1, a.eventOrder)
                }
              for (
                var x = function(e) {
                    if (xn(e.getDay(), a.startDay, a.endDay)) {
                      var D = +hn(e),
                        C = dn(e)
                      if (!c && !d) {
                        _[C] ? (f = _[C]) : ((f = []), (_[C] = f), u.push(f))
                        var w = m[r][ss]
                        v[ss] = Xn(
                          a,
                          w,
                          e,
                          kn(e, 1),
                          -1,
                          o,
                          !0,
                          a.startDay,
                          !1,
                          a.eventOrder
                        )
                      }
                      var k = {
                        allDay: [],
                        day: a.getDay(e),
                        events: {},
                        key: C,
                        lastDay: c || d ? +t : +kn(e, 1),
                        resource: r,
                        timestamp: D
                      }
                      if (!d || h)
                        for (
                          var x = function(t) {
                              var a = t.id
                              ;(k.events[a] = []),
                                (i = 0),
                                v[a][C].data.forEach(function(t) {
                                  var o = t.event,
                                    r = t.width
                                  if (o) {
                                    var l = h ? k.events[a] : k.allDay,
                                      c = s._getEventData(o, D, n),
                                      d = s._getEventPos(c, e, g)
                                    ;(c.position = {
                                      width: d ? d.position.width : r
                                    }),
                                      i++,
                                      l.push({ event: c, showText: !!d })
                                  }
                                }),
                                h && b < i && (b = i)
                            },
                            T = 0,
                            S = l;
                          T < S.length;
                          T++
                        ) {
                          x(S[T])
                        }
                      var E = [],
                        M = {}
                      if (!h) {
                        var L = qn(m[r][ss][C]) || []
                        k.events[ss] = []
                        for (var N = 0, H = L; N < H.length; N++) {
                          var O = H[N]
                          if (!O.allDay || d) {
                            var I = y._getEventData(O, D, n),
                              z = y._getEventPos(I, e, g)
                            z &&
                              ((I.cssClass = z.cssClass),
                              (I.position = z.position),
                              d || os(a, E, I, M),
                              k.events[ss].push({ event: I, showText: !0 }),
                              p[r].push(I))
                          }
                        }
                      }
                      if (!d)
                        for (
                          var P = function(e) {
                              var t = e.length
                              e.forEach(function(e, n) {
                                for (var i = 0, s = e; i < s.length; i++) {
                                  var o = s[i],
                                    r = (((M[o.uid] || t) - n) / t) * 100
                                  ;(o.position.width = r + "%"),
                                    (o.position[a.rtl ? "right" : "left"] =
                                      (100 * n) / t + "%"),
                                    (o.position[a.rtl ? "left" : "right"] =
                                      "auto")
                                }
                              })
                            },
                            R = 0,
                            Y = E;
                          R < Y.length;
                          R++
                        ) {
                          P(Y[R])
                        }
                      f.push(k)
                    }
                  },
                  T = hn(e);
                T < t;
                T.setDate(T.getDate() + 1)
              )
                x(T)
              if (d && !h) {
                for (
                  var S = [], E = {}, M = y._setRowHeight, L = 0, N = p[r];
                  L < N.length;
                  L++
                ) {
                  var H = N[L]
                  os(a, S, H, E)
                }
                for (
                  var O = function(e) {
                      var t = e.length
                      M && t > b && (b = t),
                        e.forEach(function(e, n) {
                          for (var i = 0, s = e; i < s.length; i++) {
                            var a = s[i],
                              o = (((E[a.uid] || t) - n) / t) * 100
                            ;(a.position.height = M ? "" : o + "%"),
                              (a.position.top = M ? n : (100 * n) / t + "%")
                          }
                        })
                    },
                    I = 0,
                    z = S;
                  I < z.length;
                  I++
                ) {
                  O(z[I])
                }
              }
              y._eventRows[r] = b || 1
            },
            y = this,
            b = 0,
            D = r;
          b < D.length;
          b++
        ) {
          g(D[b])
        }
        return u
      }),
      (i.prototype._getInvalids = function(e, t, n) {
        for (
          var i = this.s,
            s = i.eventList,
            a = {},
            o = cs(n, this._resources, this._slots, !!i.resources, !!i.slots),
            r = s ? hn(new Date(i.minDate)) : new Date(i.minDate),
            l = s ? hn(kn(new Date(i.maxDate), 1)) : new Date(i.maxDate),
            c = 0,
            d = this._resources;
          c < d.length;
          c++
        )
          for (
            var h = d[c], u = h.id, _ = new Map(), m = hn(e);
            m < t;
            m.setDate(m.getDate() + 1)
          )
            for (var p = dn(m), v = 0, f = this._slots; v < f.length; v++) {
              var g = f[v].id,
                y = o[u][g][p] || [],
                b = { invalids: [] }
              m < r && y.push({ end: r, start: new Date(m) }),
                m >= hn(l) && y.push({ end: new Date(t), start: l })
              for (var D = 0, C = y; D < C.length; D++) {
                var w = C[D]
                if (F(w) || gn(w)) {
                  var k = bn(w)
                  w = { allDay: !0, end: new Date(k), start: k }
                }
                var x = this._getEventData(w, +m, h)
                if (((x.cssClass = ""), (x.position = undefined), !x.allDay)) {
                  var T = this._getEventPos(x, m, _)
                  T &&
                    (!this._isTimeline &&
                    0 === rn(T.startDate) &&
                    new Date(+T.endDate + 1) >= kn(m, 1)
                      ? (x.allDay = !0)
                      : ((x.position = T.position),
                        rn(T.startDate) <= this._startTime &&
                          (x.cssClass += " mbsc-schedule-invalid-start"),
                        rn(T.endDate) >= this._endTime &&
                          (x.cssClass += " mbsc-schedule-invalid-end"))),
                    b.invalids.push(x)
                }
                if (x.allDay) {
                  ;(x.position = {}), (b.allDay = x), (b.invalids = [x])
                  break
                }
              }
              a[u] || (a[u] = {}), a[u][g] || (a[u][g] = {}), (a[u][g][p] = b)
            }
        return a
      }),
      (i.prototype._getColors = function(e, t, n) {
        for (
          var i = this.s,
            s = {},
            a = cs(n, this._resources, this._slots, !!i.resources, !!i.slots),
            o = 0,
            r = this._resources;
          o < r.length;
          o++
        )
          for (
            var l = r[o], c = l.id, d = new Map(), h = 0, u = this._slots;
            h < u.length;
            h++
          )
            for (
              var _ = u[h].id, m = hn(e);
              m < t;
              m.setDate(m.getDate() + 1)
            ) {
              for (
                var p = +hn(m),
                  v = dn(m),
                  f = { colors: [] },
                  g = 0,
                  y = a[c][_][v] || [];
                g < y.length;
                g++
              ) {
                var b = y[g],
                  D = this._getEventData(b, p, l)
                if (D.allDay && !this._isTimeline) f.allDay = D
                else {
                  var C = this._getEventPos(D, m, d)
                  C &&
                    ((D.position = C.position),
                    (D.cssClass = ""),
                    rn(C.startDate) <= this._startTime &&
                      (D.cssClass += " mbsc-schedule-color-start"),
                    rn(C.endDate) >= this._endTime &&
                      (D.cssClass += " mbsc-schedule-color-end"),
                    f.colors.push(D))
                }
                ;(D.position.background = b.background),
                  (D.position.color = b.textColor
                    ? b.textColor
                    : Se(b.background))
              }
              s[c] || (s[c] = {}), s[c][_] || (s[c][_] = {}), (s[c][_][v] = f)
            }
        return s
      }),
      (i.prototype._render = function(e, t) {
        var n = this._prevS,
          i = this._isTimeline,
          s = new Date(e.selected),
          a = +e.size,
          o = rs(e.timeLabelStep),
          r = rs(e.timeCellStep),
          l = e.firstDay,
          c = e.startDay,
          d = e.endDay,
          u = e.resources,
          _ = e.slots,
          m =
            e.groupBy !== n.groupBy ||
            u !== n.resources ||
            this._hierarchyChange,
          p = e.rtl !== n.rtl || m,
          v = this._startTime,
          f = this._endTime
        if (
          e.startTime !== n.startTime ||
          e.endTime !== n.endTime ||
          e.timeLabelStep !== n.timeLabelStep ||
          e.timeCellStep !== n.timeCellStep ||
          undefined === this._startTime ||
          undefined === this._endTime
        ) {
          var g = bn(e.startTime || "00:00"),
            y = new Date(+bn(e.endTime || "00:00") - 1)
          ;(this._startTime = v = rn(g)),
            (this._endTime = f = rn(y)),
            (this._time = f - v + 1),
            (this._timesBetween = q($(r / o) - 1)),
            (this._times = [])
          for (var b = 6e4 * r, D = $(v / b) * b; D <= f; D += b)
            this._times.push(D)
          p = !0
        }
        if (
          m ||
          c !== n.startDay ||
          d !== n.endDay ||
          _ !== n.slots ||
          e.dayNames !== n.dayNames ||
          e.eventList !== n.eventList ||
          e.getDay !== n.getDay ||
          e.refDate !== n.refDate ||
          e.rowHeight !== n.rowHeight ||
          e.selected !== n.selected ||
          e.size !== n.size ||
          e.showDays !== n.showDays ||
          e.type !== n.type ||
          e.weekNumbers !== n.weekNumbers
        ) {
          var C = "day" === e.type,
            w = "month" === e.type,
            k = void 0,
            x = void 0,
            T = void 0,
            S = void 0
          if (a > 1 || w) {
            var E = {
                eventRange: e.type,
                eventRangeSize: a,
                firstDay: l,
                getDate: e.getDate,
                getDay: e.getDay,
                getMonth: e.getMonth,
                getYear: e.getYear,
                refDate: e.refDate
              },
              M = Wn(s, E)
            ;(k = An(M, E)),
              (x = An(M + 1, E)),
              "week" === e.type &&
                ((k = kn(k, c - l + (c < l ? 7 : 0))),
                (x = kn(k, 7 * a + d - c + 1 - (d < c ? 0 : 7)))),
              (T = k),
              (S = x)
          } else {
            ;(T = kn(mn(s, e), c - l + (c < l ? 7 : 0))),
              (S = kn(T, d - c + 1 + (d < c ? 7 : 0))),
              (k = C ? hn(s) : T),
              (x = C ? kn(k, 1) : S)
          }
          ;(this._dayRefs = []),
            (this._isMulti = a > 1),
            (this._hasHierarchy = !1),
            (this._resources =
              u && u.length ? this._flattenResources(u, []) : [{ id: ss }]),
            (this._hasSlots = i && !!_ && _.length > 0),
            (this._slots = _ && _.length ? _ : [{ id: ss }]),
            (this._isSingleResource = 1 === this._resources.length),
            (this._groupByResource =
              ("date" !== e.groupBy && !(C && a < 2)) ||
              this._isSingleResource),
            (this._firstDay = k),
            (this._lastDay = x),
            (this._selectedDay = +hn(s)),
            (this._setRowHeight = e.eventList || "equal" !== e.rowHeight),
            (this._shouldAnimateScroll = undefined !== n.selected),
            (this._showTimeIndicator =
              !w &&
              !e.eventList &&
              (C ? pn(new Date(), s) : k <= new Date() && x >= new Date())),
            (this._weekDays = [])
          var L = e.dateFormat.search(/m/i),
            N = e.dateFormat.search(/y/i) < L,
            H = 0,
            O = 0,
            I = -1,
            z = -1,
            P = 0,
            R = -1,
            Y = -1,
            U = 0,
            A = k,
            W = x
          !i && C && 1 === a && ((A = T), (W = S))
          for (D = hn(A); D < hn(W); D.setDate(D.getDate() + 1))
            if (xn(D.getDay(), c, d)) {
              var F = "",
                V = ""
              if (i) {
                var B = e.getWeekNumber(kn(D, (7 - l + 1) % 7))
                if (I !== e.getMonth(D)) {
                  ;-1 !== z && (this._dayRefs[z].monthDays = P),
                    (P = 0),
                    (z = H),
                    (I = e.getMonth(D))
                  var X = e.getYear(D),
                    j = e.monthNames[I]
                  ;(F = N ? X + " " + j : j + " " + X),
                    H > 0 && (this._weekDays[H - 1].last = !0)
                }
                ;(0 !== H && R === B) ||
                  (-1 !== Y && (this._dayRefs[Y].weekDays = U),
                  (U = 0),
                  (Y = H),
                  (R = B),
                  (V = e.weekText.replace(/{count}/, R)),
                  H > 0 && (this._weekDays[H - 1].lastWeek = !0))
              }
              this._dayRefs.push({ monthIndex: z, weekIndex: Y }),
                this._weekDays.push({
                  date: Dn(
                    w || this._isMulti ? "D DDD" : e.dateFormatLong,
                    D,
                    e
                  ),
                  dateKey: dn(D),
                  dateObj: new Date(D),
                  day: e.getDay(D),
                  month: F,
                  timestamp: +hn(D),
                  week: V
                }),
                O++,
                P++,
                U++,
                H++
            }
          ;(this._days = O),
            -1 !== z && (this._dayRefs[z].monthDays = P),
            -1 !== Y && (this._dayRefs[Y].weekDays = U),
            (p = !0)
        }
        ;(e.colorsMap !== n.colorsMap || p) &&
          (this._colors = this._getColors(
            this._firstDay,
            this._lastDay,
            e.colorsMap
          )),
          (e.eventMap === n.eventMap && !p && this._events) ||
            ((this._eventRows = {}),
            (this._events = this._getEvents(
              this._firstDay,
              this._lastDay,
              e.eventMap
            ))),
          (e.invalidsMap !== n.invalidsMap || p) &&
            (this._invalids = this._getInvalids(
              this._firstDay,
              this._lastDay,
              e.invalidsMap
            ))
        var G = i && e.eventList && e.eventMap !== n.eventMap
        ;(e.height !== n.height || e.width !== n.width || G || p) &&
          (this._shouldCheckSize = h && !!e.height && !!e.width),
          e.scroll !== n.scroll && (this._shouldScroll = !0),
          (this._hasSticky = ge && !e.rtl),
          (this._hierarchyChange = !1),
          (this._stepCell = 6e4 * r),
          (this._stepLabel = 6e4 * o),
          (this._dayNames =
            t.dayNameWidth > 49 ? e.dayNamesShort : e.dayNamesMin),
          (this._displayTime = o < 1440),
          (this._eventHeight = e.eventList
            ? (t.eventHeight || 18) + 2
            : t.eventHeight || 42),
          (this._headerClass =
            " mbsc-timeline-header-placeholder mbsc-timeline-header-row-" +
            (1 +
              (this._isMulti ? 1 : 0) +
              (this._displayTime || this._hasSlots ? 1 : 0) +
              (e.weekNumbers ? 1 : 0)))
      }),
      (i.prototype._mounted = function() {
        var e,
          t,
          n,
          i = this
        ;(this._unlisten = Zt(this._el, {
          onDoubleClick: function(e) {
            var t = i.s
            n &&
              t.clickToCreate &&
              "single" !== t.clickToCreate &&
              ((e.click = !0), i._onEventDragStart(e), i._onEventDragEnd(e))
          },
          onEnd: function(n) {
            !e &&
              t &&
              "single" === i.s.clickToCreate &&
              ((e = !0), (n.click = !0), i._onEventDragStart(n)),
              e && (n.domEvent.preventDefault(), i._onEventDragEnd(n)),
              clearTimeout(i._touchTimer),
              (e = !1),
              (t = !1)
          },
          onMove: function(n) {
            var s = i.s
            e && s.dragToCreate
              ? (n.domEvent.preventDefault(), i._onEventDragMove(n))
              : t &&
                s.dragToCreate &&
                (Math.abs(n.deltaX) > 7 || Math.abs(n.deltaY) > 7)
              ? ((e = !0), i._onEventDragStart(n))
              : clearTimeout(i._touchTimer)
          },
          onStart: function(s) {
            var a = i.s
            if (
              ((s.create = !0),
              (s.click = !1),
              !e && (a.dragToCreate || a.clickToCreate))
            ) {
              var o = (s.domEvent.target && s.domEvent.target.classList) || []
              ;(n =
                o.contains("mbsc-schedule-item") ||
                o.contains("mbsc-schedule-all-day-item") ||
                o.contains("mbsc-timeline-column")) &&
                (s.isTouch && a.dragToCreate
                  ? (i._touchTimer = setTimeout(function() {
                      i._onEventDragStart(s), i._onEventDragModeOn(s), (e = !0)
                    }, 350))
                  : (t = !s.isTouch))
            }
          }
        })),
          (this._unsubscribe = Yi(this._onExternalDrag))
      }),
      (i.prototype._updated = function() {
        var e = this
        if (
          (this._shouldScroll &&
            (setTimeout(function() {
              e._scrollToTime(e._shouldAnimateScroll)
            }),
            (this._shouldScroll = !1)),
          this._shouldCheckSize)
        ) {
          var t,
            n,
            i,
            s = this._scrollCont,
            a = this.state.eventHeight
          if (this._isTimeline) {
            n =
              (this._stepCell * this._gridCont.offsetWidth) /
              (this._time * this._days)
            var o = s.offsetHeight - s.clientHeight
            if (
              ((this._headerCont.parentNode.style.bottom = o + "px"),
              !this._hasSticky &&
                this._resCont &&
                (this._resCont.style.bottom = o + "px"),
              this._setRowHeight)
            ) {
              var r = s.querySelector(".mbsc-schedule-event")
              r && (a = r.clientHeight)
            }
          } else {
            var l = this._el.querySelector(".mbsc-schedule-column-inner"),
              c = this._el.querySelector(".mbsc-schedule-header-item")
            ;(t = (this._stepCell * l.offsetHeight) / this._time),
              (i = c ? c.offsetWidth : 0)
          }
          this._onScroll(),
            (this._shouldCheckSize = !1),
            setTimeout(function() {
              e.setState({
                cellHeight: t,
                cellWidth: n,
                dayNameWidth: i,
                eventHeight: a,
                hasScrollX: s.scrollWidth > s.clientWidth,
                hasScrollY: s.scrollHeight > s.clientHeight
              })
            })
        }
      }),
      (i.prototype._destroy = function() {
        this._unlisten(), Ui(this._unsubscribe)
      }),
      (i.prototype._getDragDates = function(e, t, i) {
        var s = this.s,
          a = {},
          o = new Map(),
          r = this._firstDay,
          l = e.startDate,
          c = e.endDate,
          d = +c - +l
        for (
          l = (l = hn(l)) < r ? r : l,
            c = this.s.exclusiveEndDates || !e.allDay ? c : hn(kn(c, 1));
          l < c || !d;

        ) {
          var h = n({}, e),
            u =
              xn(l.getDay(), s.startDay, s.endDay) && this._getEventPos(e, l, o)
          u &&
            ((h.cssClass = u.cssClass),
            (h.start = u.start),
            (h.end = u.end),
            (h.position = u.position),
            (a[t + "__" + (this._isTimeline ? i + "__" : "") + dn(l)] = h)),
            (l = kn(l, 1)),
            (d = 1)
        }
        return a
      }),
      (i.prototype._getGridTime = function(e, t, n, i, s) {
        var a,
          o,
          r =
            ((a = this._isTimeline
              ? $((this._time * (t - i * this._colWidth)) / this._colWidth)
              : $((this._time * (n - 8)) / (this._colHeight - 16))),
            $(a / (o = 6e4 * s)) * o),
          l = new Date(+new Date(1970, 0, 1) + this._startTime + r)
        return yn(
          this.s,
          e.getFullYear(),
          e.getMonth(),
          e.getDate(),
          l.getHours(),
          l.getMinutes()
        )
      }),
      (i.prototype._scrollToTime = function(e) {
        var t = this._scrollCont,
          n = this._isTimeline
        if (t) {
          var i = this.s,
            s = yn(i, i.selected)
          s.setHours(i.eventList ? 0 : s.getHours(), 0)
          var a = ls(s, this._startTime, this._time * (n ? this._days : 1)),
            o = void 0
          if (n) {
            var r = (100 * _n(this._firstDay, s)) / this._days + a
            o = (this._gridCont.offsetWidth * r) / 100
          } else {
            o =
              (t.querySelector(".mbsc-schedule-column-inner").offsetHeight *
                a) /
              100
          }
          Me(t, o, e, n, i.rtl)
        }
      }),
      (i.prototype._flattenResources = function(e, t) {
        for (var n = 0, i = e; n < i.length; n++) {
          var s = i[n]
          t.push(s),
            s.children &&
              ((this._hasHierarchy = !0),
              s.collapsed || this._flattenResources(s.children, t))
        }
        return t
      }),
      i
    )
  })(Yt),
  us = {},
  _s = /*#__PURE__*/ (function(e) {
    function i() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t._onClick = function(e) {
          t._triggerClick("onClick", e)
        }),
        (t._onRightClick = function(e) {
          t._triggerClick("onRightClick", e)
        }),
        (t._onDocTouch = function(e) {
          be(t._doc, "touchstart", t._onDocTouch),
            be(t._doc, Wt, t._onDocTouch),
            (t._isDrag = !1),
            t._hook("onDragModeOff", { event: t.s.event })
        }),
        (t._updateState = function(e) {
          t.setState(e)
        }),
        t
      )
    }
    return (
      t(i, e),
      (i.prototype._render = function(e, t) {
        var i = new Date(e.timestamp),
          s = e.event,
          a = s.position,
          o = s.startDate,
          r = cn(e, s.allDay, o, s.endDate),
          l = e.isTimeline,
          c = e.isListing,
          d = c || s.allDay,
          h = !pn(o, r),
          u = h && pn(o, i),
          _ = h && pn(r, i),
          m = d && (!l || c),
          p = l ? "timeline" : "schedule",
          v = e.gridStartTime,
          f = e.gridEndTime,
          g = rn(o),
          y = rn(r),
          b = l && e.slot !== ss,
          D = new Date(e.lastDay),
          C = xn(r.getDay(), e.startDay, e.endDay)
        ;(this._isStart = b || !h || u),
          (this._isEnd = b || !h || (d || l ? r < D && C : _)),
          b || d || !(v > g || f < g) || (this._isStart = !1),
          b || d || !(f < y || v > y) || (this._isEnd = !1),
          (this._html = this._content = undefined),
          (this._isDrag = this._isDrag || e.isDrag),
          (this._rangeText = s.start + " - " + s.end),
          (this._isAllDay = m),
          (this._host = p),
          (s.allDay || (!l && h && !u && !_)) &&
            (this._rangeText = s.allDayText),
          (this._cssClass =
            "mbsc-schedule-event" +
            this._theme +
            this._rtl +
            (l ? " mbsc-timeline-event" : "") +
            (c ? " mbsc-timeline-event-listing" : "") +
            (this._isStart ? " mbsc-" + p + "-event-start" : "") +
            (this._isEnd ? " mbsc-" + p + "-event-end" : "") +
            (m ? " mbsc-schedule-event-all-day" : "") +
            (t.hasFocus && !e.inactive ? " mbsc-schedule-event-active" : "") +
            (!t.hasHover || e.inactive || this._isDrag
              ? ""
              : " mbsc-schedule-event-hover") +
            (e.isDrag
              ? " mbsc-schedule-event-dragging" +
                (l ? " mbsc-timeline-event-dragging" : "")
              : "") +
            (e.hidden ? " mbsc-schedule-event-hidden" : "") +
            (e.inactive ? " mbsc-schedule-event-inactive" : "") +
            (!1 === s.original.editable ? " mbsc-readonly-event" : "")),
          (this._style = n({}, a, {
            color: s.color,
            top:
              e.eventHeight && undefined !== a.top
                ? a.top * e.eventHeight + "px"
                : a.top
          }))
        var w = e.render || e.renderContent
        if (w) {
          var k = w(s)
          F(k)
            ? ((this._html = this._safeHtml(k)), (this._shouldEnhance = !0))
            : (this._content = k)
        } else e.contentTemplate || (this._html = s.html)
      }),
      (i.prototype._mounted = function() {
        var e,
          t,
          i = this,
          s = this.s.event.uid,
          a = us[s]
        a || ((a = new l()), (us[s] = a)),
          (this._unsubscribe = a.subscribe(this._updateState)),
          (this._doc = De(this._el)),
          (this._unlisten = Zt(this._el, {
            keepFocus: !0,
            onBlur: function() {
              a.next({ hasFocus: !1 })
            },
            onDoubleClick: function(e) {
              e.domEvent.stopPropagation(),
                i._triggerClick("onDoubleClick", e.domEvent)
            },
            onEnd: function(s) {
              if (i._isDrag) {
                var a = i.s,
                  o = n({}, s)
                o.domEvent.preventDefault(),
                  (o.event = a.event),
                  (o.resource = a.resource),
                  (o.slot = a.slot),
                  a.resize && e
                    ? ((o.resize = !0), (o.direction = e))
                    : a.drag && (o.drag = !0),
                  i._hook("onDragEnd", o),
                  a.isDrag || (i._isDrag = !1),
                  i._el && o.moved && i._el.blur()
              }
              clearTimeout(t), (e = undefined)
            },
            onFocus: function() {
              a.next({ hasFocus: !0 })
            },
            onHoverIn: function(e) {
              a.next({ hasHover: !0 }), i._triggerClick("onHoverIn", e)
            },
            onHoverOut: function(e) {
              a.next({ hasHover: !1 }), i._triggerClick("onHoverOut", e)
            },
            onKeyDown: function(e) {
              var t = i.s.event.original
              switch (e.keyCode) {
                case 13:
                case 32:
                  i._el.click(), e.preventDefault()
                  break
                case 8:
                case 46:
                  i.state.hasFocus &&
                    !1 !== t.editable &&
                    i._hook("onDelete", {
                      domEvent: e,
                      event: t,
                      source: i._host
                    })
              }
            },
            onMove: function(s) {
              var a = i.s,
                o = n({}, s)
              if (
                ((o.event = a.event),
                (o.resource = a.resource),
                (o.slot = a.slot),
                e)
              )
                (o.resize = !0), (o.direction = e)
              else {
                if (!a.drag) return
                o.drag = !0
              }
              !1 !== a.event.original.editable &&
                ((!i._isDrag && o.isTouch) || o.domEvent.preventDefault(),
                i._isDrag
                  ? i._hook("onDragMove", o)
                  : (Math.abs(o.deltaX) > 7 || Math.abs(o.deltaY) > 7) &&
                    (clearTimeout(t),
                    o.isTouch || ((i._isDrag = !0), i._hook("onDragStart", o))))
            },
            onStart: function(s) {
              var a = i.s,
                o = n({}, s),
                r = o.domEvent.target
              if (
                ((o.event = a.event),
                (o.resource = a.resource),
                (o.slot = a.slot),
                a.resize && r.classList.contains("mbsc-schedule-event-resize"))
              )
                (e = r.classList.contains("mbsc-schedule-event-resize-start")
                  ? "start"
                  : "end"),
                  (o.resize = !0),
                  (o.direction = e)
              else {
                if (!a.drag) return
                o.drag = !0
              }
              !1 !== a.event.original.editable &&
                (i._isDrag
                  ? (o.domEvent.stopPropagation(), i._hook("onDragStart", o))
                  : o.isTouch &&
                    (t = setTimeout(function() {
                      i._hook("onDragModeOn", o),
                        i._hook("onDragStart", o),
                        (i._isDrag = !0)
                    }, 350)))
            }
          })),
          this._isDrag &&
            (ye(this._doc, "touchstart", this._onDocTouch),
            ye(this._doc, Wt, this._onDocTouch))
      }),
      (i.prototype._destroy = function() {
        if ((this._el && this._el.blur(), this._unsubscribe)) {
          var e = this.s.event.uid,
            t = us[e]
          t.unsubscribe(this._unsubscribe), t.nr || delete us[e]
        }
        this._unlisten && this._unlisten(),
          be(this._doc, "touchstart", this._onDocTouch),
          be(this._doc, Wt, this._onDocTouch)
      }),
      (i.prototype._triggerClick = function(e, t) {
        var n = this.s
        this._hook(e, {
          date: n.timestamp,
          domEvent: t,
          event: n.event.original,
          resource: n.resource,
          slot: n.slot,
          source: this._host
        })
      }),
      i
    )
  })(Yt),
  ms = /*#__PURE__*/ (function(e) {
    function n() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(n, e),
      (n.prototype._template = function(e) {
        var t = e.event,
          n = this._isAllDay,
          i = e.isTimeline,
          s = this._theme,
          a = e.resize && !1 !== t.original.editable
        return mt(
          "div",
          {
            tabIndex: 0,
            className: this._cssClass,
            "data-id": t.id,
            style: this._style,
            ref: this._setEl,
            title: t.tooltip,
            onClick: this._onClick,
            onContextMenu: this._onRightClick
          },
          this._isStart &&
            a &&
            mt("div", {
              className:
                "mbsc-schedule-event-resize mbsc-schedule-event-resize-start" +
                (i ? " mbsc-timeline-event-resize" : "") +
                this._rtl +
                (e.isDrag ? " mbsc-schedule-event-resize-start-touch" : "")
            }),
          this._isEnd &&
            a &&
            mt("div", {
              className:
                "mbsc-schedule-event-resize mbsc-schedule-event-resize-end" +
                (i ? " mbsc-timeline-event-resize" : "") +
                this._rtl +
                (e.isDrag ? " mbsc-schedule-event-resize-end-touch" : "")
            }),
          e.render
            ? this._content
              ? this._content
              : mt("div", {
                  style: { height: "100%" },
                  dangerouslySetInnerHTML: this._html
                })
            : mt(
                Fe,
                null,
                !n &&
                  !i &&
                  mt("div", {
                    className: "mbsc-schedule-event-bar" + s + this._rtl
                  }),
                mt("div", {
                  className:
                    "mbsc-schedule-event-background" +
                    (i ? " mbsc-timeline-event-background" : "") +
                    (n ? " mbsc-schedule-event-all-day-background" : "") +
                    s,
                  style: { background: t.style.background }
                }),
                mt(
                  "div",
                  {
                    className:
                      "mbsc-schedule-event-inner" +
                      s +
                      (n ? " mbsc-schedule-event-all-day-inner" : "") +
                      (t.cssClass || ""),
                    style: { color: t.style.color }
                  },
                  mt(
                    "div",
                    {
                      className:
                        "mbsc-schedule-event-title" +
                        (n ? " mbsc-schedule-event-all-day-title" : "") +
                        s,
                      dangerouslySetInnerHTML: this._html
                    },
                    this._content
                  ),
                  !n &&
                    mt(
                      "div",
                      { className: "mbsc-schedule-event-range" + s },
                      this._rangeText
                    )
                )
              )
        )
      }),
      n
    )
  })(_s),
  ps = /*#__PURE__*/ (function(e) {
    function n() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t._onScroll = function() {
          var e = t._scrollCont
          if (e) {
            var n = e.scrollTop,
              i = "translateX(" + -e.scrollLeft + "px)",
              s = t._timeCont,
              a = t._allDayCont,
              o = t._headerCont,
              r = (ve ? ve + "T" : "t") + "ransform"
            a && (a.style[r] = i),
              s && (s.style.marginTop = -n + "px"),
              o && (o.style[r] = i),
              0 === n
                ? t.setState({ showShadow: !1 })
                : t.state.showShadow || t.setState({ showShadow: !0 })
          }
        }),
        t
      )
    }
    return (
      t(n, e),
      (n.prototype._render = function(t, n) {
        e.prototype._render.call(this, t, n)
        var i = this._stepCell / 6e4,
          s = $(this._startTime / 6e4) % i,
          a = ($(this._endTime / 6e4) % i) + 1
        ;(this._largeDayNames = n.dayNameWidth > 99),
          (this._startCellStyle =
            s % i != 0
              ? { height: (n.cellHeight || 50) * (((i - s) % i) / i) + "px" }
              : undefined),
          (this._endCellStyle =
            a % i != 0
              ? { height: ((n.cellHeight || 50) * (a % i)) / i + "px" }
              : undefined)
      }),
      n
    )
  })(hs),
  vs = /*#__PURE__*/ (function(e) {
    function n() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(n, e),
      (n.prototype._template = function(e) {
        return mt(
          "div",
          { className: this._cssClass, style: this._pos },
          mt(
            "div",
            {
              className:
                "mbsc-schedule-time-indicator-time mbsc-schedule-time-indicator-time-" +
                e.orientation +
                this._theme +
                this._rtl
            },
            this._time
          ),
          e.showDayIndicator &&
            mt("div", {
              className: "mbsc-schedule-time-indicator-day" + this._theme,
              style: this._dayPos
            })
        )
      }),
      n
    )
  })(
    /*#__PURE__*/ (function(e) {
      function n() {
        return (null !== e && e.apply(this, arguments)) || this
      }
      return (
        t(n, e),
        (n.prototype._mounted = function() {
          var e = this
          clearInterval(this._timer),
            (this._timer = setInterval(function() {
              e._zone
                ? e._zone.runOutsideAngular(function() {
                    e.forceUpdate()
                  })
                : e.forceUpdate()
            }, 1e4))
        }),
        (n.prototype._destroy = function() {
          clearInterval(this._timer)
        }),
        (n.prototype._render = function(e) {
          var t = yn(e),
            n = e.rtl,
            i = e.displayedDays,
            s = e.displayedTime,
            a = e.startTime,
            o = rn(t)
          ;(this._time = Dn(e.timeFormat, t)),
            (this._cssClass =
              "mbsc-schedule-time-indicator mbsc-schedule-time-indicator-" +
              e.orientation +
              this._theme +
              this._rtl +
              " " +
              (o < a || o > a + s || !xn(t.getDay(), e.startDay, e.endDay)
                ? " mbsc-hidden"
                : ""))
          for (
            var r = -1, l = hn(e.firstDay);
            l <= hn(t);
            l.setDate(l.getDate() + 1)
          )
            xn(l.getDay(), e.startDay, e.endDay) && r++
          if ("x" === e.orientation) {
            var c = (100 * r) / i + "%"
            ;(this._pos = { top: (100 * (o - a)) / s + "%" }),
              (this._dayPos = {
                left: n ? "" : c,
                right: n ? c : "",
                width: 100 / i + "%"
              })
          } else {
            var d = (100 * (r * s + o - a)) / (i * s) + "%"
            this._pos = { left: n ? "" : d, right: n ? d : "" }
          }
        }),
        n
      )
    })(Yt)
  ),
  fs = /*#__PURE__*/ (function(e) {
    function n() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return (
      t(n, e),
      (n.prototype._template = function(e, t) {
        var n
        return (
          e.renderDay && (n = e.renderDay(this._data)),
          e.renderDayContent && (n = e.renderDayContent(this._data)),
          F(n) &&
            ((n = mt("div", { dangerouslySetInnerHTML: this._safeHtml(n) })),
            (this._shouldEnhance = !0)),
          mt(
            "div",
            {
              ref: this._setEl,
              className: this._cssClass,
              onClick: this._onClick
            },
            e.renderDay
              ? n
              : mt(
                  Fe,
                  null,
                  mt(
                    "div",
                    {
                      className:
                        "mbsc-schedule-header-dayname" +
                        this._theme +
                        (e.selected ? " mbsc-selected" : "") +
                        (e.isToday ? " mbsc-schedule-header-dayname-curr" : "")
                    },
                    e.dayNames[this._day]
                  ),
                  mt(
                    "div",
                    {
                      className:
                        "mbsc-schedule-header-day" +
                        this._theme +
                        this._rtl +
                        (e.selected ? " mbsc-selected" : "") +
                        (e.isToday ? " mbsc-schedule-header-day-today" : "") +
                        (t.hasHover ? " mbsc-hover" : "")
                    },
                    e.day
                  ),
                  e.renderDayContent && n
                )
          )
        )
      }),
      n
    )
  })(
    /*#__PURE__*/ (function(e) {
      function n() {
        var t = (null !== e && e.apply(this, arguments)) || this
        return (
          (t._onClick = function() {
            var e = t.s
            e.selectable && e.onClick(e.timestamp)
          }),
          t
        )
      }
      return (
        t(n, e),
        (n.prototype._render = function(e, t) {
          var n = new Date(e.timestamp)
          ;(this._cssClass =
            "mbsc-schedule-header-item " +
            this._className +
            this._theme +
            this._rtl +
            this._hb +
            (e.largeNames ? " mbsc-schedule-header-item-large" : "") +
            (e.selected ? " mbsc-selected" : "") +
            (t.hasHover ? " mbsc-hover" : "")),
            (this._data = {
              date: n,
              events: e.events,
              resource: e.resource,
              selected: e.selected
            }),
            (this._day = n.getDay())
        }),
        (n.prototype._mounted = function() {
          var e = this
          this._unlisten = Zt(this._el, {
            onHoverIn: function() {
              e.s.selectable && e.setState({ hasHover: !0 })
            },
            onHoverOut: function() {
              e.s.selectable && e.setState({ hasHover: !1 })
            }
          })
        }),
        (n.prototype._destroy = function() {
          this._unlisten && this._unlisten()
        }),
        n
      )
    })(Yt)
  ),
  gs = /*#__PURE__*/ (function(e) {
    function i() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t._setCont = function(e) {
          t._scrollCont = e
        }),
        (t._setTimeCont = function(e) {
          t._timeCont = e
        }),
        (t._setAllDayCont = function(e) {
          t._allDayCont = e
        }),
        (t._setGridCont = function(e) {
          t._gridCont = e
        }),
        (t._setHeaderCont = function(e) {
          t._headerCont = e
        }),
        t
      )
    }
    return (
      t(i, e),
      (i.prototype._template = function(e, t) {
        var i = this,
          s = this._colors,
          a = t.dragData,
          o = a && a.draggedEvent && a.draggedEvent.id,
          r = this._invalids,
          l = this._hb,
          c = this._rtl,
          d = this._times,
          h = this._startTime,
          u = this._endTime,
          _ = this._startCellStyle,
          m = this._endCellStyle,
          p = this._stepLabel,
          v = this._theme,
          f = this._isSingleResource,
          g = e.eventMap || {},
          y = "schedule",
          b = " mbsc-flex-1-0 mbsc-schedule-resource-group" + v + c,
          D = {
            dayNames: this._dayNames,
            largeNames: this._largeDayNames,
            onClick: e.onWeekDayClick,
            renderDay: e.renderDay,
            renderDayContent: e.renderDayContent,
            rtl: e.rtl,
            theme: e.theme
          },
          C = function(t) {
            var n,
              s = t.name
            return (
              e.renderResource &&
                F((s = e.renderResource(t))) &&
                ((n = i._safeHtml(s)), (i._shouldEnhance = !0)),
              s &&
                mt(
                  "div",
                  {
                    key: t.id,
                    className:
                      "mbsc-schedule-resource" +
                      v +
                      c +
                      l +
                      (i._groupByResource
                        ? ""
                        : " mbsc-flex-1-0 mbsc-schedule-col-width")
                  },
                  mt(
                    "div",
                    {
                      dangerouslySetInnerHTML: n,
                      className: "mbsc-schedule-resource-title"
                    },
                    s
                  )
                )
            )
          },
          w = function(t, s, r, l, c, d) {
            var _ = c + "__" + s,
              m = {
                displayTimezone: e.displayTimezone,
                drag: e.dragToMove,
                endDay: e.endDay,
                exclusiveEndDates: e.exclusiveEndDates,
                gridEndTime: u,
                gridStartTime: h,
                lastDay: r,
                render: e.renderEvent,
                renderContent: e.renderEventContent,
                resize: e.dragToResize,
                resource: c,
                rtl: e.rtl,
                startDay: e.startDay,
                theme: e.theme,
                timestamp: l,
                timezonePlugin: e.timezonePlugin
              }
            return mt(
              Fe,
              null,
              t.map(function(t) {
                var s = t.event
                return t.showText
                  ? mt(
                      ms,
                      n({}, m, {
                        event: s,
                        key: s.uid,
                        inactive: o === s.id,
                        onClick: e.onEventClick,
                        onDoubleClick: e.onEventDoubleClick,
                        onRightClick: e.onEventRightClick,
                        onDelete: e.onEventDelete,
                        onHoverIn: e.onEventHoverIn,
                        onHoverOut: e.onEventHoverOut,
                        onDragStart: i._onEventDragStart,
                        onDragMove: i._onEventDragMove,
                        onDragEnd: i._onEventDragEnd,
                        onDragModeOn: i._onEventDragModeOn,
                        onDragModeOff: i._onEventDragModeOff
                      })
                    )
                  : mt(
                      "div",
                      {
                        key: s.uid,
                        className:
                          "mbsc-schedule-event mbsc-schedule-event-all-day mbsc-schedule-event-all-day-placeholder"
                      },
                      mt("div", {
                        className: "mbsc-schedule-event-all-day-inner" + v
                      })
                    )
              }),
              a &&
                a.originDates &&
                a.originDates[_] &&
                !!a.originDates[_].allDay == !!d &&
                mt(
                  ms,
                  n({}, m, {
                    event: a.originDates[_],
                    hidden: a && !!a.draggedDates,
                    isDrag: !0,
                    onDragStart: i._onEventDragStart,
                    onDragMove: i._onEventDragMove,
                    onDragEnd: i._onEventDragEnd,
                    onDragModeOff: i._onEventDragModeOff
                  })
                ),
              a &&
                a.draggedDates &&
                a.draggedDates[_] &&
                !!a.draggedDates[_].allDay == !!d &&
                mt(ms, n({}, m, { event: a.draggedDates[_], isDrag: !0 }))
            )
          }
        return mt(
          "div",
          {
            ref: this._setEl,
            className:
              "mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-wrapper" +
              v +
              (this._days > 7 ? " mbsc-schedule-wrapper-multi" : "")
          },
          mt(
            "div",
            {
              className:
                "mbsc-schedule-header mbsc-flex mbsc-flex-none" + v + c + l
            },
            mt("div", {
              className:
                "mbsc-schedule-time-col mbsc-schedule-time-col-empty" +
                v +
                c +
                l
            }),
            mt(
              "div",
              { className: "mbsc-flex-1-1 mbsc-schedule-header-wrapper" },
              mt(
                "div",
                { ref: this._setHeaderCont, className: "mbsc-flex" },
                "day" === e.type && 1 === e.size
                  ? mt(
                      "div",
                      { className: b },
                      mt(
                        "div",
                        { className: "mbsc-flex" },
                        e.showDays &&
                          this._weekDays.map(function(e) {
                            var t = e.timestamp
                            return mt(
                              fs,
                              n({}, D, {
                                key: t,
                                cssClass: "mbsc-flex-1-1",
                                day: e.day,
                                events: g[e.dateKey],
                                isToday: i._isToday(t),
                                selectable: !0,
                                selected: i._selectedDay === t,
                                timestamp: t
                              })
                            )
                          })
                      ),
                      e.resources &&
                        mt(
                          "div",
                          { className: "mbsc-flex" },
                          this._resources.map(function(e) {
                            return C(e)
                          })
                        )
                    )
                  : this._events.map(function(t, s) {
                      return mt(
                        "div",
                        { className: b, key: s },
                        i._groupByResource
                          ? mt(
                              Fe,
                              null,
                              C(i._resources[s]),
                              mt(
                                "div",
                                { className: "mbsc-flex" },
                                e.showDays &&
                                  i._weekDays.map(function(e) {
                                    var t = e.timestamp
                                    return mt(
                                      fs,
                                      n({}, D, {
                                        key: t,
                                        cssClass:
                                          "mbsc-flex-1-0 mbsc-schedule-col-width",
                                        day: e.day,
                                        events: g[e.dateKey],
                                        isToday: f && i._isToday(t),
                                        resource: i._resources[s].id,
                                        selectable: !1,
                                        selected: f && i._isToday(t),
                                        timestamp: t
                                      })
                                    )
                                  })
                              )
                            )
                          : mt(
                              Fe,
                              null,
                              e.showDays &&
                                t[0] &&
                                mt(
                                  fs,
                                  n({}, D, {
                                    key: t[0].timestamp,
                                    day: t[0].day,
                                    events: g[t[0].key],
                                    isToday: f && i._isToday(t[0].timestamp),
                                    selectable: !1,
                                    selected: i._isToday(t[0].timestamp),
                                    timestamp: t[0].timestamp
                                  })
                                ),
                              e.resources &&
                                mt(
                                  "div",
                                  { className: "mbsc-flex" },
                                  i._resources.map(function(e) {
                                    return C(e)
                                  })
                                )
                            )
                      )
                    })
              )
            ),
            mt("div", { className: "mbsc-schedule-fake-scroll-y" })
          ),
          mt(
            "div",
            {
              className:
                (t.showShadow ? "mbsc-schedule-all-day-wrapper-shadow" : "") + v
            },
            e.showAllDay &&
              mt(
                "div",
                {
                  className:
                    "mbsc-schedule-all-day-wrapper mbsc-flex-none" + v + l
                },
                mt(
                  "div",
                  { className: "mbsc-flex mbsc-schedule-all-day" + v },
                  mt(
                    "div",
                    { className: "mbsc-schedule-time-col" + v + c },
                    mt(
                      "div",
                      { className: "mbsc-schedule-all-day-text" + v },
                      e.allDayText
                    )
                  ),
                  mt(
                    "div",
                    {
                      className:
                        "mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-all-day-group-wrapper"
                    },
                    mt(
                      "div",
                      {
                        ref: this._setAllDayCont,
                        className: "mbsc-flex mbsc-flex-1-1"
                      },
                      this._events.map(function(e, t) {
                        return mt(
                          "div",
                          { className: "mbsc-flex" + b, key: t },
                          e.map(function(e, t) {
                            var n = e.resource,
                              i = e.timestamp,
                              a = e.key,
                              o = s[n][ss][a].allDay
                            return mt(
                              "div",
                              {
                                key: t + "-" + i,
                                className:
                                  "mbsc-schedule-all-day-item mbsc-schedule-col-width mbsc-flex-1-0" +
                                  v +
                                  c +
                                  l
                              },
                              w(e.allDay, a, e.lastDay, i, n, !0),
                              r[n][ss][a].allDay &&
                                mt(
                                  "div",
                                  {
                                    className:
                                      "mbsc-schedule-invalid mbsc-schedule-invalid-all-day" +
                                      v
                                  },
                                  mt(
                                    "div",
                                    { className: "mbsc-schedule-invalid-text" },
                                    r[n][ss][a].allDay.title
                                  )
                                ),
                              o &&
                                mt(
                                  "div",
                                  {
                                    className:
                                      "mbsc-schedule-color mbsc-schedule-color-all-day" +
                                      v,
                                    style: o.position
                                  },
                                  mt(
                                    "div",
                                    { className: "mbsc-schedule-color-text" },
                                    o.title
                                  )
                                )
                            )
                          })
                        )
                      })
                    )
                  )
                )
              )
          ),
          mt(
            "div",
            {
              className:
                "mbsc-flex mbsc-flex-1-1 mbsc-schedule-grid-wrapper" + v
            },
            mt(
              "div",
              {
                className:
                  "mbsc-flex-col mbsc-schedule-time-col mbsc-schedule-time-cont" +
                  v +
                  c,
                ref: this._setTimeCont
              },
              mt(
                "div",
                { className: "mbsc-flex mbsc-schedule-time-cont-inner" },
                mt(
                  "div",
                  { className: "mbsc-flex-col mbsc-flex-1-1" },
                  mt(
                    "div",
                    {
                      className:
                        "mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-time-cont-pos"
                    },
                    d.map(function(e, t) {
                      var n = d.length - 1
                      return mt(
                        "div",
                        {
                          key: t,
                          className:
                            "mbsc-flex-col mbsc-flex-1-0 mbsc-schedule-time-wrapper" +
                            v +
                            c +
                            (t === n ? " mbsc-schedule-time-wrapper-end" : "") +
                            ((0 === t && _) || (t === n && m)
                              ? " mbsc-flex-none"
                              : ""),
                          style: 0 === t ? _ : t === n ? m : {}
                        },
                        mt(
                          "div",
                          {
                            className:
                              "mbsc-flex-1-1 mbsc-schedule-time" + v + c
                          },
                          0 === t || e % p == 0
                            ? i._formatTime(0 === t ? h : e)
                            : ""
                        ),
                        i._timesBetween.map(function(t, n) {
                          var s = e + (n + 1) * p
                          return (
                            s > h &&
                            s < u &&
                            mt(
                              "div",
                              {
                                key: n,
                                className:
                                  "mbsc-flex-1-1 mbsc-schedule-time" + v + c
                              },
                              i._formatTime(s)
                            )
                          )
                        }),
                        t === n &&
                          mt(
                            "div",
                            {
                              className:
                                "mbsc-schedule-time mbsc-schedule-time-end" +
                                v +
                                c
                            },
                            i._formatTime(u + 1)
                          )
                      )
                    }),
                    this._showTimeIndicator &&
                      mt(vs, {
                        displayedTime: this._time,
                        displayedDays: this._days,
                        displayTimezone: e.displayTimezone,
                        endDay: e.endDay,
                        firstDay: this._firstDay,
                        orientation: "x",
                        rtl: e.rtl,
                        showDayIndicator:
                          f && !this._isMulti && "week" === e.type,
                        startDay: e.startDay,
                        startTime: h,
                        theme: e.theme,
                        timeFormat: e.timeFormat,
                        timezonePlugin: e.timezonePlugin
                      })
                  ),
                  t.hasScrollX &&
                    mt("div", { className: "mbsc-schedule-fake-scroll-x" })
                ),
                mt("div", { className: "mbsc-schedule-fake-scroll-y" })
              )
            ),
            mt(
              "div",
              {
                ref: this._setCont,
                className:
                  "mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-grid-scroll" + v,
                onScroll: this._onScroll
              },
              mt(
                "div",
                {
                  className: "mbsc-flex mbsc-schedule-grid",
                  ref: this._setGridCont
                },
                this._events.map(function(t, n) {
                  return mt(
                    "div",
                    { className: "mbsc-flex" + b, key: n },
                    t.map(function(t, n) {
                      var i = t.timestamp,
                        a = t.key,
                        o = t.resource
                      return mt(
                        "div",
                        {
                          key: n + "-" + i,
                          className:
                            "mbsc-flex-col mbsc-flex-1-0 mbsc-schedule-column mbsc-schedule-col-width" +
                            v +
                            c +
                            l
                        },
                        mt(
                          "div",
                          {
                            className:
                              "mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-column-inner" +
                              v +
                              c +
                              l
                          },
                          mt(
                            "div",
                            { className: "mbsc-schedule-events" + c },
                            w(t.events[ss], a, t.lastDay, i, o)
                          ),
                          r[o][ss][a].invalids.map(function(e, t) {
                            return mt(
                              "div",
                              {
                                key: t,
                                className:
                                  "mbsc-schedule-invalid" + e.cssClass + v,
                                style: e.position
                              },
                              mt(
                                "div",
                                { className: "mbsc-schedule-invalid-text" },
                                r[o][ss][a].allDay ? "" : e.title || ""
                              )
                            )
                          }),
                          s[o][ss][a].colors.map(function(e, t) {
                            return mt(
                              "div",
                              {
                                key: t,
                                className:
                                  "mbsc-schedule-color" + e.cssClass + v,
                                style: e.position
                              },
                              mt(
                                "div",
                                { className: "mbsc-schedule-color-text" },
                                e.title
                              )
                            )
                          }),
                          d.map(function(t, n) {
                            var s = ds(i, t)
                            return mt("div", {
                              key: n,
                              className:
                                "mbsc-schedule-item mbsc-flex-1-0" +
                                v +
                                l +
                                (n === d.length - 1
                                  ? " mbsc-schedule-item-last"
                                  : "") +
                                ((0 === n && _) || (n === d.length - 1 && m)
                                  ? " mbsc-flex-none"
                                  : ""),
                              onClick: function(t) {
                                return e.onCellClick({
                                  date: s,
                                  domEvent: t,
                                  resource: o,
                                  source: y
                                })
                              },
                              onDoubleClick: function(t) {
                                return e.onCellDoubleClick({
                                  date: s,
                                  domEvent: t,
                                  resource: o,
                                  source: y
                                })
                              },
                              onContextMenu: function(t) {
                                return e.onCellRightClick({
                                  date: s,
                                  domEvent: t,
                                  resource: o,
                                  source: y
                                })
                              },
                              style: 0 === n ? _ : d.length - 1 === n ? m : {}
                            })
                          })
                        )
                      )
                    })
                  )
                })
              )
            )
          ),
          a &&
            !t.isTouchDrag &&
            mt("div", { className: "mbsc-calendar-dragging" })
        )
      }),
      i
    )
  })(ps)
var ys = /*#__PURE__*/ (function(e) {
    function i() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t._setCont = function(e) {
          t._scrollCont = e
        }),
        (t._setResCont = function(e) {
          t._resCont = e
        }),
        (t._setGridCont = function(e) {
          t._gridCont = e
        }),
        (t._setHeaderCont = function(e) {
          t._headerCont = e
        }),
        t
      )
    }
    return (
      t(i, e),
      (i.prototype._template = function(e, t) {
        var i,
          s,
          a = this,
          o = this._colors,
          r = t.dragData,
          l = r && r.draggedEvent && r.draggedEvent.id,
          c = this._invalids,
          d = this._hb,
          h = this._rtl,
          u = this._times,
          _ = this._theme,
          m = this._startTime,
          p = this._endTime,
          v = this._stepLabel,
          f = this._slots,
          g = "timeline",
          y = e.resources,
          b = e.eventList,
          D = this._startCellStyle,
          C = this._endCellStyle,
          w = this._headerClass,
          k = function(t, n) {
            return (
              n++,
              t.map(function(t) {
                return mt(
                  Fe,
                  { key: t.id },
                  (function(t, n) {
                    var i,
                      s = t.children,
                      o = a._hasHierarchy ? 1.75 * n + "em" : void 0,
                      r = {
                        minHeight: a._setRowHeight
                          ? a._eventRows[t.id] * a._eventHeight + 10
                          : void 0,
                        paddingLeft: e.rtl ? void 0 : o,
                        paddingRight: e.rtl ? o : void 0
                      },
                      l = t.name
                    return (
                      e.renderResource &&
                        F((l = e.renderResource(t))) &&
                        ((i = a._safeHtml(l)), (a._shouldEnhance = !0)),
                      mt(
                        "div",
                        {
                          key: t.id,
                          className:
                            "mbsc-timeline-resource" +
                            _ +
                            h +
                            d +
                            (s ? " mbsc-timeline-parent mbsc-flex" : ""),
                          style: r
                        },
                        s &&
                          mt(Ut, {
                            className: "mbsc-timeline-resource-icon" + h + d,
                            svg: t.collapsed
                              ? e.rtl
                                ? e.nextIconRtl
                                : e.nextIcon
                              : e.downIcon,
                            theme: e.theme,
                            onClick: function() {
                              return a._onParentClick(t)
                            }
                          }),
                        mt(
                          "div",
                          {
                            className:
                              "mbsc-timeline-resource-title" +
                              (s ? " mbsc-flex-1-1" : ""),
                            dangerouslySetInnerHTML: i
                          },
                          l
                        )
                      )
                    )
                  })(t, n),
                  !t.collapsed &&
                    t.children &&
                    mt(
                      "div",
                      { className: "mbsc-timeline-resource-children" },
                      k(t.children, n)
                    )
                )
              })
            )
          },
          x = function(t) {
            return t.map(function(t) {
              return mt(
                Fe,
                { key: t.id },
                (function(t, i) {
                  var s = a._events[i]
                  return mt(
                    "div",
                    {
                      key: t.id,
                      className:
                        "mbsc-flex mbsc-timeline-row" +
                        _ +
                        d +
                        (t.children ? " mbsc-timeline-parent" : ""),
                      style: {
                        minHeight: a._setRowHeight
                          ? a._eventRows[t.id] * a._eventHeight + 10
                          : void 0
                      }
                    },
                    s.map(function(t, i) {
                      var s = t.resource,
                        v = t.timestamp,
                        y = t.key
                      return mt(
                        "div",
                        {
                          key: i,
                          className:
                            "mbsc-timeline-day mbsc-flex mbsc-flex-1-1" +
                            _ +
                            h +
                            d +
                            ("month" === e.type || a._isMulti
                              ? " mbsc-timeline-day-month"
                              : "")
                        },
                        f.map(function(i, f) {
                          var w = i.id,
                            k = s + "__" + w + "__" + y,
                            x = {
                              displayTimezone: e.displayTimezone,
                              drag: e.dragToMove,
                              endDay: e.endDay,
                              eventHeight: a._setRowHeight
                                ? a._eventHeight
                                : void 0,
                              exclusiveEndDates: e.exclusiveEndDates,
                              gridEndTime: p,
                              gridStartTime: m,
                              isListing: b,
                              isTimeline: !0,
                              lastDay: t.lastDay,
                              render: e.renderEvent,
                              renderContent: e.renderEventContent,
                              resize: e.dragToResize,
                              resource: s,
                              rtl: e.rtl,
                              slot: w,
                              startDay: e.startDay,
                              theme: e.theme,
                              timestamp: v,
                              timezonePlugin: e.timezonePlugin
                            }
                          return mt(
                            "div",
                            {
                              key: f,
                              className:
                                "mbsc-flex mbsc-flex-1-1" +
                                (a._hasSlots ? " mbsc-timeline-slot" : "")
                            },
                            mt(
                              "div",
                              { className: "mbsc-timeline-events" },
                              t.events[w].map(function(t) {
                                var i = t.event
                                return t.showText
                                  ? mt(
                                      ms,
                                      n({}, x, {
                                        event: i,
                                        inactive: l === i.id,
                                        key: i.uid,
                                        onClick: e.onEventClick,
                                        onDoubleClick: e.onEventDoubleClick,
                                        onRightClick: e.onEventRightClick,
                                        onHoverIn: e.onEventHoverIn,
                                        onHoverOut: e.onEventHoverOut,
                                        onDelete: e.onEventDelete,
                                        onDragStart: a._onEventDragStart,
                                        onDragMove: a._onEventDragMove,
                                        onDragEnd: a._onEventDragEnd,
                                        onDragModeOn: a._onEventDragModeOn,
                                        onDragModeOff: a._onEventDragModeOff
                                      })
                                    )
                                  : mt(
                                      "div",
                                      {
                                        key: i.uid,
                                        className:
                                          "mbsc-schedule-event mbsc-schedule-event-all-day-placeholder mbsc-timeline-event-listing"
                                      },
                                      mt("div", {
                                        className:
                                          "mbsc-schedule-event-all-day-inner" +
                                          _
                                      })
                                    )
                              }),
                              r &&
                                r.originDates &&
                                r.originDates[k] &&
                                mt(
                                  ms,
                                  n({}, x, {
                                    event: r.originDates[k],
                                    hidden: r && !!r.draggedDates,
                                    isDrag: !0,
                                    onDragStart: a._onEventDragStart,
                                    onDragMove: a._onEventDragMove,
                                    onDragEnd: a._onEventDragEnd,
                                    onDragModeOff: a._onEventDragModeOff
                                  })
                                ),
                              r &&
                                r.draggedDates &&
                                r.draggedDates[k] &&
                                mt(
                                  ms,
                                  n({}, x, {
                                    event: r.draggedDates[k],
                                    isDrag: !0
                                  })
                                )
                            ),
                            c[s][w][y].invalids.map(function(e, t) {
                              return (
                                e.position &&
                                mt(
                                  "div",
                                  {
                                    key: t,
                                    className:
                                      "mbsc-schedule-invalid mbsc-timeline-invalid" +
                                      e.cssClass +
                                      _,
                                    style: e.position
                                  },
                                  mt(
                                    "div",
                                    { className: "mbsc-schedule-invalid-text" },
                                    c[s][w][y].allDay ? "" : e.title || ""
                                  )
                                )
                              )
                            }),
                            o[s][w][y].colors.map(function(e, t) {
                              return mt(
                                "div",
                                {
                                  key: t,
                                  className:
                                    "mbsc-schedule-color mbsc-timeline-color" +
                                    e.cssClass +
                                    _,
                                  style: e.position
                                },
                                mt(
                                  "div",
                                  { className: "mbsc-schedule-color-text" },
                                  e.title
                                )
                              )
                            }),
                            u.map(function(t, n) {
                              var i = ds(v, t)
                              return mt("div", {
                                key: n,
                                className:
                                  "mbsc-timeline-column mbsc-flex-1-1" +
                                  _ +
                                  h +
                                  d +
                                  ((0 === n && D) || (n === u.length - 1 && C)
                                    ? " mbsc-flex-none"
                                    : ""),
                                onClick: function(t) {
                                  return e.onCellClick({
                                    date: i,
                                    domEvent: t,
                                    resource: s,
                                    slot: w,
                                    source: g
                                  })
                                },
                                onDoubleClick: function(t) {
                                  return e.onCellDoubleClick({
                                    date: i,
                                    domEvent: t,
                                    resource: s,
                                    slot: w,
                                    source: g
                                  })
                                },
                                onContextMenu: function(t) {
                                  return e.onCellRightClick({
                                    date: i,
                                    domEvent: t,
                                    resource: s,
                                    slot: w,
                                    source: g
                                  })
                                },
                                style: 0 === n ? D : u.length - 1 === n ? C : {}
                              })
                            })
                          )
                        })
                      )
                    })
                  )
                })(t, a._resources.indexOf(t)),
                !t.collapsed && t.children && mt("div", null, x(t.children))
              )
            })
          }
        return mt(
          "div",
          {
            ref: this._setEl,
            className:
              "mbsc-timeline mbsc-flex-1-1 mbsc-flex-col" +
              (y ? "" : " mbsc-timeline-no-resource") +
              _ +
              h
          },
          mt("div", { className: "mbsc-flex-none" + w }),
          mt(
            "div",
            { className: "mbsc-timeline-header mbsc-flex" + _ + h + d },
            y &&
              mt(
                "div",
                {
                  className:
                    "mbsc-timeline-resource-empty mbsc-timeline-resource-col" +
                    w +
                    _ +
                    h +
                    d
                },
                (e.renderResourceHeader &&
                  F((i = e.renderResourceHeader())) &&
                  ((s = a._safeHtml(i)), (a._shouldEnhance = !0)),
                mt(
                  "div",
                  {
                    className: "mbsc-timeline-resource-header",
                    dangerouslySetInnerHTML: s
                  },
                  i
                ))
              ),
            mt(
              "div",
              {
                className: "mbsc-timeline-header-time-cont mbsc-flex-1-1",
                ref: this._setHeaderCont
              },
              this._isMulti &&
                mt(
                  "div",
                  { className: "mbsc-flex" },
                  this._weekDays.map(function(e, t) {
                    return mt(
                      "div",
                      {
                        key: t,
                        className:
                          "mbsc-timeline-month mbsc-flex-1-0-0" +
                          _ +
                          h +
                          d +
                          (e.last ? " mbsc-timeline-day" : "")
                      },
                      mt(
                        "div",
                        {
                          className:
                            "mbsc-timeline-header-month" +
                            _ +
                            h +
                            d +
                            (e.last ? " mbsc-timeline-header-month-last" : "")
                        },
                        mt(
                          "div",
                          {
                            className:
                              "mbsc-timeline-header-month-text" +
                              _ +
                              (e.last
                                ? " mbsc-timeline-header-month-text-last"
                                : ""),
                            ref: function(e) {
                              e && (a._dayRefs[t].month = e)
                            }
                          },
                          e.month || " "
                        )
                      )
                    )
                  })
                ),
              e.weekNumbers &&
                mt(
                  "div",
                  { className: "mbsc-flex" },
                  this._weekDays.map(function(e, t) {
                    return mt(
                      "div",
                      {
                        key: t,
                        className:
                          "mbsc-timeline-month mbsc-flex-1-0-0" +
                          _ +
                          h +
                          d +
                          (e.lastWeek ? " mbsc-timeline-day" : "")
                      },
                      mt(
                        "div",
                        {
                          className:
                            "mbsc-timeline-header-week" +
                            _ +
                            h +
                            d +
                            (e.lastWeek
                              ? " mbsc-timeline-header-week-last"
                              : "")
                        },
                        mt(
                          "div",
                          {
                            className:
                              "mbsc-timeline-header-week-text" +
                              _ +
                              (e.lastWeek
                                ? " mbsc-timeline-header-week-text-last"
                                : ""),
                            ref: function(e) {
                              e && (a._dayRefs[t].week = e)
                            }
                          },
                          e.week
                        )
                      )
                    )
                  })
                ),
              mt(
                "div",
                { className: "mbsc-flex" },
                this._weekDays.map(function(t, n) {
                  return mt(
                    "div",
                    {
                      key: n,
                      className:
                        "mbsc-timeline-day mbsc-flex-1-0-0" +
                        _ +
                        h +
                        d +
                        ("month" === e.type || a._isMulti
                          ? " mbsc-timeline-day-month"
                          : "")
                    },
                    mt(
                      "div",
                      { className: "mbsc-timeline-header-date" + _ + h + d },
                      mt(
                        "div",
                        {
                          className: "mbsc-timeline-header-date-text" + h,
                          ref: function(e) {
                            e && (a._dayRefs[n].day = e)
                          }
                        },
                        t.date
                      )
                    ),
                    a._hasSlots &&
                      mt(
                        "div",
                        { className: "mbsc-flex mbsc-timeline-slots" + _ },
                        f.map(function(n, i) {
                          return mt(
                            "div",
                            {
                              key: i,
                              className:
                                "mbsc-timeline-slot mbsc-timeline-slot-header" +
                                h +
                                _
                            },
                            n.name &&
                              (function(t) {
                                var n,
                                  i = t.slot,
                                  s = i.name
                                return (
                                  e.renderSlot &&
                                    F((s = e.renderSlot(t))) &&
                                    ((n = a._safeHtml(s)),
                                    (a._shouldEnhance = !0)),
                                  mt(
                                    "div",
                                    {
                                      key: i.id,
                                      className: "mbsc-timeline-slot-title",
                                      dangerouslySetInnerHTML: n
                                    },
                                    s
                                  )
                                )
                              })({ slot: n, date: t.dateObj })
                          )
                        })
                      ),
                    mt(
                      "div",
                      { className: "mbsc-flex" },
                      u.map(function(e, t) {
                        return mt(
                          "div",
                          {
                            key: t,
                            style: 0 === t ? D : u.length - 1 === t ? C : {},
                            className:
                              "mbsc-flex mbsc-flex-1-1 mbsc-timeline-header-column" +
                              _ +
                              h +
                              d +
                              (!a._displayTime || a._hasSlots
                                ? " mbsc-timeline-no-height"
                                : "") +
                              (v > a._stepCell && u[t + 1] % v
                                ? " mbsc-timeline-no-border"
                                : "") +
                              ((0 === t && D) || (t === u.length - 1 && C)
                                ? " mbsc-flex-none"
                                : "")
                          },
                          mt(
                            "div",
                            {
                              className:
                                "mbsc-timeline-header-time mbsc-flex-1-1 " + _
                            },
                            !a._displayTime || (0 !== t && e % v != 0)
                              ? ""
                              : a._formatTime(0 === t ? m : e)
                          ),
                          a._timesBetween.map(function(t, n) {
                            var i = e + (n + 1) * v
                            return (
                              i > m &&
                              i < p &&
                              mt(
                                "div",
                                {
                                  key: n,
                                  className:
                                    "mbsc-timeline-header-time mbsc-flex-1-1 " +
                                    _
                                },
                                a._formatTime(i)
                              )
                            )
                          })
                        )
                      })
                    )
                  )
                })
              ),
              this._showTimeIndicator &&
                mt(vs, {
                  displayedTime: this._time,
                  displayedDays: this._days,
                  displayTimezone: e.displayTimezone,
                  endDay: e.endDay,
                  firstDay: this._firstDay,
                  orientation: "y",
                  rtl: e.rtl,
                  startDay: e.startDay,
                  startTime: m,
                  theme: e.theme,
                  timeFormat: e.timeFormat,
                  timezonePlugin: e.timezonePlugin
                })
            ),
            t.hasScrollY &&
              mt("div", { className: "mbsc-schedule-fake-scroll-y" })
          ),
          mt(
            "div",
            {
              ref: this._setCont,
              className:
                "mbsc-timeline-grid-scroll mbsc-flex mbsc-flex-1-1" + _ + h + d,
              onScroll: this._onScroll
            },
            mt(
              "div",
              { className: "mbsc-flex mbsc-flex-1-1" },
              y &&
                mt(
                  "div",
                  {
                    className:
                      "mbsc-timeline-resources mbsc-timeline-resource-col mbsc-flex-col" +
                      _ +
                      h,
                    ref: this._setResCont
                  },
                  !this._hasSticky &&
                    mt("div", { className: "mbsc-flex-none" + w }),
                  mt(
                    "div",
                    {
                      className:
                        "mbsc-timeline-resource-bg mbsc-flex-1-1" +
                        (this._hasHierarchy ? "" : " mbsc-flex-col") +
                        _
                    },
                    k(y, -1)
                  )
                ),
              !this._hasSticky &&
                y &&
                mt("div", { className: "mbsc-timeline-resource-col" }),
              mt(
                "div",
                { className: "mbsc-flex-col mbsc-flex-1-1" },
                mt(
                  "div",
                  { className: "mbsc-flex-col mbsc-flex-1-1" },
                  mt(
                    "div",
                    {
                      className:
                        "mbsc-timeline-grid mbsc-flex-col" +
                        (this._hasHierarchy ? "" : " mbsc-flex-1-1"),
                      ref: this._setGridCont
                    },
                    x(y || this._resources)
                  )
                )
              )
            )
          ),
          r &&
            !t.isTouchDrag &&
            mt("div", { className: "mbsc-calendar-dragging" })
        )
      }),
      i
    )
  })(
    /*#__PURE__*/ (function(e) {
      function n() {
        var t = (null !== e && e.apply(this, arguments)) || this
        return (
          (t._isTimeline = !0),
          (t._onScroll = function() {
            var e = t.s,
              n = t._scrollCont,
              i = n.scrollTop,
              s = n.scrollLeft,
              a = t._gridCont,
              o = t._resCont,
              r = t._headerCont,
              l = ge && !e.rtl,
              c = (ve ? ve + "T" : "t") + "ransform"
            if ((o && !l && (o.scrollTop = i), r)) {
              var d = a.offsetWidth,
                h = t._isMulti,
                u = t._hasSlots || t._stepCell < 864e5,
                _ = e.weekNumbers
              t._daySticky(e.rtl, t._dayRefs, s, d / t._days, h, u, _),
                (r.style[c] = "translateX(" + -s + "px)")
            }
          }),
          t
        )
      }
      return (
        t(n, e),
        (n.prototype._onParentClick = function(e) {
          ;(e.collapsed = !e.collapsed),
            (this._hierarchyChange = !0),
            this.forceUpdate()
        }),
        (n.prototype._render = function(t, n) {
          e.prototype._render.call(this, t, n)
          var i,
            s,
            a,
            o,
            r,
            l,
            c,
            d,
            h,
            u,
            _,
            m,
            p,
            v,
            f,
            g,
            y = this._stepCell / 6e4,
            b = $(this._startTime / 6e4) % y,
            D = ($(this._endTime / 6e4) % y) + 1
          ;(this._startCellStyle =
            this._displayTime && b % y != 0
              ? { width: (n.cellWidth || 40) * (((y - b) % y) / y) + "px" }
              : undefined),
            (this._endCellStyle =
              this._displayTime && D % y != 0
                ? { width: ((n.cellWidth || 40) * (D % y)) / y + "px" }
                : undefined),
            this._daySticky ||
              (this._daySticky = function(e, t, n, y, b, D, C) {
                var w = e ? -1 : 1,
                  k = e ? "marginRight" : "marginLeft",
                  x = t !== s || y !== g,
                  T = Math.max($(Math.abs(n) / y), 0),
                  S = l,
                  E = _
                ;(g = y),
                  (T !== i || x) &&
                    ((s = t),
                    (i = T),
                    a &&
                      ((a.style.marginLeft = ""), (a.style.marginRight = "")),
                    (a = s[i].day),
                    (o = i * y),
                    (S = s[i].monthIndex),
                    (E = s[i].weekIndex),
                    a && D && (r = a.offsetWidth)),
                  (E !== _ || x) &&
                    ((_ = E),
                    p &&
                      ((p.style.marginLeft = ""), (p.style.marginRight = "")),
                    (p = s[_].week) &&
                      C &&
                      ((v = _ * y),
                      (f = p.offsetWidth),
                      (m = s[_].weekDays * y))),
                  (S !== l || x) &&
                    ((l = S),
                    d &&
                      ((d.style.marginLeft = ""), (d.style.marginRight = "")),
                    (d = s[l].month) &&
                      b &&
                      ((h = l * y),
                      (u = d.offsetWidth),
                      (c = s[l].monthDays * y))),
                  a &&
                    D &&
                    (a.style[k] = Math.min(w * (n - w * o), y - r - 3) + "px"),
                  d &&
                    (d.style[k] =
                      Math.max(0, Math.min(w * (n - w * h), c - u - 3)) + "px"),
                  p &&
                    (p.style[k] =
                      Math.max(0, Math.min(w * (n - w * v), m - f - 3)) + "px")
              })
        }),
        n
      )
    })(hs)
  ),
  bs = /*#__PURE__*/ (function(e) {
    function i() {
      var t = (null !== e && e.apply(this, arguments)) || this
      return (
        (t._instanceService = new Oi()),
        (t._setList = function(e) {
          t._list = e
        }),
        (t._setPopoverList = function(e) {
          t._popoverList = e && e._el
        }),
        (t._setEl = function(e) {
          ;(t._el = e ? e._el || e : null), (t._calendarView = e)
        }),
        t
      )
    }
    return (
      t(i, e),
      (i.prototype._eventRenderer = function(e, t, n, i, s) {
        var a,
          o = this,
          r = !this._colorEventList,
          l = s ? "popover" : "agenda",
          c = !s || this.state.showPopover,
          d = this._theme,
          h = i.renderEventContent
            ? i.renderEventContent(e)
            : mt("div", {
                className: "mbsc-event-text " + d,
                title: e.tooltip,
                dangerouslySetInnerHTML: e.html
              })
        F(h)
          ? ((h = mt("div", {
              className: "mbsc-event-content" + d,
              dangerouslySetInnerHTML: { __html: h }
            })),
            (this._shouldEnhance = c && l))
          : (h = mt("div", { className: "mbsc-event-content" + d }, h))
        var u = i.renderEvent
          ? i.renderEvent(e)
          : mt(
              Fe,
              null,
              mt("div", {
                className: "mbsc-event-color" + d + this._rtl,
                style: e.style
              }),
              h,
              mt(
                "div",
                { className: "mbsc-event-time" + d + this._rtl },
                e.allDayText &&
                  mt(
                    "div",
                    { className: "mbsc-event-all-day" + d },
                    e.allDayText
                  ),
                e.lastDay &&
                  mt("div", { className: "mbsc-event-until" + d }, e.lastDay),
                e.start &&
                  mt("div", { className: "mbsc-event-start" + d }, e.start),
                e.start &&
                  e.end &&
                  mt("div", { className: "mbsc-event-sep" + d }, "-"),
                e.end && mt("div", { className: "mbsc-event-end" + d }, e.end)
              )
            )
        return (
          F(u) &&
            ((a = { __html: u }),
            (u = undefined),
            (this._shouldEnhance = c && l)),
          mt(
            zi,
            {
              className: "mbsc-event" + (r ? "" : " mbsc-colored-event"),
              key: t,
              actionable: i.actionableEvents,
              dangerouslySetInnerHTML: a,
              data: e.original,
              drag: s && this._showEventLabels && i.dragToMove,
              rtl: i.rtl,
              style: r ? undefined : e.style,
              theme: i.theme,
              themeVariant: i.themeVariant,
              onClick: function(t) {
                return o._onEventClick({
                  date: n,
                  domEvent: t,
                  event: e.original,
                  source: l
                })
              },
              onDoubleClick: function(t) {
                return o._onEventDoubleClick({
                  date: n,
                  domEvent: t,
                  event: e.original,
                  source: l
                })
              },
              onContextMenu: function(t) {
                return o._onEventRightClick({
                  date: n,
                  domEvent: t,
                  event: e.original,
                  source: l
                })
              },
              onHoverIn: function(t) {
                var i = t.domEvent
                return o._onEventHoverIn({
                  date: n,
                  domEvent: i,
                  event: e.original,
                  source: l
                })
              },
              onHoverOut: function(t) {
                var i = t.domEvent
                return o._onEventHoverOut({
                  date: n,
                  domEvent: i,
                  event: e.original,
                  source: l
                })
              },
              onDragEnd: this._onLabelUpdateEnd,
              onDragModeOff: this._onLabelUpdateModeOff,
              onDragModeOn: this._onLabelUpdateModeOn,
              onDragMove: this._onLabelUpdateMove,
              onDragStart: this._onLabelUpdateStart
            },
            u
          )
        )
      }),
      (i.prototype._listRenderer = function() {
        var e = this,
          t = this.s,
          n = t.theme,
          i = this._listDays,
          s = this.state.eventList
        return t.renderAgenda
          ? undefined === this._eventListHTML
            ? t.renderAgenda(s, t, i)
            : void 0
          : mt(
              Pi,
              { theme: n, themeVariant: t.themeVariant, rtl: t.rtl },
              !s.length &&
                mt(
                  "div",
                  { className: "mbsc-event-list-empty" + this._theme },
                  t.noEventsText
                ),
              s.map(function(s, a) {
                return mt(
                  "div",
                  {
                    className: "mbsc-event-group" + e._theme,
                    key: a,
                    ref: function(e) {
                      return (i[s.timestamp] = e)
                    }
                  },
                  ("day" !== e._eventListType || e._eventListSize > 1) &&
                    mt(
                      Ii,
                      {
                        theme: n,
                        themeVariant: t.themeVariant,
                        className: "mbsc-event-day"
                      },
                      s.date
                    ),
                  s.events.map(function(n, i) {
                    return e._eventRenderer(n, i, s.timestamp, t)
                  })
                )
              })
            )
      }),
      (i.prototype._template = function(e, t) {
        var i,
          s = this
        this._listDays || (this._listDays = {}),
          this._showEventList &&
            F((i = this._listRenderer())) &&
            ((this._eventListHTML = { __html: i }),
            (this._shouldLoadDays = !0),
            (this._shouldEnhance = !0),
            (i = undefined))
        var a = {
            clickToCreate: e.clickToCreate,
            dataTimezone: e.dataTimezone,
            dateFormat: e.dateFormat,
            dayNames: e.dayNames,
            dayNamesMin: e.dayNamesMin,
            dayNamesShort: e.dayNamesShort,
            displayTimezone: e.displayTimezone,
            dragToCreate: e.dragToCreate,
            dragToMove: e.dragToMove,
            dragToResize: e.dragToResize,
            eventOrder: e.eventOrder,
            exclusiveEndDates: e.exclusiveEndDates,
            firstDay: e.firstDay,
            getDate: e.getDate,
            getDay: e.getDay,
            getMonth: e.getMonth,
            getYear: e.getYear,
            monthNames: e.monthNames,
            monthNamesShort: e.monthNamesShort,
            refDate: this._refDate,
            rtl: e.rtl,
            showEventTooltip: e.showEventTooltip,
            theme: e.theme,
            themeVariant: e.themeVariant,
            timeFormat: e.timeFormat,
            timezonePlugin: e.timezonePlugin
          },
          o = n({}, a, {
            allDayText: e.allDayText,
            colorsMap: this._colorsMap,
            dateFormatLong: e.dateFormatLong,
            dragTimeStep: e.dragTimeStep,
            eventMap: this._eventMap,
            extendDefaultEvent: e.extendDefaultEvent,
            externalDrop: e.externalDrop,
            groupBy: e.groupBy,
            height: t.height,
            invalidateEvent: e.invalidateEvent,
            invalidsMap: this._invalidsMap,
            maxDate: this._maxDate,
            minDate: this._minDate,
            newEventText: e.newEventText,
            onCellClick: this._onCellClick,
            onCellDoubleClick: this._onCellDoubleClick,
            onCellRightClick: this._onCellRightClick,
            onEventClick: this._onEventClick,
            onEventDelete: this._onEventDelete,
            onEventDoubleClick: this._onEventDoubleClick,
            onEventDragEnd: this._onEventDragEnd,
            onEventHoverIn: this._onEventHoverIn,
            onEventHoverOut: this._onEventHoverOut,
            onEventRightClick: this._onEventRightClick,
            renderEvent: e.renderScheduleEvent,
            renderEventContent: e.renderScheduleEventContent,
            renderResource: e.renderResource,
            resources: e.resources,
            scroll: this._shouldScrollSchedule,
            selected: this._selectedDateTime,
            width: t.width
          })
        return mt(
          Hi,
          n({ ref: this._setEl }, a, {
            activeDate: this._active,
            calendarScroll: this._calendarScroll,
            calendarType: this._calendarType,
            colors: e.colors,
            context: e.context,
            cssClass: this._cssClass,
            downIcon: e.downIcon,
            dragData: t.labelDragData,
            endDay: this._rangeEndDay,
            eventRange: this._rangeType,
            eventRangeSize: this._showSchedule
              ? this._scheduleSize
              : this._showTimeline
              ? this._timelineSize
              : this._eventListSize,
            hasContent:
              this._showEventList || this._showSchedule || this._showTimeline,
            hasPicker: !0,
            height: e.height,
            invalid: e.invalid,
            instanceService: this._instanceService,
            labels: e.labels,
            labelList: this._calendarLabelList,
            marked: e.marked,
            max: e.max,
            min: e.min,
            mouseSwipe:
              (!e.dragToCreate && "single" !== e.clickToCreate) ||
              (!this._showEventLabels && !this._showEventCount),
            mousewheel: e.mousewheel,
            nextIconH: e.nextIconH,
            nextIconV: e.nextIconV,
            noOuterChange: !this._showEventList,
            onActiveChange: this._onActiveChange,
            onCellHoverIn: this._onCellHoverIn,
            onCellHoverOut: this._onCellHoverOut,
            onDayClick: this._onDayClick,
            onDayDoubleClick: this._onDayDoubleClick,
            onDayRightClick: this._onDayRightClick,
            onGestureStart: this._onGestureStart,
            onLabelClick: this._onLabelClick,
            onLabelDoubleClick: this._onLabelDoubleClick,
            onLabelRightClick: this._onLabelRightClick,
            onLabelHoverIn: this._onLabelHoverIn,
            onLabelHoverOut: this._onLabelHoverOut,
            onLabelDelete: this._onEventDelete,
            onLabelUpdateStart: this._onLabelUpdateStart,
            onLabelUpdateMove: this._onLabelUpdateMove,
            onLabelUpdateEnd: this._onLabelUpdateEnd,
            onLabelUpdateModeOn: this._onLabelUpdateModeOn,
            onLabelUpdateModeOff: this._onLabelUpdateModeOff,
            onPageChange: this._onPageChange,
            onPageLoaded: this._onPageLoaded,
            onPageLoading: this._onPageLoading,
            onResize: this._onResize,
            pageLoad: this._pageLoad,
            prevIconH: e.prevIconH,
            prevIconV: e.prevIconV,
            resourcesMap: this._resourcesMap,
            responsiveStyle: !0,
            renderHeader: e.renderHeader,
            renderDay: e.renderDay,
            renderDayContent: e.renderDayContent,
            renderLabel: e.renderLabel,
            renderLabelContent: e.renderLabelContent,
            selectedDates: this._selectedDates,
            selectView: "month",
            showCalendar: this._showCalendar,
            showControls: e.showControls,
            showLabelCount: this._showEventCount,
            showOuterDays: this._showOuterDays,
            showSchedule: this._showSchedule || this._showTimeline,
            showToday: e.showToday,
            showWeekNumbers: this._showWeekNumbers,
            size: this._calendarSize,
            startDay: this._rangeStartDay,
            swipe: !t.isTouchDrag,
            upIcon: e.upIcon,
            valid: e.valid,
            weeks: this._calendarSize,
            width: e.width,
            getMaxDayOfMonth: e.getMaxDayOfMonth,
            getWeekNumber: e.getWeekNumber,
            eventText: e.eventText,
            eventsText: e.eventsText,
            moreEventsPluralText: e.moreEventsPluralText,
            moreEventsText: e.moreEventsText,
            todayText: e.todayText,
            yearSuffix: e.yearSuffix
          }),
          this._showDate &&
            !this._showScheduleDays &&
            mt(
              "div",
              {
                className:
                  "mbsc-schedule-date-header mbsc-flex" + this._theme + this._hb
              },
              this._showSchedule &&
                !this._showCalendar &&
                e.resources &&
                mt("div", { className: "mbsc-schedule-time-col" }),
              mt(
                "div",
                {
                  className:
                    "mbsc-schedule-date-header-text mbsc-flex-1-1" + this._theme
                },
                this._selectedDateHeader
              ),
              this._showSchedule &&
                !this._showCalendar &&
                e.resources &&
                mt("div", { className: "mbsc-schedule-fake-scroll-y" })
            ),
          this._showEventList &&
            mt(
              "div",
              {
                className:
                  "mbsc-event-list" +
                  (t.isListScrollable ? " mbsc-event-list-scroll" : ""),
                dangerouslySetInnerHTML: this._eventListHTML,
                onScroll: this._onScroll,
                ref: this._setList
              },
              i
            ),
          this._showSchedule &&
            mt(
              gs,
              n({}, o, {
                endDay: this._scheduleEndDay,
                endTime: this._scheduleEndTime,
                renderDay: e.renderDay,
                renderDayContent: e.renderDayContent,
                showAllDay: this._showScheduleAllDay,
                showDays: this._showScheduleDays,
                size: this._scheduleSize,
                startDay: this._scheduleStartDay,
                startTime: this._scheduleStartTime,
                timeCellStep: this._scheduleTimeCellStep,
                timeLabelStep: this._scheduleTimeLabelStep,
                type: this._scheduleType,
                onWeekDayClick: this._onWeekDayClick
              })
            ),
          this._showTimeline &&
            mt(
              ys,
              n({}, o, {
                dragToCreate: !e.slots && e.dragToCreate,
                dragToResize: !e.slots && e.dragToResize,
                downIcon: e.chevronIconDown,
                endDay: this._timelineEndDay,
                endTime: this._timelineEndTime,
                eventList: this._timelineListing,
                getWeekNumber: e.getWeekNumber,
                nextIcon: e.nextIconH,
                nextIconRtl: e.prevIconH,
                renderResourceHeader: e.renderResourceHeader,
                renderSlot: e.renderSlot,
                rowHeight: this._timelineRowHeight,
                weekNumbers: this._showTimelineWeekNumbers,
                weekText: e.weekText,
                size: this._timelineSize,
                slots: e.slots,
                startDay: this._timelineStartDay,
                startTime: this._timelineStartTime,
                timeCellStep: this._timelineTimeCellStep,
                timeLabelStep: this._timelineTimeLabelStep,
                type: this._timelineType
              })
            ),
          mt(
            gi,
            {
              anchor: this._anchor,
              closeOnScroll: !0,
              contentPadding: !1,
              context: e.context,
              cssClass: "mbsc-calendar-popup " + this._popoverClass,
              display: "anchored",
              isOpen: t.showPopover,
              locale: e.locale,
              maxHeight: "24em",
              onClose: this._onPopoverClose,
              rtl: e.rtl,
              scrollLock: !1,
              showOverlay: !1,
              theme: e.theme,
              themeVariant: e.themeVariant
            },
            t.popoverList &&
              mt(
                Pi,
                {
                  ref: this._setPopoverList,
                  theme: e.theme,
                  themeVariant: e.themeVariant,
                  rtl: e.rtl,
                  className: "mbsc-popover-list"
                },
                t.popoverList.map(function(n, i) {
                  return s._eventRenderer(n, i, t.popoverDate, e, !0)
                })
              )
          ),
          t.labelDragData &&
            t.labelDragData.draggedEvent &&
            !t.isTouchDrag &&
            mt("div", { className: "mbsc-calendar-dragging" })
        )
      }),
      i
    )
  })(is),
  Ds = {
    before: function(e, t) {
      t.selectedDate &&
        ((t.defaultSelectedDate = t.selectedDate), delete t.selectedDate)
    }
  },
  Cs = ((ii._selector = "[mbsc-calendar-next]"), ai),
  ws = ((ni._selector = "[mbsc-calendar-prev]"), ii),
  ks = ((si._selector = "[mbsc-calendar-today]"), ni),
  xs = ((ai._selector = "[mbsc-calendar-nav]"), si),
  Ts = /*#__PURE__*/ Ct(ws),
  Ss = /*#__PURE__*/ Ct(ks),
  Es = /*#__PURE__*/ Ct(xs),
  Ms = /*#__PURE__*/ Ct(Cs),
  Ls = {
    before: function(e, t) {
      t.element = e
    }
  },
  Ns = /*#__PURE__*/ (function(e) {
    function n() {
      return (null !== e && e.apply(this, arguments)) || this
    }
    return t(n, e), (n._selector = "[mbsc-draggable]"), (n._renderOpt = Ls), n
  })(
    /*#__PURE__*/ (function(e) {
      function n() {
        return (null !== e && e.apply(this, arguments)) || this
      }
      return (
        t(n, e),
        (n.prototype._template = function(e) {
          return e.children || ""
        }),
        n
      )
    })(Ai)
  ),
  Hs = /*#__PURE__*/ Ct(Ns, Ls),
  Os = /*#__PURE__*/ Ct(bs, Ds)
export {
  Cs as CalendarNav,
  ws as CalendarNext,
  ks as CalendarPrev,
  xs as CalendarToday,
  Ns as Draggable,
  bs as Eventcalendar,
  D as autoDetect,
  Ms as calendarNav,
  Ts as calendarNext,
  Ss as calendarPrev,
  Es as calendarToday,
  x as createCustomTheme,
  Hs as draggable,
  Dt as enhance,
  Os as eventcalendar,
  Dn as formatDate,
  w as getAutoTheme,
  yt as getInst,
  Fi as getJson,
  C as globalChanges,
  xt as hijriCalendar,
  Lt as jalaliCalendar,
  Ht as locale,
  Nt as localeEn,
  ji as luxonTimezone,
  Ji as momentTimezone,
  g as options,
  Cn as parseDate,
  T as platform,
  bt as registerComponent,
  k as setOptions,
  b as themes,
  y as util
}
